import "../../components/layout/Stack/Stack.js";
import { makeBox as o } from "../../components/layout/Box/Box.js";
import "styled-components";
import "react/jsx-runtime";
import * as a from "react";
import "../../index-CZ8zjHGv.js";
import "../../components/layout/Center/Center.js";
import "../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../components/layout/Columns/ColumnsContext.js";
var K5, J5;
function l() {
  return l = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l.apply(this, arguments);
}
var n7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", l({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), K5 || (K5 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#Alarm_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 5.625V10h4.375"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeMiterlimit: 10,
    d: "M10 16.875a6.875 6.875 0 1 0 0-13.75 6.875 6.875 0 0 0 0 13.75Z"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.305 2.047 2.648 2.648M2.047 4.695l2.648-2.648"
  }))), J5 || (J5 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Alarm_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, Y5, tt;
function s() {
  return s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s.apply(this, arguments);
}
var a7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", s({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 18"
  }, t), Y5 || (Y5 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "M15.29 2.51v-.1H7.624L5.994.926 5.967.9H-.1v14.006c0 1.16.815 2.154 1.846 2.185h.003l13.167.009h.001c.853 0 1.59-.666 1.807-1.595l-.098-.023.098.023L19.097 5.35l.03-.123H15.29zM7.2 3.907h6.773v1.32h-9.07l-.018.077L2.65 14.86c-.1.428-.416.712-.768.736h-.113c-.287-.016-.553-.317-.553-.69V2.397h4.287l1.63 1.485.028.026zm7.717 11.697-11.102-.007a3 3 0 0 0 .107-.352l1.994-8.522h11.498l-1.963 8.397.098.023-.098-.023c-.068.295-.295.484-.534.484Z"
  })), tt || (tt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "M6.977 14.398v.1h.1l6.836.01h.1v-.1l.001-1.49v-.1h-.1l-6.836-.01h-.1v.1z"
  })));
}, et;
function i() {
  return i = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i.apply(this, arguments);
}
var o7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", i({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), et || (et = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 3.125v13.75M4.375 11.25 10 16.875l5.625-5.625"
  })));
}, rt, nt;
function c() {
  return c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c.apply(this, arguments);
}
var l7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", c({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), rt || (rt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.5 10-3.75 3.75L7.5 17.5"
  })), nt || (nt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 2.5v11.25H3.75"
  })));
}, at, ot;
function v() {
  return v = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v.apply(this, arguments);
}
var s7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", v({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 128 128"
  }, t), at || (at = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M68 112V88H24a4 4 0 0 1-4-4V44a4 4 0 0 1 4-4h44V16l48 48z",
    opacity: 0.2
  })), ot || (ot = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m118.83 61.17-48-48A4 4 0 0 0 64 16v20H24a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h40v20a3.998 3.998 0 0 0 6.83 2.83l48-48a4 4 0 0 0 1.173-2.83 3.99 3.99 0 0 0-1.173-2.83M72 102.345V88a4 4 0 0 0-4-4H24V44h44a4 4 0 0 0 4-4V25.655L110.345 64z"
  })));
}, lt;
function h() {
  return h = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h.apply(this, arguments);
}
var i7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), lt || (lt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m28.707 14.293-12-12a1 1 0 0 0-1.415 0l-12 12A1 1 0 0 0 4 16h5v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V16h5a1.001 1.001 0 0 0 .707-1.707M22 14a1 1 0 0 0-1 1v11H11V15a1 1 0 0 0-1-1H6.414L16 4.414 25.586 14z"
  })));
}, st;
function p() {
  return p = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p.apply(this, arguments);
}
var c7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", p({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, t), st || (st = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.5 7a.625.625 0 0 1-.625.625H2.634l4.558 4.558a.626.626 0 0 1-.884.884L.683 7.442a.625.625 0 0 1 0-.884L6.308.933a.625.625 0 1 1 .884.884L2.634 6.375h12.241A.625.625 0 0 1 15.5 7"
  })));
}, it;
function u() {
  return u = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u.apply(this, arguments);
}
var v7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", u({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, t), it || (it = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.417 12h16.5M14.167 5.25l6.75 6.75-6.75 6.75"
  })));
}, ct;
function g() {
  return g = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, g.apply(this, arguments);
}
var h7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", g({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), ct || (ct = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m15.25 12.595-2.124 2.125a.53.53 0 0 1-.752 0l-2.125-2.125a.532.532 0 1 1 .752-.752l1.218 1.218v-3.81L8.5 5.532 4.781 9.251v3.81L6 11.843a.532.532 0 1 1 .752.752L4.626 14.72a.53.53 0 0 1-.752 0L1.75 12.595a.53.53 0 1 1 .752-.752l1.218 1.218v-4.03a.53.53 0 0 1 .155-.376L7.97 4.561V1.594a.531.531 0 1 1 1.062 0V4.56l4.095 4.094a.53.53 0 0 1 .155.376v4.03l1.218-1.218a.532.532 0 1 1 .752.752"
  })));
}, vt, ht;
function m() {
  return m = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m.apply(this, arguments);
}
var p7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", m({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), vt || (vt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.61 13.609c-.15.15-.414.255-.855.231s-1.002-.176-1.651-.468c-1.295-.583-2.844-1.677-4.322-3.154S4.21 7.193 3.628 5.898c-.292-.65-.445-1.21-.468-1.651s.081-.706.232-.856c.15-.151.413-.256.854-.232s1.001.176 1.65.468c1.296.584 2.845 1.678 4.323 3.155s2.571 3.025 3.154 4.32c.292.65.444 1.21.468 1.651s-.081.705-.232.856l.354.354z",
    opacity: 0.2
  })), ht || (ht = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.024 8.5c1.636-2.298 2.471-4.674 1.31-5.835-1.16-1.16-3.536-.326-5.834 1.311-2.298-1.637-4.674-2.471-5.835-1.31-1.16 1.16-.326 3.536 1.311 5.834-1.637 2.298-2.471 4.674-1.31 5.834.373.374.873.54 1.454.54 1.228 0 2.821-.74 4.383-1.85 1.556 1.11 3.15 1.85 4.38 1.85.581 0 1.082-.166 1.455-.54 1.157-1.16.322-3.536-1.314-5.834m.56-5.083c.507.507.164 2.151-1.23 4.202a20 20 0 0 0-1.408-1.565 20 20 0 0 0-1.565-1.406c2.05-1.394 3.695-1.74 4.202-1.231M11.706 8.5q-.706.892-1.512 1.695-.803.806-1.695 1.512-.893-.706-1.695-1.512A19 19 0 0 1 5.293 8.5 19.8 19.8 0 0 1 8.5 5.293q.892.706 1.695 1.512.806.802 1.512 1.695m-8.29-5.083c.146-.147.387-.223.705-.223.785 0 2.038.458 3.496 1.454q-.82.662-1.565 1.406-.743.745-1.405 1.565C3.254 5.569 2.91 3.924 3.417 3.417m0 10.166c-.508-.507-.163-2.151 1.231-4.202a20 20 0 0 0 2.97 2.97c-2.05 1.395-3.694 1.74-4.201 1.232m10.166 0c-.507.508-2.151.165-4.202-1.23a20 20 0 0 0 1.565-1.407q.744-.745 1.406-1.565c1.394 2.05 1.739 3.695 1.231 4.202M9.297 8.5a.797.797 0 1 1-1.594 0 .797.797 0 0 1 1.594 0"
  })));
}, pt, ut;
function f() {
  return f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, f.apply(this, arguments);
}
var u7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", f({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), pt || (pt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M14.375 8.5a5.876 5.876 0 1 1-11.751 0 5.876 5.876 0 0 1 11.751 0Z",
    opacity: 0.2
  })), ut || (ut = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M6.11 9.297a.797.797 0 1 1 0-1.594.797.797 0 0 1 0 1.594m4.78-1.594a.797.797 0 1 0 0 1.594.797.797 0 0 0 0-1.594m-.814 3.004a2.99 2.99 0 0 1-3.152 0 .531.531 0 1 0-.567.899 4.05 4.05 0 0 0 4.286 0 .532.532 0 1 0-.567-.9m5.33-2.207A6.906 6.906 0 1 1 8.5 1.594 6.913 6.913 0 0 1 15.406 8.5m-1.062 0A5.85 5.85 0 0 0 8.76 2.662c-.77 1.082-.791 2.111-.791 2.12a.531.531 0 1 0 1.062 0 .531.531 0 1 1 1.063 0 1.594 1.594 0 0 1-3.188 0c0-.05.009-.95.562-2.035A5.844 5.844 0 1 0 14.344 8.5"
  })));
}, gt;
function d() {
  return d = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d.apply(this, arguments);
}
var g7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", d({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, t), gt || (gt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.469 8.469h-.532V6.344a1.06 1.06 0 0 0-1.062-1.063h-1.062V4.75a1.06 1.06 0 0 0-1.063-1.062h-1.594a1.063 1.063 0 0 0-1.062 1.062v3.719H6.906V4.75a1.06 1.06 0 0 0-1.062-1.062H4.25A1.06 1.06 0 0 0 3.188 4.75v.531H2.125a1.06 1.06 0 0 0-1.062 1.063v2.125H.53a.531.531 0 1 0 0 1.062h.532v2.125a1.063 1.063 0 0 0 1.062 1.063h1.063v.531a1.063 1.063 0 0 0 1.062 1.063h1.594a1.06 1.06 0 0 0 1.062-1.063V9.531h3.188v3.719a1.063 1.063 0 0 0 1.062 1.063h1.594a1.06 1.06 0 0 0 1.063-1.063v-.531h1.062a1.063 1.063 0 0 0 1.063-1.063V9.531h.53a.531.531 0 0 0 0-1.062M2.125 11.656V6.344h1.063v5.312zm3.719 1.594H4.25v-8.5h1.594zm6.906 0h-1.594v-8.5h1.594v8.5m2.125-1.594h-1.062V6.344h1.062z"
  })));
}, mt, ft;
function w() {
  return w = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w.apply(this, arguments);
}
var m7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", w({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), mt || (mt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M15.438 7.438v3.218H7.406V5.812h6.407a1.625 1.625 0 0 1 1.624 1.625Z",
    opacity: 0.2
  })), ft || (ft = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.813 4.781H1.592V3.188a.531.531 0 1 0-1.062 0v10.625a.531.531 0 0 0 1.063 0v-2.126h13.812v2.126a.532.532 0 0 0 1.063 0V7.437a2.656 2.656 0 0 0-2.657-2.656M1.592 5.844h4.782v4.781H1.594zm5.845 4.781V5.844h6.375a1.594 1.594 0 0 1 1.593 1.593v3.188z"
  })));
}, dt, wt;
function _() {
  return _ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _.apply(this, arguments);
}
var f7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", _({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 180 180"
  }, t), dt || (dt = /* @__PURE__ */ a.createElement("path", {
    d: "M146.25 135H33.75a5.627 5.627 0 0 1-4.837-8.438c4.633-8.015 10.462-22.633 10.462-47.812a50.625 50.625 0 1 1 101.25 0c0 25.186 5.836 39.797 10.477 47.812a5.64 5.64 0 0 1 .005 5.617A5.624 5.624 0 0 1 146.25 135",
    opacity: 0.2
  })), wt || (wt = /* @__PURE__ */ a.createElement("path", {
    d: "M118.125 157.5a5.626 5.626 0 0 1-5.625 5.625h-45a5.626 5.626 0 0 1 0-11.25h45c1.492 0 2.923.593 3.977 1.648a5.62 5.62 0 0 1 1.648 3.977m41.759-115.087a78.3 78.3 0 0 0-27.507-30.291 5.62 5.62 0 0 0-6.267.142 5.626 5.626 0 0 0-1.342 7.863c.43.603.976 1.116 1.605 1.508a66.2 66.2 0 0 1 23.526 25.952 5.63 5.63 0 0 0 7.51 2.27 5.625 5.625 0 0 0 2.475-7.444M25.109 50.625a5.63 5.63 0 0 0 4.992-3.038 66.2 66.2 0 0 1 23.526-25.952 5.626 5.626 0 0 0-3.952-10.312c-.73.128-1.428.4-2.052.799a78.3 78.3 0 0 0-27.507 30.29 5.626 5.626 0 0 0 4.993 8.213m130.851 73.083a11.247 11.247 0 0 1-4.077 15.401 11.25 11.25 0 0 1-5.633 1.516H33.75a11.25 11.25 0 0 1-9.696-16.917c6.335-10.934 9.696-26.48 9.696-44.958a56.25 56.25 0 1 1 112.5 0c0 18.471 3.361 34.017 9.71 44.958m-9.71 5.667C138.769 116.529 135 99.499 135 78.75a45 45 0 0 0-90 0c0 20.756-3.783 37.786-11.25 50.625z"
  })));
}, _t, bt, Ot, jt, Et, Mt;
function b() {
  return b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b.apply(this, arguments);
}
var d7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", b({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, t), _t || (_t = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.813 6.25a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875"
  })), bt || (bt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.12,
    d: "M13.813 6.25a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875"
  })), Ot || (Ot = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.375 10.625-3.125 3.75"
  })), jt || (jt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m10.375 10.625-3.125 3.75"
  })), Et || (Et = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.25 7.5v1.875a7.5 7.5 0 0 1-7.5 7.5H1.625l7.5-9.375V5.938a4.063 4.063 0 0 1 7.995-1.025l2.005 1.337z"
  })), Mt || (Mt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M17.25 7.5v1.875a7.5 7.5 0 0 1-7.5 7.5H1.625l7.5-9.375V5.938a4.063 4.063 0 0 1 7.995-1.025l2.005 1.337z"
  })));
}, xt, Ct;
function O() {
  return O = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O.apply(this, arguments);
}
var w7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", O({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), xt || (xt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M14.571 6.473a1.36 1.36 0 0 0 .169-1.552l.438-.241-.438.24a1.36 1.36 0 0 0-1.402-.686l-.678.107.106-.678a1.36 1.36 0 0 0-.405-1.193l.345-.362-.345.362a1.36 1.36 0 0 0-2.093 1.7 1.03 1.03 0 0 1-.14 1.286l-4.674 4.673-.353-.353a.53.53 0 0 1-.664.07 1.86 1.86 0 0 0-2.33 2.862M14.57 6.473l-7.7 5.073a1.03 1.03 0 0 0-.14 1.285 1.36 1.36 0 0 1-2.094 1.7l-.345.362.345-.362a1.36 1.36 0 0 1-.404-1.193l.105-.676-.676.105a1.36 1.36 0 0 1-1.193-.404l-.362.345M14.57 6.473a1.36 1.36 0 0 1-1.742.26m1.742-.26-1.742.26M2.107 12.707l.362-.345a1.36 1.36 0 0 1 1.7-2.094zm10.722-5.976a1.03 1.03 0 0 0-1.285.14zm-1.285.14-4.673 4.674z",
    opacity: 0.2
  })), Ct || (Ct = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.385 4.043a2.38 2.38 0 0 0-1.582-.846A2.39 2.39 0 1 0 9.396 4.72v.006l-4.67 4.672H4.72a2.39 2.39 0 1 0-1.522 4.407 2.39 2.39 0 1 0 4.407-1.522v-.005l4.672-4.672h.007a2.39 2.39 0 0 0 3.103-3.562zm-.835 2.409a1.33 1.33 0 0 1-1.705.252 1.06 1.06 0 0 0-1.32.146L6.85 11.525a1.06 1.06 0 0 0-.143 1.32 1.328 1.328 0 1 1-2.44.498.53.53 0 0 0-.607-.607 1.33 1.33 0 1 1 .495-2.443 1.06 1.06 0 0 0 1.32-.146l4.676-4.675a1.06 1.06 0 0 0 .142-1.317 1.328 1.328 0 1 1 2.44-.498.53.53 0 0 0 .608.607 1.328 1.328 0 0 1 1.206 2.191z"
  })));
}, $t, Lt, kt, St;
function j() {
  return j = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, j.apply(this, arguments);
}
var _7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", j({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), $t || ($t = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.75 16.875A1.875 1.875 0 0 1 5.625 15H16.25V2.5H5.625A1.875 1.875 0 0 0 3.75 4.375z"
  })), Lt || (Lt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M3.75 16.875A1.875 1.875 0 0 1 5.625 15H16.25V2.5H5.625A1.875 1.875 0 0 0 3.75 4.375z"
  })), kt || (kt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.75 16.875v.625H15"
  })), St || (St = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M3.75 16.875v.625H15"
  })));
}, yt, Ht;
function E() {
  return E = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, E.apply(this, arguments);
}
var b7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", E({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, t), yt || (yt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M32.5 5v25H11.25a3.75 3.75 0 0 0-3.75 3.75v-25A3.75 3.75 0 0 1 11.25 5z",
    opacity: 0.2
  })), Ht || (Ht = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M32.5 3.75H11.25a5 5 0 0 0-5 5V35a1.25 1.25 0 0 0 1.25 1.25H30a1.25 1.25 0 0 0 0-2.5H8.75a2.5 2.5 0 0 1 2.5-2.5H32.5A1.25 1.25 0 0 0 33.75 30V5a1.25 1.25 0 0 0-1.25-1.25m-1.25 25h-20a5 5 0 0 0-2.5.67V8.75a2.5 2.5 0 0 1 2.5-2.5h20z"
  })));
}, Pt;
function M() {
  return M = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, M.apply(this, arguments);
}
var O7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", M({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 29"
  }, t), Pt || (Pt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M24.5 5.75h-7A4.38 4.38 0 0 0 14 7.5a4.38 4.38 0 0 0-3.5-1.75h-7A1.75 1.75 0 0 0 1.75 7.5v14a1.75 1.75 0 0 0 1.75 1.75h7a2.625 2.625 0 0 1 2.625 2.625.875.875 0 1 0 1.75 0A2.625 2.625 0 0 1 17.5 23.25h7a1.75 1.75 0 0 0 1.75-1.75v-14a1.75 1.75 0 0 0-1.75-1.75m-14 15.75h-7v-14h7a2.625 2.625 0 0 1 2.625 2.625v12.25A4.35 4.35 0 0 0 10.5 21.5m14 0h-7a4.35 4.35 0 0 0-2.625.875v-12.25A2.625 2.625 0 0 1 17.5 7.5h7zm-7-11.375h4.375a.875.875 0 1 1 0 1.75H17.5a.875.875 0 1 1 0-1.75m5.25 4.375a.875.875 0 0 1-.875.875H17.5a.875.875 0 1 1 0-1.75h4.375a.875.875 0 0 1 .875.875m0 3.5a.875.875 0 0 1-.875.875H17.5a.875.875 0 1 1 0-1.75h4.375a.875.875 0 0 1 .875.875"
  })));
}, zt, Vt;
function x() {
  return x = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x.apply(this, arguments);
}
var j7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", x({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, t), zt || (zt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M21.75 6.8v12a.75.75 0 0 1-.75.75h-6a3 3 0 0 0-3 3V9.05a3 3 0 0 1 3-3h6a.75.75 0 0 1 .75.75",
    opacity: 0.2
  })), Vt || (Vt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M21 5.3h-6a3.75 3.75 0 0 0-3 1.5 3.75 3.75 0 0 0-3-1.5H3a1.5 1.5 0 0 0-1.5 1.5v12A1.5 1.5 0 0 0 3 20.3h6a2.25 2.25 0 0 1 2.25 2.25.75.75 0 1 0 1.5 0A2.25 2.25 0 0 1 15 20.3h6a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 21 5.3M9 18.8H3v-12h6a2.25 2.25 0 0 1 2.25 2.25v10.5A3.73 3.73 0 0 0 9 18.8m12 0h-6a3.73 3.73 0 0 0-2.25.75V9.05A2.25 2.25 0 0 1 15 6.8h6zm-6-9.75h3.75a.75.75 0 1 1 0 1.5H15a.75.75 0 1 1 0-1.5m4.5 3.75a.75.75 0 0 1-.75.75H15a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .75.75m0 3a.75.75 0 0 1-.75.75H15a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .75.75"
  })));
}, Bt, Wt, At, Rt;
function C() {
  return C = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C.apply(this, arguments);
}
var E7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", C({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Bt || (Bt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.125 17.5 8.75 14.375 4.375 17.5V5.625A.625.625 0 0 1 5 5h7.5a.625.625 0 0 1 .625.625z"
  })), Wt || (Wt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M13.125 17.5 8.75 14.375 4.375 17.5V5.625A.625.625 0 0 1 5 5h7.5a.625.625 0 0 1 .625.625z"
  })), At || (At = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.875 2.5H15a.625.625 0 0 1 .625.625V15"
  })), Rt || (Rt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M6.875 2.5H15a.625.625 0 0 1 .625.625V15"
  })));
}, Ft;
function $() {
  return $ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $.apply(this, arguments);
}
var M7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", $({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Ft || (Ft = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.25 3.125h-2.5a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h2.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625M3.125 6.25h3.75M10 3.125H7.5a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625H10c.345 0 .625-.28.625-.625V3.75A.625.625 0 0 0 10 3.125M6.875 13.75h3.75M13.647 2.925l-2.415.647a.625.625 0 0 0-.442.766l3.235 12.074c.09.333.432.53.766.442l2.415-.647a.625.625 0 0 0 .442-.766L14.412 3.367a.625.625 0 0 0-.765-.442M13.378 13.997l3.622-.97M11.437 6.752l3.622-.97"
  })));
}, qt;
function L() {
  return L = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L.apply(this, arguments);
}
var x7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", L({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, t), qt || (qt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m32.576 27.358-4.668-22.19a2.247 2.247 0 0 0-2.671-1.743L18.654 4.84a2.26 2.26 0 0 0-1.73 2.672l4.668 22.19a2.25 2.25 0 0 0 2.671 1.747l6.583-1.415a2.263 2.263 0 0 0 1.73-2.676M19.125 7.052V7.04l6.581-1.406.468 2.232-6.58 1.416zm1.406 6.663-.47-2.236 6.583-1.415.47 2.236zm9.844 14.12-6.581 1.406-.468-2.231 6.58-1.417.469 2.23zM14.625 4.5h-6.75a2.25 2.25 0 0 0-2.25 2.25v22.5a2.25 2.25 0 0 0 2.25 2.25h6.75a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25m-6.75 2.25h6.75V9h-6.75zm6.75 22.5h-6.75V27h6.75z"
  })));
}, Zt, Dt, Tt, Gt;
function k() {
  return k = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k.apply(this, arguments);
}
var C7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", k({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Zt || (Zt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 13.75v-7.5M6.875 11.25a3.125 3.125 0 1 1-3.125 3.125v-.526"
  })), Dt || (Dt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.125 11.25a3.125 3.125 0 1 0 3.125 3.125v-.526"
  })), Tt || (Tt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.625 14.063H5a3.75 3.75 0 0 1-1.25-7.287V5.625a3.125 3.125 0 0 1 6.25 0v8.75M14.375 14.063H15a3.75 3.75 0 0 0 1.25-7.287V5.625a3.125 3.125 0 1 0-6.25 0"
  })), Gt || (Gt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.875 6.563v.625a2.19 2.19 0 0 1-2.187 2.187M13.125 6.563v.625a2.19 2.19 0 0 0 2.188 2.187"
  })));
}, Ut, Nt;
function S() {
  return S = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, S.apply(this, arguments);
}
var $7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", S({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Ut || (Ut = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M8.5 10.062a13.2 13.2 0 0 0 5.875-1.37v4.59a.03.03 0 0 1-.031.03H2.656a.031.031 0 0 1-.031-.031v-4.59A13.2 13.2 0 0 0 8.5 10.063Zm0 0v-.5.5Z",
    opacity: 0.2
  })), Nt || (Nt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M6.906 7.438a.53.53 0 0 1 .532-.532h2.125a.531.531 0 1 1 0 1.063H7.437a.53.53 0 0 1-.53-.532m8.5-2.657v8.5a1.063 1.063 0 0 1-1.062 1.063H2.656a1.063 1.063 0 0 1-1.062-1.063v-8.5A1.06 1.06 0 0 1 2.656 3.72h2.657v-.531a1.594 1.594 0 0 1 1.593-1.594h3.188a1.594 1.594 0 0 1 1.594 1.594v.53h2.656a1.063 1.063 0 0 1 1.062 1.063M6.375 3.72h4.25v-.531a.53.53 0 0 0-.531-.532H6.906a.53.53 0 0 0-.531.531zM2.656 4.78v2.764a12.22 12.22 0 0 0 11.688 0V4.78zm11.688 8.5v-4.54a13.3 13.3 0 0 1-11.688 0v4.54z"
  })));
}, Xt, It;
function y() {
  return y = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y.apply(this, arguments);
}
var L7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", y({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Xt || (Xt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M8.531 2.126v11.718H3.156V5.668a.03.03 0 0 1 .014-.027l5.312-3.54V2.1a.03.03 0 0 1 .045.01l.425-.256-.425.256q.004.007.004.016Z",
    opacity: 0.2
  })), It || (It = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.938 13.813h-1.063V6.375a1.06 1.06 0 0 0-1.062-1.063h-4.25V2.125A1.063 1.063 0 0 0 7.91 1.24L2.598 4.781a1.06 1.06 0 0 0-.473.886v8.146H1.063a.53.53 0 1 0 0 1.062h14.875a.532.532 0 0 0 0-1.062m-2.126-7.438v7.438h-4.25V6.375zM3.188 5.667 8.5 2.125v11.688H3.188zm4.25 1.77V8.5a.531.531 0 0 1-1.063 0V7.437a.531.531 0 1 1 1.063 0m-2.125 0V8.5a.531.531 0 0 1-1.063 0V7.437a.531.531 0 1 1 1.063 0m0 3.72v1.062a.531.531 0 0 1-1.063 0v-1.063a.531.531 0 1 1 1.063 0m2.125 0v1.062a.531.531 0 0 1-1.063 0v-1.063a.531.531 0 1 1 1.063 0"
  })));
}, Qt;
function H() {
  return H = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H.apply(this, arguments);
}
var k7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", H({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Qt || (Qt = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.625 1.875H4.375a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25V3.125a1.25 1.25 0 0 0-1.25-1.25m-8.75 13.75a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.875m0-3.126a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875M10 15.624a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m0-3.125a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m3.125 3.125a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874m0-3.125a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874m1.25-4.375a.625.625 0 0 1-.625.625h-7.5a.625.625 0 0 1-.625-.625V5a.625.625 0 0 1 .625-.625h7.5a.625.625 0 0 1 .625.625z"
  })));
}, Kt;
function P() {
  return P = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P.apply(this, arguments);
}
var S7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", P({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Kt || (Kt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 3.125H3.75a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625M13.75 1.875v2.5M6.25 1.875v2.5M3.125 6.875h13.75"
  })));
}, Jt, Yt;
function z() {
  return z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z.apply(this, arguments);
}
var y7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", z({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Jt || (Jt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 3.125H3.75a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625M13.75 1.875v2.5M6.25 1.875v2.5M3.125 6.875h13.75"
  })), Yt || (Yt = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.812 10-3.646 3.437-1.979-1.875"
  })));
}, te, ee;
function V() {
  return V = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V.apply(this, arguments);
}
var H7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", V({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, t), te || (te = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.5 7.8-5 5-5-5"
  })), ee || (ee = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.5 3-5 5-5-5"
  })));
}, re, ne;
function B() {
  return B = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B.apply(this, arguments);
}
var P7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", B({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, t), re || (re = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.5 8.2 5-5 5 5"
  })), ne || (ne = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.5 13 5-5 5 5"
  })));
}, ae;
function W() {
  return W = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W.apply(this, arguments);
}
var z7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", W({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 17"
  }, t), ae || (ae = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m9.03 8.832-7.5 7.5A.75.75 0 1 1 .47 15.27L7.44 8.3.47 1.331A.75.75 0 1 1 1.53.272l7.5 7.5a.75.75 0 0 1 0 1.06"
  })));
}, oe, le;
function A() {
  return A = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A.apply(this, arguments);
}
var V7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", A({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, t), oe || (oe = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M27.5 17.5 11.616 33.384a1.25 1.25 0 0 1-1.768 0l-3.232-3.228a1.25 1.25 0 0 1 0-1.767L22.5 12.5z",
    opacity: 0.2
  })), le || (le = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M38.75 23.75A1.25 1.25 0 0 1 37.5 25H35v2.5a1.25 1.25 0 0 1-2.5 0V25H30a1.25 1.25 0 0 1 0-2.5h2.5V20a1.25 1.25 0 0 1 2.5 0v2.5h2.5a1.25 1.25 0 0 1 1.25 1.25m-30-12.5h2.5v2.5a1.25 1.25 0 0 0 2.5 0v-2.5h2.5a1.25 1.25 0 0 0 0-2.5h-2.5v-2.5a1.25 1.25 0 0 0-2.5 0v2.5h-2.5a1.25 1.25 0 1 0 0 2.5m20 18.75H27.5v-1.25a1.25 1.25 0 0 0-2.5 0V30h-1.25a1.25 1.25 0 0 0 0 2.5H25v1.25a1.25 1.25 0 0 0 2.5 0V32.5h1.25a1.25 1.25 0 0 0 0-2.5m5.517-17.5L12.5 34.267a2.5 2.5 0 0 1-3.534 0L5.73 31.036a2.5 2.5 0 0 1 0-3.536L27.5 5.733a2.5 2.5 0 0 1 3.536 0l3.231 3.231a2.5 2.5 0 0 1 0 3.536m-8.536 5L22.5 14.267l-15 15 3.231 3.233zm6.769-6.767L29.267 7.5l-5 5 3.233 3.233z"
  })));
}, se, ie;
function R() {
  return R = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R.apply(this, arguments);
}
var B7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", R({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), se || (se = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#ChalkStickDocument_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M24.19 10.25h-4.44V5.81z",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25 28H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12l7 7v16a1 1 0 0 1-1 1"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 4v7h7"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m10.78 22.2 4.98-4.981.741.74-4.98 4.981zm.953.952Z",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.814 18.86v2.701M18.463 20.21h2.702M12.158 13.906v2.702M10.807 15.258h2.702M17.111 22.012v1.801M16.21 22.913h1.802M15.76 16.158l1.802 1.801M17.88 14.039l-7.842 7.842a.45.45 0 0 0 0 .637l1.164 1.164a.45.45 0 0 0 .637 0l7.842-7.842a.45.45 0 0 0 0-.637l-1.164-1.164a.45.45 0 0 0-.637 0"
  }))), ie || (ie = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "ChalkStickDocument_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}, ce, ve;
function F() {
  return F = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F.apply(this, arguments);
}
var W7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", F({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), ce || (ce = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#ChalkboardTeacher_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M8.125 13.75a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M4.172 16.25a4.375 4.375 0 0 1 7.906 0h4.797a.624.624 0 0 0 .625-.625V4.375a.625.625 0 0 0-.625-.625H3.125a.625.625 0 0 0-.625.625v11.25a.625.625 0 0 0 .625.625z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M13.75 13.75H15v-7.5H5V7.5"
  }))), ve || (ve = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "ChalkboardTeacher_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
}, he, pe, ue, ge, me, fe, de, we;
function q() {
  return q = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, q.apply(this, arguments);
}
var A7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", q({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), he || (he = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.438 16.25v-5.625h4.374"
  })), pe || (pe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M3.438 16.25v-5.625h4.374"
  })), ue || (ue = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.813 16.25H2.188"
  })), ge || (ge = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M17.813 16.25H2.188"
  })), me || (me = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.813 16.25V6.875h4.375"
  })), fe || (fe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M7.813 16.25V6.875h4.375"
  })), de || (de = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.563 3.125h-4.375V16.25h4.374z"
  })), we || (we = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.563 3.125h-4.375V16.25h4.374z"
  })));
}, _e, be;
function Z() {
  return Z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z.apply(this, arguments);
}
var R7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Z({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, t), _e || (_e = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M35.8 8.75V32.5h-30v-25h28.75a1.25 1.25 0 0 1 1.25 1.25",
    opacity: 0.2
  })), be || (be = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M37.05 32.5a1.25 1.25 0 0 1-1.25 1.25h-30a1.25 1.25 0 0 1-1.25-1.25v-25a1.25 1.25 0 0 1 2.5 0v16.983l7.865-7.867a1.25 1.25 0 0 1 1.77 0l4.115 4.117 8.233-8.233H25.8a1.25 1.25 0 0 1 0-2.5h6.25a1.25 1.25 0 0 1 1.25 1.25v6.25a1.25 1.25 0 0 1-2.5 0v-3.233l-9.116 9.117a1.25 1.25 0 0 1-1.769 0L15.8 19.267l-8.75 8.75v3.233H35.8a1.25 1.25 0 0 1 1.25 1.25"
  })));
}, Oe;
function D() {
  return D = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D.apply(this, arguments);
}
var F7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", D({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Oe || (Oe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.259 14.593a8.996 8.996 0 1 1 3.147 3.148h0l-3.108.888a.75.75 0 0 1-.927-.927z"
  })));
}, je, Ee;
function T() {
  return T = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T.apply(this, arguments);
}
var q7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", T({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), je || (je = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m5.363 13.474.195.112A5.875 5.875 0 0 0 14.375 8.5zm0 0-.213.07m.213-.07-.213.07m0 0-2.483.829a.03.03 0 0 1-.017 0 .03.03 0 0 1-.024-.023.03.03 0 0 1 .001-.017l.828-2.483.072-.213m1.623 1.908-1.623-1.908m0 0-.113-.195m.113.195-.113-.195m0 0a5.9 5.9 0 0 1-.776-2.553m.776 2.553-.776-2.553m0 0c-.06-.9.089-1.8.433-2.633m-.433 2.633.433-2.633m0 0a5.9 5.9 0 0 1 1.553-2.17m-1.553 2.17 1.553-2.17m0 0a5.9 5.9 0 0 1 2.353-1.259m-2.353 1.26 2.353-1.26m0 0a5.9 5.9 0 0 1 2.667-.088m-2.667.088 2.667-.088m0 0a5.9 5.9 0 0 1 2.431 1.1m-2.43-1.1 2.43 1.1m0 0a5.9 5.9 0 0 1 1.693 2.063m-1.693-2.063 1.693 2.063m0 0c.4.808.607 1.697.607 2.598z",
    opacity: 0.2
  })), Ee || (Ee = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.5 1.594a6.906 6.906 0 0 0-6.098 10.152l-.754 2.261a1.062 1.062 0 0 0 1.344 1.344l2.262-.754A6.906 6.906 0 1 0 8.5 1.594m0 12.75a5.84 5.84 0 0 1-2.926-.784.53.53 0 0 0-.434-.044l-2.484.828.828-2.484a.53.53 0 0 0-.044-.434 5.844 5.844 0 1 1 5.06 2.918m2.656-6.906a.53.53 0 0 1-.531.53h-4.25a.531.531 0 0 1 0-1.062h4.25a.53.53 0 0 1 .53.532m0 2.125a.53.53 0 0 1-.531.53h-4.25a.531.531 0 0 1 0-1.062h4.25a.53.53 0 0 1 .53.531"
  })));
}, Me, xe, Ce, $e;
function G() {
  return G = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G.apply(this, arguments);
}
var Z7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", G({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Me || (Me = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.662 10.996a5.623 5.623 0 1 1 1.967 1.967h0l-1.943.555a.47.47 0 0 1-.58-.58z"
  })), xe || (xe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M2.662 10.996a5.623 5.623 0 1 1 1.967 1.967h0l-1.943.555a.47.47 0 0 1-.58-.58z"
  })), Ce || (Ce = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.192 13.742a5.628 5.628 0 0 0 8.179 2.971h0l1.943.555a.468.468 0 0 0 .58-.58l-.556-1.942h0a5.626 5.626 0 0 0-4.53-8.488"
  })), $e || ($e = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M7.192 13.742a5.628 5.628 0 0 0 8.179 2.971h0l1.943.555a.468.468 0 0 0 .58-.58l-.556-1.942h0a5.626 5.626 0 0 0-4.53-8.488"
  })));
}, Le, ke;
function U() {
  return U = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U.apply(this, arguments);
}
var D7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", U({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, t), Le || (Le = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.209 16.25 18.042 25l-4.584-4.375"
  })), ke || (ke = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.834 6.25h-25c-.69 0-1.25.56-1.25 1.25v25c0 .69.56 1.25 1.25 1.25h25c.69 0 1.25-.56 1.25-1.25v-25c0-.69-.56-1.25-1.25-1.25"
  })));
}, Se;
function N() {
  return N = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N.apply(this, arguments);
}
var T7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 9"
  }, t), Se || (Se = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.25 1.5 7 7.75.75 1.5"
  })));
}, ye;
function X() {
  return X = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X.apply(this, arguments);
}
var G7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", X({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 14"
  }, t), ye || (ye = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 13.25 1.25 7 7.5.75"
  })));
}, He;
function I() {
  return I = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, I.apply(this, arguments);
}
var U7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", I({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 14"
  }, t), He || (He = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.5.75 7.75 7 1.5 13.25"
  })));
}, Pe;
function Q() {
  return Q = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Q.apply(this, arguments);
}
var N7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Q({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 9"
  }, t), Pe || (Pe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 7.5 7 1.25l6.25 6.25"
  })));
}, ze, Ve;
function K() {
  return K = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K.apply(this, arguments);
}
var X7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), ze || (ze = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m12.719 9.383 1.656.994v3.467h-1.656zm-8.438 0v4.46H2.625v-3.466z",
    opacity: 0.2
  })), Ve || (Ve = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.149 9.638 12.75 8.2V6.906a.53.53 0 0 0-.266-.465L9.031 4.473V3.188h1.063a.531.531 0 0 0 0-1.063H9.03V1.063a.531.531 0 1 0-1.062 0v1.062H6.906a.531.531 0 1 0 0 1.063H7.97v1.285L4.516 6.445a.53.53 0 0 0-.266.465v1.293L1.851 9.638a.53.53 0 0 0-.257.456v4.25a.53.53 0 0 0 .531.531h5.313a.53.53 0 0 0 .53-.531v-3.188a.531.531 0 0 1 1.063 0v3.188a.53.53 0 0 0 .531.531h5.313a.53.53 0 0 0 .531-.531v-4.25a.53.53 0 0 0-.257-.456m-12.493.757 1.594-.957v4.374H2.656zM8.5 9.563a1.594 1.594 0 0 0-1.594 1.593v2.656H5.313V7.215L8.5 5.393l3.188 1.821v6.599h-1.594v-2.657A1.594 1.594 0 0 0 8.5 9.562m5.844 4.25H12.75V9.438l1.594.957z"
  })));
}, Be;
function J() {
  return J = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J.apply(this, arguments);
}
var I7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", J({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Be || (Be = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.754 8.059a7.47 7.47 0 0 1 1.943-3.362M4.696 15.304a7.47 7.47 0 0 1-1.94-3.363M11.941 17.246a7.47 7.47 0 0 1-3.882-.002M17.246 11.941a7.47 7.47 0 0 1-1.943 3.362M15.304 4.696a7.47 7.47 0 0 1 1.94 3.363M8.059 2.754a7.47 7.47 0 0 1 3.882.001"
  })));
}, We, Ae;
function Y() {
  return Y = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y.apply(this, arguments);
}
var Q7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Y({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), We || (We = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.255 15.745c-.72-.719-.242-2.228-.608-3.113-.38-.917-1.772-1.655-1.772-2.632s1.392-1.715 1.772-2.632c.366-.885-.111-2.394.608-3.113.719-.72 2.228-.242 3.113-.608.917-.38 1.655-1.772 2.632-1.772s1.715 1.392 2.632 1.772c.885.366 2.394-.111 3.113.608.72.719.242 2.228.608 3.113.38.917 1.772 1.655 1.772 2.632s-1.392 1.715-1.772 2.632c-.366.885.111 2.394-.608 3.113-.719.72-2.228.242-3.113.608-.917.38-1.655 1.772-2.632 1.772s-1.715-1.392-2.632-1.772c-.885-.366-2.394.111-3.113-.608"
  })), Ae || (Ae = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.438 8.125 8.854 12.5l-2.291-2.187"
  })));
}, Re;
function t1() {
  return t1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t1.apply(this, arguments);
}
var K7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", t1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 15"
  }, t), Re || (Re = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M11.25 4.453c0-.51-.161-1.008-.463-1.432a2.7 2.7 0 0 0-1.235-.95 2.9 2.9 0 0 0-1.588-.146c-.534.099-1.024.345-1.409.705-.384.36-.646.82-.752 1.32s-.052 1.019.156 1.49c.208.47.561.873 1.013 1.157.452.283.984.434 1.528.434.73 0 1.428-.272 1.944-.756a2.5 2.5 0 0 0 .806-1.822M8.5 6.093c-.346 0-.684-.095-.972-.276a1.67 1.67 0 0 1-.645-.736c-.132-.3-.167-.63-.1-.948.068-.318.235-.61.48-.84.244-.23.556-.386.896-.449s.69-.03 1.01.093c.32.125.594.335.786.605s.295.587.295.911c0 .435-.184.853-.513 1.16a1.8 1.8 0 0 1-1.237.48M12.25 7.5c-.544 0-1.076.151-1.528.434A2.6 2.6 0 0 0 9.71 9.092c-.208.47-.262.989-.156 1.49.106.5.368.959.752 1.32.385.36.875.605 1.409.705a2.9 2.9 0 0 0 1.588-.147 2.7 2.7 0 0 0 1.235-.95c.302-.424.463-.922.463-1.432 0-.683-.29-1.339-.806-1.822A2.85 2.85 0 0 0 12.25 7.5m0 4.219c-.346 0-.684-.096-.972-.277a1.67 1.67 0 0 1-.645-.736c-.132-.3-.167-.63-.1-.948.068-.318.235-.61.48-.84.244-.23.556-.386.896-.449s.69-.03 1.01.093c.32.125.594.335.786.605s.295.587.295.911c0 .435-.184.853-.513 1.16a1.8 1.8 0 0 1-1.237.48M4.75 7.5c-.544 0-1.076.151-1.528.434A2.62 2.62 0 0 0 2.21 9.092c-.208.47-.262.989-.156 1.49.106.5.368.959.752 1.32.385.36.875.605 1.408.705a2.9 2.9 0 0 0 1.59-.147 2.7 2.7 0 0 0 1.234-.95c.302-.424.463-.922.463-1.432 0-.683-.29-1.339-.806-1.822A2.85 2.85 0 0 0 4.75 7.5m0 4.219c-.346 0-.684-.096-.972-.277a1.67 1.67 0 0 1-.645-.736c-.132-.3-.167-.63-.1-.948.068-.318.235-.61.48-.84.244-.23.556-.386.896-.449s.69-.03 1.01.093c.32.125.594.335.786.605s.295.587.295.911c0 .435-.184.853-.513 1.16a1.8 1.8 0 0 1-1.237.48"
  })));
}, Fe, qe;
function e1() {
  return e1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, e1.apply(this, arguments);
}
var J7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", e1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Fe || (Fe = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m3.165 13.835-.351.351.351-.351a.03.03 0 0 1-.009-.023V3.188a.03.03 0 0 1 .031-.032h10.626q.013 0 .022.01l.351-.352-.351.351q.008.01.009.022v10.626a.03.03 0 0 1-.01.022l.354.353-.353-.353a.03.03 0 0 1-.023.009H3.188a.03.03 0 0 1-.023-.01Zm1.235-2.08.452-.188-.452.187a1.563 1.563 0 1 0 2.887-1.196A1.563 1.563 0 0 0 4.4 11.754Zm7.354-6.292-.191.462.191-.462a1.563 1.563 0 1 0-1.196 2.887 1.563 1.563 0 0 0 1.196-2.887Z",
    opacity: 0.2
  })), qe || (qe = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.813 2.125H3.188a1.06 1.06 0 0 0-1.063 1.063v10.625a1.063 1.063 0 0 0 1.063 1.062h10.625a1.06 1.06 0 0 0 1.062-1.062V3.188a1.06 1.06 0 0 0-1.062-1.063m-7.97 8.5a.532.532 0 1 1 0 1.064.532.532 0 0 1 0-1.064M3.189 3.188h2.125v6.466a1.594 1.594 0 1 0 1.062 0V7.657l3.188 3.188v2.967H3.186zm10.625 10.625h-3.188v-3.188a.53.53 0 0 0-.155-.376L6.375 6.155V3.187H8.5v1.594a.53.53 0 0 0 .155.376L9.718 6.22a1.594 1.594 0 1 0 .752-.751l-.908-.908V3.188h4.25zm-2.657-7.438a.531.531 0 1 1 0 1.063.531.531 0 0 1 0-1.063"
  })));
}, Ze;
function r1() {
  return r1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r1.apply(this, arguments);
}
var Y7 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", r1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Ze || (Ze = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 21V7a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14M2 25h28M15 25v-4h8v4"
  })));
}, De, Te;
function n1() {
  return n1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, n1.apply(this, arguments);
}
var to = function(t) {
  return /* @__PURE__ */ a.createElement("svg", n1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), De || (De = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 1.7a8.3 8.3 0 1 0 0 16.6 8.3 8.3 0 0 0 0-16.6M.3 10C.3 4.645 4.645.3 10 .3c5.358 0 9.7 4.344 9.7 9.7 0 5.358-4.342 9.7-9.7 9.7C4.645 19.7.3 15.359.3 10",
    clipRule: "evenodd"
  })), Te || (Te = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.18 13.26 9.3 10.35V3.7h1.4v5.95l3.32 2.49z",
    clipRule: "evenodd"
  })));
}, Ge, Ue;
function a1() {
  return a1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a1.apply(this, arguments);
}
var eo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", a1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Ge || (Ge = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M12.569 6.344 15.156 8.5l-2.587 2.156H4.431L1.844 8.5 4.43 6.344z",
    opacity: 0.2
  })), Ue || (Ue = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M4.59 6.252 1.892 8.5l2.698 2.248a.53.53 0 1 1-.68.816L.722 8.908a.53.53 0 0 1 0-.816L3.91 5.435a.531.531 0 1 1 .68.817m11.687 1.84L13.09 5.435a.531.531 0 1 0-.68.817L15.107 8.5l-2.697 2.248a.53.53 0 0 0 .289.944.53.53 0 0 0 .39-.128l3.188-2.656a.53.53 0 0 0 0-.816m-5.47-5.935a.53.53 0 0 0-.681.318l-4.25 11.688a.531.531 0 1 0 .998.362l4.25-11.687a.53.53 0 0 0-.318-.681"
  })));
}, Ne, Xe, Ie, Qe;
function o1() {
  return o1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o1.apply(this, arguments);
}
var ro = function(t) {
  return /* @__PURE__ */ a.createElement("svg", o1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Ne || (Ne = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "M9.997 5.9A4.1 4.1 0 1 0 14.1 10a4.107 4.107 0 0 0-4.103-4.1Zm-.1 6.962v.002A2.862 2.862 0 1 1 12.862 10a2.866 2.866 0 0 1-2.865 2.862z"
  })), Xe || (Xe = /* @__PURE__ */ a.createElement("mask", {
    id: "Cog_svg__a",
    width: 21,
    height: 21,
    x: -0.5,
    y: -0.5,
    fill: "currentColor",
    maskUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M-.5-.5h21v21h-21z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M18.991 7.964h-2.107a7 7 0 0 0-.577-1.394l1.497-1.49a.51.51 0 0 0 0-.719l-2.165-2.165a.51.51 0 0 0-.72 0L13.43 3.69a7 7 0 0 0-1.394-.573V1.009a.51.51 0 0 0-.51-.509H8.474a.51.51 0 0 0-.509.509v2.114q-.722.215-1.384.576l-1.5-1.503a.523.523 0 0 0-.719 0L2.196 4.361a.51.51 0 0 0 0 .72l1.507 1.506c-.233.438-.42.9-.557 1.377H1.01a.51.51 0 0 0-.509.51v3.053a.51.51 0 0 0 .509.509h2.144c.142.47.332.925.567 1.357L2.196 14.92a.51.51 0 0 0 0 .719l2.165 2.165a.51.51 0 0 0 .72 0l1.526-1.524a7 7 0 0 0 1.357.567v2.144a.51.51 0 0 0 .51.509h3.053a.51.51 0 0 0 .509-.509v-2.134c.476-.14.937-.33 1.374-.567l1.51 1.514a.51.51 0 0 0 .719 0l2.165-2.165a.51.51 0 0 0 0-.72l-1.497-1.496c.237-.441.427-.906.567-1.387h2.117a.51.51 0 0 0 .509-.51V8.474a.51.51 0 0 0-.509-.509m-.509 3.054h-1.995a.51.51 0 0 0-.495.39 6.3 6.3 0 0 1-.76 1.825.51.51 0 0 0 .071.628l1.415 1.415-1.439 1.442-1.421-1.422a.51.51 0 0 0-.628-.074 6.1 6.1 0 0 1-1.819.746.51.51 0 0 0-.393.478v2.036H8.982v-2.036a.51.51 0 0 0-.39-.495 6.1 6.1 0 0 1-1.808-.75.51.51 0 0 0-.628.072L4.72 16.718l-1.439-1.439 1.435-1.435a.51.51 0 0 0 .072-.628 6.1 6.1 0 0 1-.75-1.808.51.51 0 0 0-.485-.39H1.518V8.982h2.036a.51.51 0 0 0 .495-.393c.15-.643.402-1.257.746-1.819a.51.51 0 0 0-.074-.628L3.282 4.721l1.439-1.439 1.415 1.415a.51.51 0 0 0 .627.071 6.1 6.1 0 0 1 1.826-.76.51.51 0 0 0 .393-.495V1.518h2.036v1.988a.51.51 0 0 0 .393.495c.65.15 1.27.406 1.836.757a.51.51 0 0 0 .628-.071l1.404-1.405 1.439 1.439-1.405 1.404a.51.51 0 0 0-.071.628c.35.567.606 1.187.757 1.836a.51.51 0 0 0 .495.393h1.988z"
  }))), Ie || (Ie = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M18.991 7.964h-2.107a7 7 0 0 0-.577-1.394l1.497-1.49a.51.51 0 0 0 0-.719l-2.165-2.165a.51.51 0 0 0-.72 0L13.43 3.69a7 7 0 0 0-1.394-.573V1.009a.51.51 0 0 0-.51-.509H8.474a.51.51 0 0 0-.509.509v2.114q-.722.215-1.384.576l-1.5-1.503a.523.523 0 0 0-.719 0L2.196 4.361a.51.51 0 0 0 0 .72l1.507 1.506c-.233.438-.42.9-.557 1.377H1.01a.51.51 0 0 0-.509.51v3.053a.51.51 0 0 0 .509.509h2.144c.142.47.332.925.567 1.357L2.196 14.92a.51.51 0 0 0 0 .719l2.165 2.165a.51.51 0 0 0 .72 0l1.526-1.524a7 7 0 0 0 1.357.567v2.144a.51.51 0 0 0 .51.509h3.053a.51.51 0 0 0 .509-.509v-2.134c.476-.14.937-.33 1.374-.567l1.51 1.514a.51.51 0 0 0 .719 0l2.165-2.165a.51.51 0 0 0 0-.72l-1.497-1.496c.237-.441.427-.906.567-1.387h2.117a.51.51 0 0 0 .509-.51V8.474a.51.51 0 0 0-.509-.509m-.509 3.054h-1.995a.51.51 0 0 0-.495.39 6.3 6.3 0 0 1-.76 1.825.51.51 0 0 0 .071.628l1.415 1.415-1.439 1.442-1.421-1.422a.51.51 0 0 0-.628-.074 6.1 6.1 0 0 1-1.819.746.51.51 0 0 0-.393.478v2.036H8.982v-2.036a.51.51 0 0 0-.39-.495 6.1 6.1 0 0 1-1.808-.75.51.51 0 0 0-.628.072L4.72 16.718l-1.439-1.439 1.435-1.435a.51.51 0 0 0 .072-.628 6.1 6.1 0 0 1-.75-1.808.51.51 0 0 0-.485-.39H1.518V8.982h2.036a.51.51 0 0 0 .495-.393c.15-.643.402-1.257.746-1.819a.51.51 0 0 0-.074-.628L3.282 4.721l1.439-1.439 1.415 1.415a.51.51 0 0 0 .627.071 6.1 6.1 0 0 1 1.826-.76.51.51 0 0 0 .393-.495V1.518h2.036v1.988a.51.51 0 0 0 .393.495c.65.15 1.27.406 1.836.757a.51.51 0 0 0 .628-.071l1.404-1.405 1.439 1.439-1.405 1.404a.51.51 0 0 0-.071.628c.35.567.606 1.187.757 1.836a.51.51 0 0 0 .495.393h1.988z"
  })), Qe || (Qe = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.4,
    d: "M18.991 7.964h-2.107a7 7 0 0 0-.577-1.394l1.497-1.49a.51.51 0 0 0 0-.719l-2.165-2.165a.51.51 0 0 0-.72 0L13.43 3.69a7 7 0 0 0-1.394-.573V1.009a.51.51 0 0 0-.51-.509H8.474a.51.51 0 0 0-.509.509v2.114q-.722.215-1.384.576l-1.5-1.503a.523.523 0 0 0-.719 0L2.196 4.361a.51.51 0 0 0 0 .72l1.507 1.506c-.233.438-.42.9-.557 1.377H1.01a.51.51 0 0 0-.509.51v3.053a.51.51 0 0 0 .509.509h2.144c.142.47.332.925.567 1.357L2.196 14.92a.51.51 0 0 0 0 .719l2.165 2.165a.51.51 0 0 0 .72 0l1.526-1.524a7 7 0 0 0 1.357.567v2.144a.51.51 0 0 0 .51.509h3.053a.51.51 0 0 0 .509-.509v-2.134c.476-.14.937-.33 1.374-.567l1.51 1.514a.51.51 0 0 0 .719 0l2.165-2.165a.51.51 0 0 0 0-.72l-1.497-1.496c.237-.441.427-.906.567-1.387h2.117a.51.51 0 0 0 .509-.51V8.474a.51.51 0 0 0-.509-.509Zm-.509 3.054h-1.995a.51.51 0 0 0-.495.39 6.3 6.3 0 0 1-.76 1.825.51.51 0 0 0 .071.628l1.415 1.415-1.439 1.442-1.421-1.422a.51.51 0 0 0-.628-.074 6.1 6.1 0 0 1-1.819.746.51.51 0 0 0-.393.478v2.036H8.982v-2.036a.51.51 0 0 0-.39-.495 6.1 6.1 0 0 1-1.808-.75.51.51 0 0 0-.628.072L4.72 16.718l-1.439-1.439 1.435-1.435a.51.51 0 0 0 .072-.628 6.1 6.1 0 0 1-.75-1.808.51.51 0 0 0-.485-.39H1.518V8.982h2.036a.51.51 0 0 0 .495-.393c.15-.643.402-1.257.746-1.819a.51.51 0 0 0-.074-.628L3.282 4.721l1.439-1.439 1.415 1.415a.51.51 0 0 0 .627.071 6.1 6.1 0 0 1 1.826-.76.51.51 0 0 0 .393-.495V1.518h2.036v1.988a.51.51 0 0 0 .393.495c.65.15 1.27.406 1.836.757a.51.51 0 0 0 .628-.071l1.404-1.405 1.439 1.439-1.405 1.404a.51.51 0 0 0-.071.628c.35.567.606 1.187.757 1.836a.51.51 0 0 0 .495.393h1.988z",
    mask: "url(#Cog_svg__a)"
  })));
}, Ke, Je;
function l1() {
  return l1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l1.apply(this, arguments);
}
var no = function(t) {
  return /* @__PURE__ */ a.createElement("svg", l1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, t), Ke || (Ke = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M5 5V1h16v16h-4"
  })), Je || (Je = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M1 5h16v16H1z"
  })));
}, Ye, t2;
function s1() {
  return s1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s1.apply(this, arguments);
}
var ao = function(t) {
  return /* @__PURE__ */ a.createElement("svg", s1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Ye || (Ye = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M10.094 10.594h.5V6.406H6.406v4.188h3.688Zm-6.397 2.71-.352.35.352-.35a.03.03 0 0 1-.01-.023V3.72a.03.03 0 0 1 .032-.031h9.562q.012 0 .022.009l.352-.352-.352.352q.01.009.01.022v9.562a.03.03 0 0 1-.01.022l.354.354-.354-.354a.03.03 0 0 1-.022.01H3.72a.03.03 0 0 1-.022-.01Z",
    opacity: 0.2
  })), t2 || (t2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10.094 6.375H6.906a.53.53 0 0 0-.531.531v3.188a.53.53 0 0 0 .531.531h3.188a.53.53 0 0 0 .531-.531V6.906a.53.53 0 0 0-.531-.531m-.531 3.188H7.437V7.437h2.125zm5.843 0h-1.062V7.437h1.062a.531.531 0 1 0 0-1.062h-1.062V3.719a1.063 1.063 0 0 0-1.063-1.063h-2.656V1.594a.531.531 0 0 0-1.062 0v1.062H7.437V1.594a.531.531 0 1 0-1.062 0v1.062H3.719A1.06 1.06 0 0 0 2.656 3.72v2.656H1.594a.531.531 0 1 0 0 1.063h1.062v2.125H1.594a.531.531 0 1 0 0 1.062h1.062v2.656a1.063 1.063 0 0 0 1.063 1.063h2.656v1.062a.531.531 0 1 0 1.063 0v-1.062h2.125v1.062a.531.531 0 1 0 1.062 0v-1.062h2.656a1.063 1.063 0 0 0 1.063-1.063v-2.656h1.062a.531.531 0 0 0 0-1.062m-2.125 3.718H3.72V3.72h9.562v9.563"
  })));
}, e2, r2;
function i1() {
  return i1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i1.apply(this, arguments);
}
var oo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", i1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, t), e2 || (e2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m.506 12.506 12-12 .99.99-12 12z",
    clipRule: "evenodd"
  })), r2 || (r2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.506 13.496-12-12 .99-.99 12 12z",
    clipRule: "evenodd"
  })));
}, n2, a2;
function c1() {
  return c1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c1.apply(this, arguments);
}
var lo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", c1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), n2 || (n2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M14.375 4.25v5.344H2.625V4.25a.563.563 0 0 1 .563-.562h10.625a.56.56 0 0 1 .562.562Z",
    opacity: 0.2
  })), a2 || (a2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.813 2.656H3.188A1.594 1.594 0 0 0 1.594 4.25v7.438a1.594 1.594 0 0 0 1.594 1.593h4.78v1.063H6.376a.531.531 0 1 0 0 1.062h4.25a.532.532 0 1 0 0-1.062H9.031V13.28h4.781a1.594 1.594 0 0 0 1.594-1.594V4.25a1.594 1.594 0 0 0-1.594-1.594M3.188 3.72h10.625a.53.53 0 0 1 .53.531v5.313H2.657V4.25a.53.53 0 0 1 .531-.531m10.625 8.5H3.188a.53.53 0 0 1-.532-.531v-1.063h11.688v1.063a.53.53 0 0 1-.531.53"
  })));
}, o2, l2;
function v1() {
  return v1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v1.apply(this, arguments);
}
var so = function(t) {
  return /* @__PURE__ */ a.createElement("svg", v1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), o2 || (o2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M11.61 11.33c.372.6.588 1.281.632 1.983H4.758A4.28 4.28 0 0 1 7.117 9.75L8.5 9.059l1.383.692c.712.355 1.31.902 1.728 1.578ZM9.884 7.25 8.5 7.94l-1.383-.692a4.28 4.28 0 0 1-2.359-3.561h7.484a4.28 4.28 0 0 1-2.359 3.561Z",
    opacity: 0.2
  })), l2 || (l2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.281 13.58v1.826a.531.531 0 0 1-1.062 0V13.58a4.23 4.23 0 0 0-2.35-3.802L6.655 8.172A5.29 5.29 0 0 1 3.72 3.42V1.594a.531.531 0 1 1 1.062 0V3.42a4.23 4.23 0 0 0 2.35 3.802l3.214 1.606a5.28 5.28 0 0 1 2.936 4.752m-2.656-.299H4.793c.025-.362.097-.719.214-1.062h4.828a.531.531 0 0 0 0-1.063H5.542c.267-.385.596-.724.973-1.001a.53.53 0 1 0-.629-.858A5.33 5.33 0 0 0 3.72 13.58v1.826a.531.531 0 1 0 1.062 0v-1.062h5.844a.531.531 0 0 0 0-1.063M12.75 1.063a.53.53 0 0 0-.531.53v1.063H6.375a.531.531 0 1 0 0 1.063h5.833a4.2 4.2 0 0 1-.215 1.062H7.165a.531.531 0 1 0 0 1.063h4.293a4.2 4.2 0 0 1-.973 1.001.532.532 0 0 0 .629.857A5.33 5.33 0 0 0 13.28 3.42V1.594a.53.53 0 0 0-.531-.532"
  })));
}, s2, i2;
function h1() {
  return h1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h1.apply(this, arguments);
}
var io = function(t) {
  return /* @__PURE__ */ a.createElement("svg", h1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 4"
  }, t), s2 || (s2 = /* @__PURE__ */ a.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#DotsHorizontal_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M4 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0M11 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0M18 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
  }))), i2 || (i2 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "DotsHorizontal_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 4V0h18v4z"
  })))));
}, c2;
function p1() {
  return p1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p1.apply(this, arguments);
}
var co = function(t) {
  return /* @__PURE__ */ a.createElement("svg", p1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 4 18"
  }, t), c2 || (c2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
}, v2, h2;
function u1() {
  return u1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u1.apply(this, arguments);
}
var vo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", u1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 44"
  }, t), v2 || (v2 = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#DownloadFile_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M37.063 14.145 27.438 4.52a1.4 1.4 0 0 0-.98-.395h-16.5a2.75 2.75 0 0 0-2.75 2.75v30.25a2.75 2.75 0 0 0 2.75 2.75h24.75a2.75 2.75 0 0 0 2.75-2.75v-22a1.4 1.4 0 0 0-.395-.98m-8.937 13.647-4.813 4.813a1.41 1.41 0 0 1-1.96 0l-4.812-4.813a1.392 1.392 0 0 1 1.96-1.96l2.457 2.476v-7.683a1.375 1.375 0 0 1 2.75 0v7.683l2.458-2.475a1.392 1.392 0 0 1 1.96 1.96m-1.668-12.667V7.563l7.563 7.562z"
  }))), h2 || (h2 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "DownloadFile_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M.333 0h44v44h-44z"
  })))));
}, p2, u2;
function g1() {
  return g1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, g1.apply(this, arguments);
}
var ho = function(t) {
  return /* @__PURE__ */ a.createElement("svg", g1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, t), p2 || (p2 = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#Edit_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "m10.7 4.443 2.172-2.95 4.16 3.219-2.096 2.847-7.753 10.534L2.76 19.52l.274-4.659 5.07-6.89z"
  }))), u2 || (u2 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Edit_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v20H0z"
  })))));
}, g2, m2;
function m1() {
  return m1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m1.apply(this, arguments);
}
var po = function(t) {
  return /* @__PURE__ */ a.createElement("svg", m1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), g2 || (g2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.5 4.375h15V15a.624.624 0 0 1-.625.625H3.125A.625.625 0 0 1 2.5 15z"
  })), m2 || (m2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.5 4.375 10 11.25 2.5 4.375"
  })));
}, f2, d2;
function f1() {
  return f1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, f1.apply(this, arguments);
}
var uo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", f1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19"
  }, t), f2 || (f2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.75 15.687H3.375a.56.56 0 0 1-.562-.562v-3.142a.56.56 0 0 1 .164-.398l8.438-8.437a.56.56 0 0 1 .795 0l3.142 3.142a.563.563 0 0 1 0 .795zM9.563 5 13.5 8.938"
  })), d2 || (d2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.187 15.687H6.75l-3.902-3.901"
  })));
}, w2, _2, b2;
function d1() {
  return d1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d1.apply(this, arguments);
}
var go = function(t) {
  return /* @__PURE__ */ a.createElement("svg", d1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), w2 || (w2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M19.3 10A9.3 9.3 0 1 1 .7 10a9.3 9.3 0 0 1 18.6 0"
  })), _2 || (_2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M10 5v7.994"
  })), b2 || (b2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M9.99 14.996H10"
  })));
}, O2;
function w1() {
  return w1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w1.apply(this, arguments);
}
var mo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", w1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 22"
  }, t), O2 || (O2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m10.285.01 4.96 4.96-.99.99-3.267-3.267.001 15.451h-1.4V2.687L6.313 5.961l-.99-.99zM.3 13.857h1.4v6.441h17.547v-6.441h1.4v7.841H.301z"
  })));
}, j2;
function _1() {
  return _1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _1.apply(this, arguments);
}
var fo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", _1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), j2 || (j2 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M10 4.374C3.75 4.374 1.25 10 1.25 10s2.5 5.624 8.75 5.624S18.75 10 18.75 10 16.25 4.374 10 4.374"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
  }))));
}, E2, M2, x2;
function b1() {
  return b1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b1.apply(this, arguments);
}
var wo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", b1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), E2 || (E2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.75 3.125 12.5 13.75M12.102 12.312a3.126 3.126 0 0 1-4.204-4.624"
  })), M2 || (M2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.78 5.359C2.597 6.972 1.25 10 1.25 10s2.5 5.624 8.75 5.624a9.2 9.2 0 0 0 4.219-.984M16.298 13.211c1.703-1.526 2.452-3.21 2.452-3.21S16.25 4.373 10 4.373q-.813 0-1.616.132"
  })), x2 || (x2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.588 6.93a3.13 3.13 0 0 1 2.523 2.776"
  })));
}, C2;
function O1() {
  return O1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O1.apply(this, arguments);
}
var _o = function(t) {
  return /* @__PURE__ */ a.createElement("svg", O1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, t), C2 || (C2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.513 11.052a.69.69 0 0 0-.75.15l-1.86 1.86H4.125a.687.687 0 0 0-.687.688v3.438a.687.687 0 0 0 .687.687h1.778l1.86 1.861a.687.687 0 0 0 1.175-.486v-7.562a.69.69 0 0 0-.425-.636m-.95 6.538-.89-.889a.7.7 0 0 0-.486-.201H4.813v-2.062h1.375a.69.69 0 0 0 .487-.202l.888-.889zm5.5-2.121a3.48 3.48 0 0 1-1.72 3 .688.688 0 0 1-.687-1.188 2.105 2.105 0 0 0 0-3.625.688.688 0 0 1 .688-1.187 3.49 3.49 0 0 1 1.719 3m5.298-8.393L13.55 2.264a.69.69 0 0 0-.486-.201h-8.25a1.375 1.375 0 0 0-1.375 1.374v6.876a.687.687 0 0 0 1.374 0V3.436h7.563v4.126a.687.687 0 0 0 .688.687h4.124v10.313h-2.75a.687.687 0 1 0 0 1.375h2.75a1.375 1.375 0 0 0 1.375-1.375v-11a.69.69 0 0 0-.2-.487M13.75 4.41l2.465 2.466H13.75z"
  })));
}, $2, L2;
function j1() {
  return j1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, j1.apply(this, arguments);
}
var bo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", j1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, t), $2 || ($2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M18.361 7.076 13.55 2.264a.69.69 0 0 0-.486-.201h-8.25a1.375 1.375 0 0 0-1.375 1.374v6.876a.687.687 0 0 0 1.374 0V3.436h7.563v4.126a.687.687 0 0 0 .688.687h4.124v10.313h-2.75a.687.687 0 1 0 0 1.375h2.75a1.375 1.375 0 0 0 1.375-1.375v-11a.69.69 0 0 0-.2-.487M13.75 4.41l2.465 2.466H13.75z"
  })), L2 || (L2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.875 11.688c.38 0 .688.307.688.687v6.188a.687.687 0 1 1-1.375 0v-6.188c0-.38.307-.687.687-.687M11 11.688c.38 0 .688.307.688.687v6.188a.687.687 0 1 1-1.376 0v-6.188c0-.38.308-.687.688-.687",
    clipRule: "evenodd"
  })));
}, k2, S2;
function E1() {
  return E1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, E1.apply(this, arguments);
}
var Oo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", E1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, t), k2 || (k2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M18.361 7.076 13.55 2.264a.69.69 0 0 0-.486-.201h-8.25a1.375 1.375 0 0 0-1.375 1.374v6.876a.687.687 0 0 0 1.374 0V3.436h7.563v4.126a.687.687 0 0 0 .688.687h4.124v10.313h-2.75a.687.687 0 1 0 0 1.375h2.75a1.375 1.375 0 0 0 1.375-1.375v-11a.69.69 0 0 0-.2-.487M13.75 4.41l2.465 2.466H13.75z"
  })), S2 || (S2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.895 13.965c.848.54.848 1.78 0 2.32L8.3 19.845a1.375 1.375 0 0 1-2.113-1.16v-7.12a1.375 1.375 0 0 1 2.113-1.16l-.738 1.16v7.12l5.594-3.56-5.594-3.56.738-1.16z",
    clipRule: "evenodd"
  })));
}, y2, H2;
function M1() {
  return M1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, M1.apply(this, arguments);
}
var jo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", M1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, t), y2 || (y2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M35.75 15.125h-9.625V5.5z",
    opacity: 0.2
  })), H2 || (H2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M38.5 26.125a1.375 1.375 0 0 1-1.375 1.375H33v2.75h2.75a1.375 1.375 0 0 1 0 2.75H33v2.75a1.375 1.375 0 0 1-2.75 0v-9.625a1.375 1.375 0 0 1 1.375-1.375h5.5a1.375 1.375 0 0 1 1.375 1.375m-22.687 3.438A4.813 4.813 0 0 1 11 34.375H9.625v1.375a1.375 1.375 0 0 1-2.75 0v-9.625A1.375 1.375 0 0 1 8.25 24.75H11a4.813 4.813 0 0 1 4.813 4.813m-2.75 0A2.06 2.06 0 0 0 11 27.5H9.625v4.125H11a2.06 2.06 0 0 0 2.063-2.062m15.125 1.375A6.187 6.187 0 0 1 22 37.125h-2.75a1.375 1.375 0 0 1-1.375-1.375v-9.625a1.375 1.375 0 0 1 1.375-1.375H22a6.187 6.187 0 0 1 6.188 6.188m-2.75 0A3.44 3.44 0 0 0 22 27.5h-1.375v6.875H22a3.44 3.44 0 0 0 3.438-3.437M6.875 19.25V6.875a2.75 2.75 0 0 1 2.75-2.75h16.5a1.38 1.38 0 0 1 .973.402l9.625 9.625a1.37 1.37 0 0 1 .402.973v4.125a1.375 1.375 0 0 1-2.75 0V16.5h-8.25a1.375 1.375 0 0 1-1.375-1.375v-8.25H9.625V19.25a1.375 1.375 0 0 1-2.75 0m20.625-5.5h4.931L27.5 8.819z"
  })));
}, P2, z2;
function x1() {
  return x1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x1.apply(this, arguments);
}
var Eo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", x1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), P2 || (P2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.625 17.5H4.375a.625.625 0 0 1-.625-.625V3.125a.625.625 0 0 1 .625-.625h7.5l4.375 4.375v10a.624.624 0 0 1-.625.625"
  })), z2 || (z2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.875 2.5v4.375h4.376M8.125 10l3.75 3.75M11.875 10l-3.75 3.75"
  })));
}, V2, B2;
function C1() {
  return C1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C1.apply(this, arguments);
}
var Mo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", C1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), V2 || (V2 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#Files_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m13.28 5.47-.22-.22H8.25v-1.5h7.19l3.31 3.31v10.19h-1.5V9.44l-.22-.22z",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 21H5.25a.75.75 0 0 1-.75-.75V6.75A.75.75 0 0 1 5.25 6h7.5l3.75 3.75v10.5a.75.75 0 0 1-.75.75"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 6V3.75A.75.75 0 0 1 8.25 3h7.5l3.75 3.75v10.5a.75.75 0 0 1-.75.75H16.5M8.25 14.25h4.5M8.25 17.25h4.5"
  }))), B2 || (B2 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Files_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}, W2, A2;
function $1() {
  return $1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $1.apply(this, arguments);
}
var xo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", $1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), W2 || (W2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m9.098 3.869-.187.452.187-.452a1.563 1.563 0 1 0-1.196 2.887A1.563 1.563 0 0 0 9.098 3.87Zm-3.862-.254a5.875 5.875 0 1 1 6.528 9.77 5.875 5.875 0 0 1-6.528-9.77ZM4.444 9.8a1.563 1.563 0 1 0 1.737-2.598 1.563 1.563 0 0 0-1.737 2.598Zm3.188 3.188a1.562 1.562 0 1 0 1.736-2.599 1.562 1.562 0 0 0-1.736 2.599Zm3.187-3.188A1.563 1.563 0 1 0 12.556 7.2a1.563 1.563 0 0 0-1.737 2.6Z",
    opacity: 0.2
  })), A2 || (A2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M14.875 14.344h-2.699A6.902 6.902 0 1 0 8.5 15.406h6.375a.531.531 0 0 0 0-1.062M2.656 8.5A5.844 5.844 0 1 1 8.5 14.344 5.85 5.85 0 0 1 2.656 8.5M8.5 6.906a1.594 1.594 0 1 0 0-3.187 1.594 1.594 0 0 0 0 3.187m0-2.125a.531.531 0 1 1 0 1.063.531.531 0 0 1 0-1.063m1.594 6.907a1.594 1.594 0 1 0-3.187 0 1.594 1.594 0 0 0 3.187 0m-2.125 0a.531.531 0 1 1 1.063 0 .531.531 0 0 1-1.063 0m3.719-1.594a1.594 1.594 0 1 0 0-3.188 1.594 1.594 0 0 0 0 3.188m0-2.125a.53.53 0 1 1 0 1.061.53.53 0 0 1 0-1.061M5.313 6.906a1.594 1.594 0 1 0 0 3.188 1.594 1.594 0 0 0 0-3.188m0 2.125a.531.531 0 1 1 0-1.062.531.531 0 0 1 0 1.062"
  })));
}, R2;
function L1() {
  return L1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L1.apply(this, arguments);
}
var Co = function(t) {
  return /* @__PURE__ */ a.createElement("svg", L1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, t), R2 || (R2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.625,
    d: "M15.031 17.468H4.063M21.938 17.468h-2.844M17.063 19.5a2.031 2.031 0 1 0 0-4.063 2.031 2.031 0 0 0 0 4.062M8.531 8.53H4.062M21.938 8.53h-9.344M10.563 10.562a2.031 2.031 0 1 0 0-4.063 2.031 2.031 0 0 0 0 4.063"
  })));
}, F2;
function k1() {
  return k1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k1.apply(this, arguments);
}
var $o = function(t) {
  return /* @__PURE__ */ a.createElement("svg", k1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), F2 || (F2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.125 16.875V3.75M3.125 13.125c5-3.75 8.75 3.75 13.75 0V3.75c-5 3.75-8.75-3.75-13.75 0"
  })));
}, q2, Z2;
function S1() {
  return S1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, S1.apply(this, arguments);
}
var Lo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", S1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), q2 || (q2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M3.188 13.844H13.81q.009 0 .016-.005l.253.432-.253-.432a.03.03 0 0 0 .015-.027.03.03 0 0 0-.004-.015l-1.075-1.792c-1.008.296-2.512.333-4.49-.668zm0 0a.03.03 0 0 1-.016-.005m.016.005-.016-.005m-.011-.043a.03.03 0 0 0 0 .032l.01.011m-.01-.043.01.043m-.01-.043 1.904-3.173M3.16 13.796l1.904-3.173m0 0c.752-.094 1.817.01 3.209.714z",
    opacity: 0.2
  })), Z2 || (Z2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m14.722 13.266-4.097-6.83v-3.78h.531a.531.531 0 1 0 0-1.062H5.844a.531.531 0 0 0 0 1.062h.53v3.78l-4.096 6.83a1.063 1.063 0 0 0 .91 1.609h10.624a1.063 1.063 0 0 0 .912-1.609zm-7.36-6.41a.53.53 0 0 0 .075-.272V2.656h2.125v3.928c0 .096.026.19.076.272l2.538 4.234c-.797.157-1.93.09-3.436-.671-1.057-.535-2.062-.819-3.003-.851zm-4.175 6.957 1.896-3.16c.946-.115 2.012.123 3.175.712 1.262.638 2.324.855 3.188.855.439.002.876-.058 1.298-.18l1.068 1.773z"
  })));
}, D2, T2;
function y1() {
  return y1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y1.apply(this, arguments);
}
var ko = function(t) {
  return /* @__PURE__ */ a.createElement("svg", y1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), D2 || (D2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M11.045 7.621c.39-1.614 1.08-3.225 2.268-4.103v7.138H10.61q.011-.237.039-.56c.057-.656.17-1.543.395-2.475Z",
    opacity: 0.2
  })), T2 || (T2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M4.781 5.844V2.656a.531.531 0 0 1 1.063 0v3.188a.531.531 0 0 1-1.063 0m9.563-3.188v12.22a.531.531 0 0 1-1.063 0v-3.188h-3.187a.53.53 0 0 1-.531-.532c.024-1.272.185-2.539.479-3.777.65-2.689 1.88-4.49 3.561-5.21a.53.53 0 0 1 .74.487m-1.063.923c-2.136 1.632-2.554 5.606-2.636 7.046h2.636zm-5.32-1.01a.531.531 0 1 0-1.047.175l.524 3.142a2.125 2.125 0 0 1-4.25 0l.523-3.142a.531.531 0 1 0-1.048-.175l-.531 3.188a1 1 0 0 0-.007.087 3.19 3.19 0 0 0 2.656 3.142v5.89a.531.531 0 1 0 1.063 0v-5.89A3.19 3.19 0 0 0 8.5 5.844a1 1 0 0 0-.007-.087z"
  })));
}, G2;
function H1() {
  return H1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H1.apply(this, arguments);
}
var So = function(t) {
  return /* @__PURE__ */ a.createElement("svg", H1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 15"
  }, t), G2 || (G2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M18.412 3.563A10.43 10.43 0 0 0 11 .5h-.037C5.194.52.5 5.281.5 11.106v2.144a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V11a10.43 10.43 0 0 0-3.088-7.437M20 13.25h-9.777l5.134-7.06a.75.75 0 1 0-1.214-.883L8.367 13.25H2v-2.144q0-.433.04-.856h2.21a.75.75 0 1 0 0-1.5H2.307c.967-3.643 4.125-6.397 7.943-6.718V4.25a.75.75 0 1 0 1.5 0V2.03a9.01 9.01 0 0 1 7.969 6.72H17.75a.75.75 0 1 0 0 1.5h2.22q.03.372.03.75z"
  })));
}, U2, N2;
function P1() {
  return P1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P1.apply(this, arguments);
}
var yo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", P1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), U2 || (U2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m9.585 2.678-4.25 4.25a.03.03 0 0 1-.044 0L4.228 5.866a.03.03 0 0 1 0-.044l4.25-4.25a.03.03 0 0 1 .045 0l1.062 1.062a.03.03 0 0 1 0 .044Zm5.844 5.8.007.01a.03.03 0 0 1 0 .024l-.007.01-4.25 4.25a.03.03 0 0 1-.022.01.03.03 0 0 1-.022-.01l-1.063-1.062a.03.03 0 0 1-.01-.023q0-.006.003-.011l-.462-.192.462.191.007-.01 4.25-4.25.01-.007-.191-.462.191.462a.03.03 0 0 1 .034.007z",
    opacity: 0.2
  })), N2 || (N2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m16.158 7.749-1.062-1.063a1.06 1.06 0 0 0-1.384-.101l-3.296-3.297a1.06 1.06 0 0 0-.101-1.383L9.252.842a1.063 1.063 0 0 0-1.503 0L3.5 5.092a1.06 1.06 0 0 0 0 1.503l1.063 1.062a1.06 1.06 0 0 0 1.383.101l.476.476-4.342 4.342a1.66 1.66 0 0 0 2.346 2.345l4.34-4.341.477.475a1.06 1.06 0 0 0 .101 1.384l1.063 1.063a1.063 1.063 0 0 0 1.502 0l4.25-4.25a1.064 1.064 0 0 0 0-1.503M5.313 6.906 4.25 5.844l4.25-4.25 1.063 1.062zm-1.64 7.264a.6.6 0 0 1-.842 0 .6.6 0 0 1 0-.842l4.341-4.342.843.842zm3.034-7.153L9.673 4.05l3.277 3.276-2.966 2.966zm4.45 5.733-1.063-1.062.266-.266 3.718-3.719.266-.265L15.407 8.5z"
  })));
}, X2, I2;
function z1() {
  return z1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z1.apply(this, arguments);
}
var Ho = function(t) {
  return /* @__PURE__ */ a.createElement("svg", z1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), X2 || (X2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.313 8.5a4.812 4.812 0 1 1-9.624 0 4.812 4.812 0 0 1 9.624 0Z",
    opacity: 0.2
  })), I2 || (I2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.406 7.969H14.32a5.8 5.8 0 0 0-.514-1.918l.942-.544a.53.53 0 1 0-.531-.92l-.943.544a5.9 5.9 0 0 0-1.404-1.404l.544-.943a.532.532 0 1 0-.92-.53l-.544.94a5.8 5.8 0 0 0-1.918-.513V1.594a.531.531 0 1 0-1.062 0V2.68a5.8 5.8 0 0 0-1.918.514l-.544-.942a.531.531 0 0 0-.92.531l.544.943a5.9 5.9 0 0 0-1.404 1.404l-.943-.544a.531.531 0 1 0-.53.92l.94.544a5.8 5.8 0 0 0-.513 1.918H1.594a.531.531 0 1 0 0 1.062H2.68c.06.664.233 1.313.514 1.918l-.942.544a.531.531 0 1 0 .531.92l.943-.544c.386.544.86 1.018 1.404 1.404l-.544.943a.531.531 0 1 0 .92.53l.544-.94c.605.28 1.254.454 1.918.513v1.087a.531.531 0 1 0 1.062 0V14.32a5.8 5.8 0 0 0 1.918-.514l.544.942a.531.531 0 1 0 .92-.531l-.544-.943a5.9 5.9 0 0 0 1.404-1.404l.943.544a.53.53 0 1 0 .532-.92l-.942-.544c.28-.605.454-1.254.513-1.918h1.087a.531.531 0 1 0 0-1.062m-9.74 4.379a4.777 4.777 0 0 1 0-7.696L7.885 8.5zm2.834.933a4.75 4.75 0 0 1-1.915-.398L8.807 9.03h4.444a4.787 4.787 0 0 1-4.751 4.25m.307-5.312L6.585 4.12a4.777 4.777 0 0 1 6.666 3.851z"
  })));
}, Q2, K2, J2;
function V1() {
  return V1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V1.apply(this, arguments);
}
var Po = function(t) {
  return /* @__PURE__ */ a.createElement("svg", V1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Q2 || (Q2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M19.3 10A9.3 9.3 0 1 1 .7 10a9.3 9.3 0 0 1 18.6 0Z"
  })), K2 || (K2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M14.3 10c0 2.676-.544 5.065-1.39 6.758-.868 1.735-1.937 2.542-2.91 2.542s-2.042-.807-2.91-2.542C6.245 15.065 5.7 12.676 5.7 10s.544-5.065 1.39-6.758C7.959 1.507 9.028.7 10 .7s2.042.807 2.91 2.542C13.755 4.935 14.3 7.324 14.3 10Z"
  })), J2 || (J2 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M18.083 4.445C16.264 5.69 13.32 6.5 10 6.5c-3.32 0-6.263-.81-8.082-2.055M18.083 15.555C16.264 14.31 13.32 13.5 10 13.5c-3.32 0-6.263.81-8.082 2.055M1 10h18"
  })));
}, Y2, tr;
function B1() {
  return B1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B1.apply(this, arguments);
}
var zo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", B1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Y2 || (Y2 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M6.384 5.875a1.03 1.03 0 0 0-.894.516v.001l-.614 1.07-.697-1.86a.03.03 0 0 1 0-.023l.732-1.731A5.85 5.85 0 0 1 8.5 2.625H8.5q.523 0 1.037.091l.585 1.047v.002a.03.03 0 0 1-.005.038L8.33 5.418l-.002.002-.003.002-.816.449h-.002l-.012.004H6.384Zm0 0v.5m0-.5v.5m0 0h1.11m-1.11 0a.53.53 0 0 0-.46.266l-.885 1.544m2.455-1.81L4.942 7.638a.03.03 0 0 0 .023.02l.18.038-.106.489m2.455-1.81q.137 0 .256-.066l.816-.45a.5.5 0 0 0 .1-.07zm-2.455 1.81-.167-.096-.2-.115-.067-.038.125-.218-.256.096a.53.53 0 0 0 .386.332zM10.41 9.74l3.065 1.885A5.88 5.88 0 0 1 9.43 14.3l.083-.43v-.001a1.03 1.03 0 0 0-.258-.896l-.007-.008-1.304-1.343a.03.03 0 0 1-.004-.032l.91-2.041a.03.03 0 0 1 .032-.019l1.515.205.014.005Z",
    opacity: 0.2
  })), tr || (tr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.5 1.594A6.906 6.906 0 1 0 15.406 8.5 6.914 6.914 0 0 0 8.5 1.594M14.344 8.5c0 .75-.144 1.492-.425 2.187L10.95 8.862a1.1 1.1 0 0 0-.414-.148l-1.515-.205a1.07 1.07 0 0 0-1.063.522H7.38l-.252-.522a1.06 1.06 0 0 0-.73-.575l-.532-.115.52-.913h1.109c.18 0 .356-.046.513-.133l.814-.448q.107-.06.199-.143l1.787-1.616a1.06 1.06 0 0 0 .216-1.305L11 3.217A5.85 5.85 0 0 1 14.345 8.5M9.517 2.745l.577 1.034-1.787 1.616-.813.449h-1.11a1.06 1.06 0 0 0-.921.531l-.58 1.011-.674-1.795.726-1.718a5.84 5.84 0 0 1 4.582-1.13zM2.657 8.5c-.002-.869.192-1.726.566-2.51L3.976 8a1.06 1.06 0 0 0 .772.664l1.423.306.253.526a1.07 1.07 0 0 0 .956.598h.099l-.48 1.078a1.06 1.06 0 0 0 .19 1.153l.009.01 1.302 1.34-.129.665A5.85 5.85 0 0 1 2.656 8.5m6.811 5.763.075-.386a1.07 1.07 0 0 0-.275-.932l-1.3-1.341.91-2.041 1.516.204 3.036 1.867a5.86 5.86 0 0 1-3.962 2.629"
  })));
}, er, rr;
function W1() {
  return W1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W1.apply(this, arguments);
}
var Vo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", W1({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "0 0"
    },
    viewBox: "0 0 80 80"
  }, t), er || (er = /* @__PURE__ */ a.createElement("style", null, "@keyframes pathRect{25%{stroke-dashoffset:64}50%{stroke-dashoffset:128}75%{stroke-dashoffset:192}to{stroke-dashoffset:256}}@keyframes dotRect{0%,to{transform:translate(0,0)}25%{transform:translate(18px,-18px)}50%{transform:translate(0,-36px)}75%{transform:translate(-18px,-18px)}}.GoStudentLoader_svg__pathRect{stroke:currentColor;stroke-width:9px;stroke-linejoin:round;stroke-linecap:round;stroke-dasharray:2 32 192 32;stroke-dashoffset:0;animation:pathRect 3s cubic-bezier(.785,.135,.15,.86) infinite}")), rr || (rr = /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    d: "M8 8h64v64H8z",
    className: "GoStudentLoader_svg__pathRect"
  })));
}, nr, ar, or, lr;
function A1() {
  return A1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A1.apply(this, arguments);
}
var Bo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", A1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.38 0.88 15.64 15.95"
  }, t), nr || (nr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.012 9.03c0-.526-.047-1.024-.127-1.51H8.363v2.998h4.307a3.7 3.7 0 0 1-1.598 2.38v1.993h2.57c1.504-1.389 2.37-3.436 2.37-5.862"
  })), ar || (ar = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.363 16.825c2.157 0 3.96-.718 5.279-1.934l-2.57-1.994c-.718.479-1.63.771-2.709.771-2.083 0-3.847-1.402-4.48-3.296h-2.65v2.053a7.98 7.98 0 0 0 7.13 4.4"
  })), or || (or = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M3.883 10.372A4.6 4.6 0 0 1 3.63 8.85a4.8 4.8 0 0 1 .253-1.522V5.275h-2.65a7.87 7.87 0 0 0 0 7.15z"
  })), lr || (lr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.363 4.032c1.178 0 2.23.405 3.062 1.196l2.277-2.273C12.324 1.665 10.52.875 8.363.875a7.98 7.98 0 0 0-7.13 4.4l2.65 2.053c.633-1.894 2.397-3.296 4.48-3.296"
  })));
}, sr, ir, cr, vr;
function R1() {
  return R1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R1.apply(this, arguments);
}
var Wo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", R1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 -0.03 31.4 32.04"
  }, t), sr || (sr = /* @__PURE__ */ a.createElement("path", {
    fill: "#4285F4",
    d: "M31.402 16.356c0-1.089-.088-2.183-.277-3.254H16.02v6.167h8.65a7.41 7.41 0 0 1-3.201 4.866v4.002h5.16c3.03-2.79 4.773-6.909 4.773-11.781"
  })), ir || (ir = /* @__PURE__ */ a.createElement("path", {
    fill: "#34A853",
    d: "M16.018 32.005c4.32 0 7.962-1.419 10.616-3.867l-5.16-4.001c-1.437.977-3.29 1.53-5.45 1.53-4.178 0-7.72-2.819-8.991-6.608H1.707v4.125a16.02 16.02 0 0 0 14.311 8.82"
  })), cr || (cr = /* @__PURE__ */ a.createElement("path", {
    fill: "#FBBC04",
    d: "M7.023 19.05a9.6 9.6 0 0 1 0-6.132V8.793h-5.32a16.03 16.03 0 0 0 0 14.382z"
  })), vr || (vr = /* @__PURE__ */ a.createElement("path", {
    fill: "#EA4335",
    d: "M16.018 6.307a8.7 8.7 0 0 1 6.144 2.401l4.572-4.572A15.4 15.4 0 0 0 16.018-.03 16.01 16.01 0 0 0 1.707 8.797l5.32 4.125c1.265-3.796 4.813-6.615 8.991-6.615"
  })));
}, hr, pr, ur, gr, mr, fr;
function F1() {
  return F1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F1.apply(this, arguments);
}
var Ao = function(t) {
  return /* @__PURE__ */ a.createElement("svg", F1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 20"
  }, t), hr || (hr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.625 7.5 11 2.5l9.375 5-9.375 5z"
  })), pr || (pr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M1.625 7.5 11 2.5l9.375 5-9.375 5z"
  })), ur || (ur = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.688 18.75V10L11 7.5"
  })), gr || (gr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M15.688 18.75V10L11 7.5"
  })), mr || (mr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.188 8.667v4.26a.62.62 0 0 1-.125.373c-.526.7-2.746 3.263-7.063 3.263S4.463 14 3.937 13.3a.62.62 0 0 1-.124-.374v-4.26"
  })), fr || (fr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M18.188 8.667v4.26a.62.62 0 0 1-.125.373c-.526.7-2.746 3.263-7.063 3.263S4.463 14 3.937 13.3a.62.62 0 0 1-.124-.374v-4.26"
  })));
}, dr, wr;
function q1() {
  return q1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, q1.apply(this, arguments);
}
var Ro = function(t) {
  return /* @__PURE__ */ a.createElement("svg", q1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), dr || (dr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M9.702 9.171A5.8 5.8 0 0 0 8.5 10.923 5.81 5.81 0 0 0 3.688 7.49V4.776a4.8 4.8 0 0 1 1.668.49l.506.257.19-.534c.344-.964 1.005-1.702 1.6-2.208a7 7 0 0 1 .848-.613l.082.05c.198.125.47.313.766.564.596.505 1.258 1.243 1.603 2.206l.191.534.506-.256a4.8 4.8 0 0 1 1.665-.49V7.49a5.8 5.8 0 0 0-3.61 1.681Z",
    opacity: 0.2
  })), wr || (wr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.813 3.719c-.724 0-1.442.135-2.116.398-.95-1.972-2.872-2.952-2.96-2.997a.53.53 0 0 0-.475 0c-.088.045-2.009 1.025-2.96 2.997a5.8 5.8 0 0 0-2.114-.398.53.53 0 0 0-.532.531v5.313a5.844 5.844 0 0 0 11.688 0V4.25a.53.53 0 0 0-.531-.531M7.969 14.315a4.79 4.79 0 0 1-4.25-4.752V8.529a4.79 4.79 0 0 1 4.25 4.752zm0-4.39a5.84 5.84 0 0 0-4.25-2.463V4.811a4.79 4.79 0 0 1 4.25 4.752zM6.252 4.59C6.864 3.313 8.007 2.508 8.5 2.205c.494.301 1.634 1.102 2.247 2.384A5.9 5.9 0 0 0 8.5 7.13a5.9 5.9 0 0 0-2.248-2.54m7.03 4.974a4.787 4.787 0 0 1-4.25 4.752V13.28a4.79 4.79 0 0 1 4.25-4.752zm0-2.1a5.84 5.84 0 0 0-4.25 2.462v-.362a4.79 4.79 0 0 1 4.25-4.752z"
  })));
}, _r, br;
function Z1() {
  return Z1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z1.apply(this, arguments);
}
var Fo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Z1({
    xmlns: "http://www.w3.org/2000/svg",
    fillOpacity: 0,
    viewBox: "0 0 24 24"
  }, t), _r || (_r = /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 16.875a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M18.375 10.875a5.62 5.62 0 0 1 4.5 2.25M1.125 13.125a5.62 5.62 0 0 1 4.5-2.25"
  })), br || (br = /* @__PURE__ */ a.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.603 20.25a6.003 6.003 0 0 1 10.794 0M5.625 10.875a3 3 0 1 1 2.947-3.563M15.428 7.312a3 3 0 1 1 2.947 3.563"
  })));
}, Or;
function D1() {
  return D1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D1.apply(this, arguments);
}
var qo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", D1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Or || (Or = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.875 9.375H3.125a.625.625 0 0 0 0 1.25h13.75a.625.625 0 0 0 0-1.25M3.125 5.625h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25M16.875 14.375H3.125a.625.625 0 1 0 0 1.25h13.75a.625.625 0 0 0 0-1.25"
  })));
}, jr, Er;
function T1() {
  return T1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T1.apply(this, arguments);
}
var Zo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", T1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), jr || (jr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m15.96 8.212-1.903 1.904a.031.031 0 0 1-.044 0l-2.496-2.5-.354-.355-.354.354-1.505 1.506-1.418-1.418L9.39 6.197l.354-.353-.353-.353-3.176-3.183a5.33 5.33 0 0 1 5.271 1.35l4.471 4.508.002.002a.03.03 0 0 1 .01.022.03.03 0 0 1-.01.022Zm.353-.398a.53.53 0 0 1 0 .752z",
    opacity: 0.2
  })), Er || (Er = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m16.69 7.437-4.48-4.51a6.38 6.38 0 0 0-9.016 0l-.006.006-.914.945a.531.531 0 0 0 .763.74l.912-.942a5.3 5.3 0 0 1 1.242-.924L8.28 5.844l-6.375 6.375a1.063 1.063 0 0 0 0 1.503l1.374 1.373a1.06 1.06 0 0 0 1.503 0l6.375-6.375.952.953 1.173 1.171a1.06 1.06 0 0 0 1.503 0l1.905-1.905a1.06 1.06 0 0 0 .001-1.502M4.03 14.344 2.655 12.97 7.17 8.454l1.374 1.374zm6.75-6.752L9.296 9.076 7.922 7.703 9.407 6.22a.53.53 0 0 0 0-.752L6.263 2.324a5.31 5.31 0 0 1 5.195 1.356l2.936 2.955-1.91 1.909-.952-.952a.53.53 0 0 0-.752 0m3.254 2.5-.797-.797 1.903-1.907.797.797z"
  })));
}, Mr, xr;
function G1() {
  return G1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G1.apply(this, arguments);
}
var Do = function(t) {
  return /* @__PURE__ */ a.createElement("svg", G1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Mr || (Mr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M12.78 3.156h.006c1.161 0 2.12.983 2.12 2.156 0 .81-.392 1.615-1.008 2.378-.588.73-1.346 1.377-2.04 1.895l-.795.182a1.827 1.827 0 0 0-1.766-2.298H6.67c-.532-.715-.857-1.42-.857-2.157 0-1.173.959-2.156 2.12-2.156h.006a2.1 2.1 0 0 1 1.96 1.287l.46 1.1.461-1.1a2.1 2.1 0 0 1 1.96-1.287ZM1.063 10.594h1.625v2.718H1.062a.031.031 0 0 1-.031-.031v-2.656a.03.03 0 0 1 .032-.031Z",
    opacity: 0.2
  })), xr || (xr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.295 9.367a1.62 1.62 0 0 0-1.235-.316c1.247-1.26 1.877-2.511 1.877-3.738 0-1.758-1.413-3.188-3.151-3.188a3.16 3.16 0 0 0-2.427 1.112 3.16 3.16 0 0 0-2.426-1.112c-1.738 0-3.152 1.43-3.152 3.188 0 .73.215 1.44.668 2.191-.37.094-.71.287-.98.558l-1.501 1.5H1.063A1.06 1.06 0 0 0 0 10.626v2.656a1.06 1.06 0 0 0 1.063 1.063h6.906a.5.5 0 0 0 .129-.016l4.25-1.063a1 1 0 0 0 .079-.026l2.58-1.099.03-.013a1.634 1.634 0 0 0 .261-2.76zm-7.362-6.18A2.07 2.07 0 0 1 9.868 4.45a.531.531 0 0 0 .983 0 2.07 2.07 0 0 1 1.935-1.261c1.132 0 2.089.972 2.089 2.125 0 1.295-1.049 2.76-3.032 4.243l-.737.17a1.86 1.86 0 0 0-1.81-2.288h-2.61c-.573-.773-.842-1.453-.842-2.125 0-1.153.957-2.125 2.089-2.125m-6.87 7.438h1.593v2.656H1.062zm13.509.545-2.524 1.075-4.146 1.036H3.72v-2.967l1.503-1.502a1.05 1.05 0 0 1 .75-.312h3.325a.797.797 0 0 1 0 1.594h-1.86a.531.531 0 0 0 0 1.062h2.125q.06 0 .12-.013l4.449-1.023.02-.006a.57.57 0 0 1 .418 1.056z"
  })));
}, Cr;
function U1() {
  return U1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U1.apply(this, arguments);
}
var To = function(t) {
  return /* @__PURE__ */ a.createElement("svg", U1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, t), Cr || (Cr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 14.875S1.188 10.5 1.188 5.188A4.063 4.063 0 0 1 9 3.622h0a4.063 4.063 0 0 1 7.813 1.566C16.813 10.5 9 14.875 9 14.875"
  })));
}, $r, Lr, kr;
function N1() {
  return N1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N1.apply(this, arguments);
}
var Go = function(t) {
  return /* @__PURE__ */ a.createElement("svg", N1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), $r || ($r = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  })), Lr || (Lr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10 15a.937.937 0 1 0 0-1.875A.937.937 0 0 0 10 15"
  })), kr || (kr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 11.25v-.625a2.187 2.187 0 1 0-2.187-2.187"
  })));
}, Sr;
function X1() {
  return X1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X1.apply(this, arguments);
}
var Uo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", X1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Sr || (Sr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.875 16.25V12.5a.625.625 0 0 0-.626-.626h-2.5a.625.625 0 0 0-.624.625v3.75a.625.625 0 0 1-.625.626H3.75a.625.625 0 0 1-.625-.625V9.027a.63.63 0 0 1 .205-.463l6.25-5.682a.625.625 0 0 1 .84 0l6.25 5.682a.63.63 0 0 1 .205.463v7.223a.625.625 0 0 1-.625.625H12.5a.625.625 0 0 1-.626-.625"
  })));
}, yr, Hr;
function I1() {
  return I1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, I1.apply(this, arguments);
}
var No = function(t) {
  return /* @__PURE__ */ a.createElement("svg", I1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), yr || (yr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m2.634 13.303-.351.352.351-.352a.03.03 0 0 1-.009-.022V3.72a.03.03 0 0 1 .031-.031h11.688q.012 0 .022.009l.351-.352-.351.352q.009.009.009.022v9.562a.03.03 0 0 1-.01.022l.354.354-.353-.354a.03.03 0 0 1-.022.01H2.656a.03.03 0 0 1-.022-.01ZM5.212 9.71l.278-.416-.278.416a2.094 2.094 0 0 0 2.904-2.904l-.416.277.416-.277A2.094 2.094 0 1 0 5.212 9.71Z",
    opacity: 0.2
  })), Hr || (Hr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.281 7.438a.53.53 0 0 1-.531.53h-2.656a.531.531 0 1 1 0-1.062h2.656a.53.53 0 0 1 .531.532M12.75 9.03h-2.656a.531.531 0 1 0 0 1.063h2.656a.531.531 0 0 0 0-1.063m2.656-5.312v9.562a1.063 1.063 0 0 1-1.062 1.063H2.656a1.063 1.063 0 0 1-1.062-1.063V3.72a1.06 1.06 0 0 1 1.062-1.063h11.688a1.063 1.063 0 0 1 1.062 1.063m-1.062 9.562V3.72H2.656v9.562zm-5.33-2.258a.531.531 0 0 1-1.03.266c-.174-.681-.867-1.195-1.61-1.195s-1.435.514-1.61 1.195a.531.531 0 1 1-1.03-.266 2.65 2.65 0 0 1 1.142-1.55 2.125 2.125 0 1 1 2.996 0c.563.355.97.909 1.143 1.55zM6.375 9.031a1.062 1.062 0 1 0 0-2.125 1.062 1.062 0 0 0 0 2.125"
  })));
}, Pr, zr, Vr;
function Q1() {
  return Q1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Q1.apply(this, arguments);
}
var Xo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Q1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Pr || (Pr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.875 3.75H3.125a.625.625 0 0 0-.625.625v11.25c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625V4.375a.625.625 0 0 0-.625-.625"
  })), zr || (zr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m2.5 13.125 3.933-3.933a.625.625 0 0 1 .884 0l3.491 3.491a.627.627 0 0 0 .884 0l1.616-1.616a.625.625 0 0 1 .884 0l3.308 3.308"
  })), Vr || (Vr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M12.188 8.75a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875"
  })));
}, Br;
function K1() {
  return K1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K1.apply(this, arguments);
}
var Io = function(t) {
  return /* @__PURE__ */ a.createElement("svg", K1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, t), Br || (Br = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M25.25.5h-18A2.25 2.25 0 0 0 5 2.75V5H2.75A2.25 2.25 0 0 0 .5 7.25v18a2.25 2.25 0 0 0 2.25 2.25h18A2.25 2.25 0 0 0 23 25.25V23h2.25a2.25 2.25 0 0 0 2.25-2.25v-18A2.25 2.25 0 0 0 25.25.5m-18 2.25h18v9.757l-2.348-2.349a2.25 2.25 0 0 0-3.181 0L9.13 20.75H7.25zm13.5 22.5h-18v-18H5v13.5A2.25 2.25 0 0 0 7.25 23h13.5zM10.625 8.375a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"
  })));
}, Wr;
function J1() {
  return J1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J1.apply(this, arguments);
}
var Qo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", J1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Wr || (Wr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.33 11.885-.678.767a3.75 3.75 0 1 1 0-5.304l4.696 5.304a3.75 3.75 0 1 0 0-5.304l-.678.767"
  })));
}, Ar;
function Y1() {
  return Y1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y1.apply(this, arguments);
}
var Ko = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Y1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 37"
  }, t), Ar || (Ar = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M30.375 6.426H5.625a2.25 2.25 0 0 0-2.25 2.25v20.25a2.25 2.25 0 0 0 2.25 2.25h24.75a2.25 2.25 0 0 0 2.25-2.25V8.676a2.25 2.25 0 0 0-2.25-2.25m-1.648 16.352a5.625 5.625 0 0 1-7.931.024l-7.115-6.344-.04-.048a3.374 3.374 0 1 0 0 4.781c.05-.05.1-.102.14-.154a1.126 1.126 0 0 1 1.688 1.49 5.625 5.625 0 1 1-.264-7.723l7.112 6.344.047.043a3.375 3.375 0 1 0-.005-4.78q-.076.074-.14.154a1.125 1.125 0 1 1-1.688-1.49 5 5 0 0 1 .24-.255 5.625 5.625 0 0 1 7.956 7.953z"
  })));
}, Rr, Fr, qr;
function t0() {
  return t0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t0.apply(this, arguments);
}
var Jo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", t0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Rr || (Rr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  })), Fr || (Fr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.375 9.375H10v4.375h.625"
  })), qr || (qr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M9.844 7.5a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875"
  })));
}, Zr, Dr, Tr;
function e0() {
  return e0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, e0.apply(this, arguments);
}
var Yo = function(t) {
  return /* @__PURE__ */ a.createElement("svg", e0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Zr || (Zr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.75 8.125v2.5h-7.5"
  })), Dr || (Dr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.125 8.75 6.25 10.625 8.125 12.5"
  })), Tr || (Tr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.875 3.75H3.125a.625.625 0 0 0-.625.625v11.25c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625V4.375a.625.625 0 0 0-.625-.625"
  })));
}, Gr, Ur;
function r0() {
  return r0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r0.apply(this, arguments);
}
var t4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", r0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 26"
  }, t), Gr || (Gr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m12.178 10.017-.904 5.143L16 12.734l4.726 2.426-.904-5.143 3.853-3.665-5.32-.754L16 .94l-2.355 4.658-5.32.754z"
  })), Ur || (Ur = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M26.901 9.934c.025-.3.033-.605.043-.91.89-.387 2.539-1.263 3.283-2.859.312-.67 1.017-2.286-.432-5.727-2.423.748-3.981 1.748-4.728 3.35-.888 1.905-.222 4.077.02 4.743-.05 5.606-3.22 12.032-9.087 12.032h-.004c-5.64 0-9.035-6.159-9.088-12.032.243-.666.91-2.838.02-4.744-1.04-2.23-3.746-3.07-3.86-3.106L2.262.438l-.33.771c-.047.111-1.142 2.725-.102 4.956.745 1.596 2.33 2.472 3.221 2.86.01.304.018.61.043.909-1.585-.783-3.162-.67-5.095-.24.316 2.518 1.01 4.164 2.458 5.178 1.059.74 2.322.92 3.302.92.331 0 .613-.022.86-.049q.279.592.601 1.142c-.017 0-.033-.006-.05-.006-.739 0-2.503.044-5.008 2.813 1.702 1.88 3.24 2.813 5.008 2.813 1.653 0 3.04-.939 3.807-1.587q.675.435 1.401.75a6.54 6.54 0 0 0-2.568 3.27l1.769.624A4.695 4.695 0 0 1 16 22.438a4.69 4.69 0 0 1 4.42 3.124l1.769-.624a6.54 6.54 0 0 0-2.57-3.271q.725-.315 1.4-.75c.766.649 2.154 1.587 3.808 1.587.738 0 2.502-.044 5.008-2.812-1.703-1.88-3.241-2.812-5.009-2.812q-.025.002-.05.005.321-.55.6-1.142c.248.027.53.05.861.05.98 0 2.306-.18 3.363-.921.605-.424 1.935-1.473 2.4-5.177-3.406-.76-4.736.06-5.099.239"
  })));
}, Nr;
function n0() {
  return n0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, n0.apply(this, arguments);
}
var e4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", n0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, t), Nr || (Nr = /* @__PURE__ */ a.createElement("path", {
    d: "m15.317 8.442-3.28 3.281a.624.624 0 0 1-1.067-.442V8.625H6.125a.625.625 0 0 1 0-1.25h4.845V4.719a.626.626 0 0 1 1.067-.442l3.28 3.281a.625.625 0 0 1 0 .884M6.125 14.25H1.75V1.75h4.375a.625.625 0 0 0 0-1.25H1.75A1.25 1.25 0 0 0 .5 1.75v12.5a1.25 1.25 0 0 0 1.25 1.25h4.375a.625.625 0 1 0 0-1.25"
  })));
}, Xr, Ir;
function a0() {
  return a0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a0.apply(this, arguments);
}
var r4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", a0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), Xr || (Xr = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
  })), Ir || (Ir = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M9.349 9.348 5.636 5.636M14.651 9.348l3.713-3.712M14.651 14.652l3.713 3.712M9.349 14.652l-3.713 3.712"
  })));
}, Qr;
function o0() {
  return o0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o0.apply(this, arguments);
}
var n4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", o0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, t), Qr || (Qr = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#LightBulb_svg__clip0_7760_6286)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M5.5 14.5h5M8 12.5V9M6 7l2 2 2-2"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M4.919 10.438A4.97 4.97 0 0 1 3 6.532C2.988 3.819 5.17 1.562 7.881 1.5a5 5 0 0 1 3.207 8.932 1.51 1.51 0 0 0-.588 1.193V12a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.375a1.53 1.53 0 0 0-.581-1.187"
  }))));
}, Kr, Jr;
function l0() {
  return l0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l0.apply(this, arguments);
}
var a4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", l0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, t), Kr || (Kr = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#LightBulbBigFilled_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M12.297 26.094A12.48 12.48 0 0 1 7.5 16.32C7.463 9.545 12.925 3.906 19.698 3.75a12.5 12.5 0 0 1 8.022 22.328 3.8 3.8 0 0 0-1.47 2.984V30A1.25 1.25 0 0 1 25 31.25H15A1.25 1.25 0 0 1 13.75 30v-.938a3.77 3.77 0 0 0-1.453-2.969",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.75 36.25h12.5M12.297 26.094A12.48 12.48 0 0 1 7.5 16.32C7.463 9.545 12.925 3.906 19.698 3.75a12.5 12.5 0 0 1 8.022 22.328 3.8 3.8 0 0 0-1.47 2.984V30A1.25 1.25 0 0 1 25 31.25H15A1.25 1.25 0 0 1 13.75 30v-.938a3.77 3.77 0 0 0-1.453-2.969"
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.25 8.75c3.125.527 5.72 3.125 6.25 6.25"
  }))), Jr || (Jr = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "LightBulbBigFilled_svg__a"
  }, /* @__PURE__ */ a.createElement("rect", {
    width: 40,
    height: 40,
    fill: "currentColor",
    rx: 12
  })))));
}, Yr;
function s0() {
  return s0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s0.apply(this, arguments);
}
var o4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", s0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 20"
  }, t), Yr || (Yr = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.86 9.234a.63.63 0 0 0-.391-.445l-4.5-1.687 1.14-5.727a.63.63 0 0 0-.32-.68.62.62 0 0 0-.742.125l-8.75 9.375a.617.617 0 0 0-.016.841.64.64 0 0 0 .25.175l4.5 1.688-1.14 5.726a.63.63 0 0 0 .32.68q.136.068.289.07a.62.62 0 0 0 .453-.195l8.75-9.375a.62.62 0 0 0 .156-.57"
  })));
}, tn, en;
function i0() {
  return i0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i0.apply(this, arguments);
}
var l4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", i0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 20"
  }, t), tn || (tn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m4.5 18.75 1.25-6.25-5-1.876L9.5 1.25 8.25 7.5l5 1.875z"
  })), en || (en = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m4.5 18.75 1.25-6.25-5-1.876L9.5 1.25 8.25 7.5l5 1.875z"
  })));
}, rn, nn;
function c0() {
  return c0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c0.apply(this, arguments);
}
var s4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", c0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), rn || (rn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.558 5.58 1.547-1.546a3.437 3.437 0 1 1 4.861 4.86l-2.21 2.21a3.436 3.436 0 0 1-4.86 0"
  })), nn || (nn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.442 14.42-1.547 1.546a3.436 3.436 0 0 1-5.608-1.114 3.44 3.44 0 0 1 .747-3.747l2.21-2.21a3.437 3.437 0 0 1 4.86 0"
  })));
}, an, on;
function v0() {
  return v0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v0.apply(this, arguments);
}
var i4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", v0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, t), an || (an = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M54 36a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
    opacity: 0.2
  })), on || (on = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8 16a2 2 0 0 1 2-2h44a2 2 0 0 1 0 4H10a2 2 0 0 1-2-2m2 18h18a2 2 0 0 0 0-4H10a2 2 0 1 0 0 4m22 12H10a2 2 0 1 0 0 4h22a2 2 0 0 0 0-4m27.415 3.415a2 2 0 0 1-2.83 0L51.5 44.34a10 10 0 1 1 2.84-2.84l5.075 5.075a2 2 0 0 1 0 2.84M46 42a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })));
}, ln, sn, cn, vn, hn, pn;
function h0() {
  return h0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h0.apply(this, arguments);
}
var c4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", h0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), ln || (ln = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 6.875H3.75a.625.625 0 0 0-.625.625v8.75c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V7.5a.625.625 0 0 0-.625-.625"
  })), sn || (sn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.25 6.875H3.75a.625.625 0 0 0-.625.625v8.75c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V7.5a.625.625 0 0 0-.625-.625"
  })), cn || (cn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.188 6.875V4.063a2.813 2.813 0 0 1 5.625 0v2.812"
  })), vn || (vn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M7.188 6.875V4.063a2.813 2.813 0 0 1 5.625 0v2.812"
  })), hn || (hn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10 12.813a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874"
  })), pn || (pn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.12,
    d: "M10 12.813a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874"
  })));
}, un, gn, mn;
function p0() {
  return p0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p0.apply(this, arguments);
}
var v4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", p0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, t), un || (un = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.98 9.094H5.353a.78.78 0 0 0-.781.781v10.938c0 .431.35.78.781.78H20.98c.432 0 .782-.349.782-.78V9.875a.78.78 0 0 0-.782-.781"
  })), gn || (gn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.651 9.094V5.578a3.516 3.516 0 1 1 7.031 0"
  })), mn || (mn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.167 16.516a1.172 1.172 0 1 0 0-2.344 1.172 1.172 0 0 0 0 2.344"
  })));
}, fn, dn;
function u0() {
  return u0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u0.apply(this, arguments);
}
var h4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", u0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, t), fn || (fn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M27.7 17.5 11.816 33.384a1.25 1.25 0 0 1-1.768 0l-3.232-3.228a1.25 1.25 0 0 1 0-1.767L22.7 12.5z",
    opacity: 0.2
  })), dn || (dn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M38.95 23.75A1.25 1.25 0 0 1 37.7 25h-2.5v2.5a1.25 1.25 0 0 1-2.5 0V25h-2.5a1.25 1.25 0 0 1 0-2.5h2.5V20a1.25 1.25 0 0 1 2.5 0v2.5h2.5a1.25 1.25 0 0 1 1.25 1.25m-30-12.5h2.5v2.5a1.25 1.25 0 0 0 2.5 0v-2.5h2.5a1.25 1.25 0 0 0 0-2.5h-2.5v-2.5a1.25 1.25 0 0 0-2.5 0v2.5h-2.5a1.25 1.25 0 1 0 0 2.5m20 18.75H27.7v-1.25a1.25 1.25 0 0 0-2.5 0V30h-1.25a1.25 1.25 0 0 0 0 2.5h1.25v1.25a1.25 1.25 0 0 0 2.5 0V32.5h1.25a1.25 1.25 0 0 0 0-2.5m5.517-17.5L12.7 34.267a2.5 2.5 0 0 1-3.534 0L5.93 31.036a2.5 2.5 0 0 1 0-3.536L27.7 5.733a2.5 2.5 0 0 1 3.536 0l3.231 3.231a2.5 2.5 0 0 1 0 3.536m-8.536 5L22.7 14.267l-15 15L10.93 32.5zm6.769-6.767L29.467 7.5l-5 5 3.233 3.233z"
  })));
}, wn, _n;
function g0() {
  return g0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, g0.apply(this, arguments);
}
var p4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", g0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), wn || (wn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m10.469 13.301-1.631 1.596a.031.031 0 0 1-.044 0l-1.902-1.903a.03.03 0 0 1-.01-.023.03.03 0 0 1 .01-.022l1.638-1.583zm-8.364-5.14h.001l1.6-1.623 1.937 1.937-1.593 1.633-.01.007-.012.002a.03.03 0 0 1-.022-.009L2.105 8.206a.03.03 0 0 1 0-.044Z",
    opacity: 0.2
  })), _n || (_n = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.746 3.337a5.8 5.8 0 0 0-4.144-1.743H9.58a5.8 5.8 0 0 0-4.135 1.714L3.327 5.453 1.37 7.438a1.06 1.06 0 0 0 .003 1.498l1.904 1.903a1.06 1.06 0 0 0 .751.311h.006a1.06 1.06 0 0 0 .755-.32l4.044-4.144a1.07 1.07 0 0 1 1.488-.013 1.03 1.03 0 0 1 .314.743 1.12 1.12 0 0 1-.322.796l-4.136 3.999a1.06 1.06 0 0 0-.012 1.513l1.904 1.903a1.066 1.066 0 0 0 1.495.008l4.104-4.014c2.288-2.29 2.323-6.006.079-8.284m-9.719 6.75L2.125 8.183l1.58-1.602L5.6 8.476zm4.791 4.788-1.905-1.902 1.62-1.566 1.893 1.896zm4.101-4.014-1.734 1.696-1.888-1.887 1.755-1.698.007-.006a2.2 2.2 0 0 0 .636-1.56 2.09 2.09 0 0 0-.64-1.496 2.14 2.14 0 0 0-2.982.033L6.34 7.715 4.449 5.827l1.75-1.77a4.75 4.75 0 0 1 3.381-1.4h.018a4.75 4.75 0 0 1 3.39 1.426c1.837 1.864 1.804 4.907-.069 6.78z"
  })));
}, bn;
function m0() {
  return m0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m0.apply(this, arguments);
}
var u4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", m0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, t), bn || (bn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8 1.5A5.506 5.506 0 0 0 2.5 7c0 4.706 5 8.26 5.213 8.41a.5.5 0 0 0 .574 0C8.5 15.26 13.5 11.705 13.5 7A5.506 5.506 0 0 0 8 1.5M8 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
}, On, jn;
function f0() {
  return f0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, f0.apply(this, arguments);
}
var g4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", f0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), On || (On = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M3.156 3.187v3.705c0 2.263.63 4.29 1.624 5.738.995 1.45 2.319 2.276 3.72 2.276s2.725-.827 3.72-2.277c.993-1.447 1.624-3.474 1.624-5.738V3.188a.03.03 0 0 0-.014-.026l-.014-.005zm0 0q0-.007.004-.015m-.004.015.004-.015m0 0 .01-.011m-.01.011.01-.011m0 0 .014-.005m-.014.005.014-.005m0 0q.007 0 .015.002m-.015-.002.015.002m0 0 .18-.467m-.18.467.18-.467m0 0-.18.466C4.23 3.56 6.228 4.2 8.5 4.2M3.38 2.691 8.5 4.2m0 0c2.27 0 4.27-.64 5.301-1.04z",
    opacity: 0.2
  })), jn || (jn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M14.41 2.311a1.06 1.06 0 0 0-.984-.114c-.932.363-2.813.971-4.926.971s-3.995-.608-4.928-.97a1.063 1.063 0 0 0-1.447.99V6.89c0 2.38.64 4.625 1.805 6.32 1.206 1.758 2.829 2.723 4.57 2.723s3.364-.967 4.57-2.722c1.164-1.694 1.805-3.94 1.805-6.32V3.188a1.06 1.06 0 0 0-.465-.877m-.598 4.582c0 2.168-.575 4.199-1.618 5.72-1.002 1.459-2.313 2.262-3.694 2.262s-2.692-.803-3.694-2.263C3.763 11.09 3.188 9.06 3.188 6.892V3.188C4.19 3.578 6.214 4.23 8.5 4.23s4.31-.654 5.313-1.043zm-1.195 1.253a.533.533 0 1 1-.797.708c-.178-.2-.587-.354-.93-.354-.341 0-.754.155-.93.354a.533.533 0 0 1-.796-.709c.38-.423 1.072-.707 1.727-.707.654 0 1.344.284 1.726.707zM6.11 8.5c-.344 0-.754.155-.93.354a.533.533 0 0 1-.796-.709c.382-.423 1.074-.707 1.726-.707s1.345.284 1.727.707a.533.533 0 1 1-.797.709c-.175-.199-.585-.354-.93-.354m5.077 3.001a3.514 3.514 0 0 1-5.372 0 .532.532 0 0 1 .808-.69 2.45 2.45 0 0 0 3.756 0 .531.531 0 1 1 .808.69"
  })));
}, En;
function d0() {
  return d0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d0.apply(this, arguments);
}
var m4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", d0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), En || (En = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M7.438 4.782a.53.53 0 0 1-.532.53h-4.25a.531.531 0 0 1 0-1.062h4.25a.53.53 0 0 1 .532.532m-.532 6.906H5.313v-1.594a.531.531 0 0 0-1.063 0v1.594H2.656a.531.531 0 0 0 0 1.062H4.25v1.594a.531.531 0 1 0 1.063 0V12.75h1.593a.531.531 0 0 0 0-1.062m3.188 0h4.25a.531.531 0 0 0 0-1.063h-4.25a.531.531 0 0 0 0 1.063m4.25 1.062h-4.25a.531.531 0 0 0 0 1.063h4.25a.531.531 0 0 0 0-1.063m-4.095-5.999a.53.53 0 0 0 .752 0l1.218-1.218 1.218 1.218A.532.532 0 0 0 14.188 6L12.97 4.782l1.218-1.218a.532.532 0 0 0-.751-.752L12.219 4.03 11 2.812a.532.532 0 0 0-.752.752l1.219 1.218-1.219 1.217a.53.53 0 0 0 0 .752"
  })));
}, Mn, xn;
function w0() {
  return w0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w0.apply(this, arguments);
}
var f4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", w0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Mn || (Mn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 13.75a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5"
  })), xn || (xn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 11.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5M13.75 12.5v6.25L10 16.875 6.25 18.75V12.5"
  })));
}, Cn, $n;
function _0() {
  return _0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _0.apply(this, arguments);
}
var d4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", _0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Cn || (Cn = /* @__PURE__ */ a.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#Megaphone_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M7.692 7.414V6.132H.002C0 6.501 0 7.103 0 7.414v6.453h7.692v-1.282h-6.41v-5.17z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M17.307 1c-.938.506-.74.402-.938.506l-8.975 4.7a.64.64 0 0 0-.343.568v6.453a.64.64 0 0 0 .343.568l8.975 4.701.938.505V1M16.025 16.87l-7.692-4.03V7.162l7.692-4.03zM5.043 13.226v3.931h-2.18v-3.931H1.581v4.572q0 .243-.003.641h4.7459999999999996v-5.213z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M19.356 6.345h-2.692v1.282h2.051v4.53h-2.05v1.282h3.332V6.986c0-.165.003-.487 0-.64-.333-.002-.452 0-.64 0"
  }))), $n || ($n = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Megaphone_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, Ln, kn, Sn;
function b0() {
  return b0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b0.apply(this, arguments);
}
var w4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", b0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), Ln || (Ln = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 16a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })), kn || (kn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 21a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M6 8a1 1 0 0 1 1 1v1c0 1.762.486 3.275 1.329 4.325C9.152 15.351 10.363 16 12 16c1.636 0 2.848-.649 3.671-1.675C16.514 13.275 17 11.763 17 10V9a1 1 0 1 1 2 0v1c0 2.108-.58 4.095-1.769 5.577C16.022 17.084 14.233 18 12 18s-4.022-.916-5.231-2.423C5.579 14.095 5 12.107 5 10V9a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })), Sn || (Sn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 14c-1.66 0-3-1.34-3-3V5c0-1.66 1.34-3 3-3s3 1.34 3 3v6c0 1.66-1.34 3-3 3",
    clipRule: "evenodd"
  })));
}, yn;
function O0() {
  return O0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O0.apply(this, arguments);
}
var _4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", O0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 18"
  }, t), yn || (yn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M7 12.75A3.754 3.754 0 0 0 10.75 9V4a3.75 3.75 0 0 0-7.5 0v5A3.754 3.754 0 0 0 7 12.75M4.5 4a2.5 2.5 0 1 1 5 0v5a2.5 2.5 0 0 1-5 0zm3.125 11.219v1.906a.625.625 0 1 1-1.25 0v-1.906A6.26 6.26 0 0 1 .75 9 .625.625 0 0 1 2 9a5 5 0 1 0 10 0 .625.625 0 1 1 1.25 0 6.26 6.26 0 0 1-5.625 6.219"
  })));
}, Hn;
function j0() {
  return j0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, j0.apply(this, arguments);
}
var b4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", j0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Hn || (Hn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.904 6.672a.833.833 0 0 0-.737.828v.833c0 1.757.482 3.413 1.474 4.648.852 1.062 2.05 1.772 3.526 1.966v1.72h-2.5a.833.833 0 1 0 0 1.666h6.666a.833.833 0 0 0 0-1.666h-2.5v-1.72a5.5 5.5 0 0 0 1.797-.55l-1.271-1.27a4.3 4.3 0 0 1-1.359.206c-1.364 0-2.373-.54-3.06-1.395-.702-.875-1.107-2.136-1.107-3.605v-.732zM7.502 9.27a2.496 2.496 0 0 0 2.395 2.395zm5.827 2.29 1.199 1.2c.877-1.208 1.305-2.773 1.305-4.427V7.5a.833.833 0 0 0-1.666 0v.833c0 1.27-.303 2.384-.838 3.228m-1.156-1.155L7.5 5.732V4.167c0-1.384 1.117-2.5 2.5-2.5s2.5 1.116 2.5 2.5v5c0 .45-.119.874-.327 1.238M1.225 1.225a.625.625 0 0 1 .884 0L18.775 17.89a.625.625 0 0 1-.884.884L1.225 2.11a.625.625 0 0 1 0-.884",
    clipRule: "evenodd"
  })));
}, Pn;
function E0() {
  return E0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, E0.apply(this, arguments);
}
var O4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", E0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "5 5 22.04 22"
  }, t), Pn || (Pn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M5 5h10.494v10.476H5zM16.543 5h10.493v10.476H16.543zM5 16.524h10.494V27H5zM16.543 16.524h10.493V27H16.543z"
  })));
}, zn, Vn, Bn, Wn;
function M0() {
  return M0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, M0.apply(this, arguments);
}
var j4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", M0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "5 5 22.04 22"
  }, t), zn || (zn = /* @__PURE__ */ a.createElement("path", {
    fill: "#F35325",
    d: "M5 5h10.494v10.476H5z"
  })), Vn || (Vn = /* @__PURE__ */ a.createElement("path", {
    fill: "#81BC06",
    d: "M16.543 5h10.493v10.476H16.543z"
  })), Bn || (Bn = /* @__PURE__ */ a.createElement("path", {
    fill: "#05A6F0",
    d: "M5 16.524h10.494V27H5z"
  })), Wn || (Wn = /* @__PURE__ */ a.createElement("path", {
    fill: "#FFBA08",
    d: "M16.543 16.524h10.493V27H16.543z"
  })));
}, An;
function x0() {
  return x0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x0.apply(this, arguments);
}
var E4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", x0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, t), An || (An = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M0 9h18"
  })));
}, Rn, Fn;
function C0() {
  return C0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C0.apply(this, arguments);
}
var M4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", C0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Rn || (Rn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m9.851 9.403.416.278-.416-.278A1.625 1.625 0 1 1 7.15 7.597 1.625 1.625 0 0 1 9.85 9.403Zm4.688-3.755a2.7 2.7 0 0 1-.598-.898h1.496v1.496a2.7 2.7 0 0 1-.898-.598Zm.899 5.106v1.496H13.94a2.74 2.74 0 0 1 1.496-1.496ZM3.057 12.25H1.564v-1.496a2.74 2.74 0 0 1 1.496 1.496Zm-.597-6.602c-.259.258-.564.461-.898.598V4.75h1.496c-.137.334-.34.64-.598.898Z",
    opacity: 0.2
  })), Fn || (Fn = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M8.5 5.844a2.656 2.656 0 1 0 0 5.312 2.656 2.656 0 0 0 0-5.312m0 4.25a1.594 1.594 0 1 1 0-3.188 1.594 1.594 0 0 1 0 3.188m7.438-6.375H1.063a.53.53 0 0 0-.532.531v8.5a.53.53 0 0 0 .532.531h14.875a.53.53 0 0 0 .53-.531v-8.5a.53.53 0 0 0-.53-.531M1.594 4.78h1.419a2.7 2.7 0 0 1-1.42 1.42zm0 7.438v-1.42a2.7 2.7 0 0 1 1.419 1.42zm13.812 0h-1.419a2.7 2.7 0 0 1 1.42-1.42zm0-2.547a3.77 3.77 0 0 0-2.546 2.547H4.14a3.77 3.77 0 0 0-2.546-2.547V7.328A3.77 3.77 0 0 0 4.14 4.78h8.72a3.77 3.77 0 0 0 2.546 2.547zm0-3.472a2.7 2.7 0 0 1-1.419-1.419h1.42z"
  })));
}, qn, Zn;
function $0() {
  return $0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $0.apply(this, arguments);
}
var x4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", $0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), qn || (qn = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#Moon_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.93 11.922A7.18 7.18 0 0 1 8.078 3.07a7.188 7.188 0 1 0 8.852 8.852"
  }))), Zn || (Zn = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Moon_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
}, Dn, Tn, Gn, Un, Nn, Xn, In, Qn, Kn, Jn;
function L0() {
  return L0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L0.apply(this, arguments);
}
var C4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", L0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Dn || (Dn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.875 8.75V5"
  })), Tn || (Tn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.875 8.75V5"
  })), Gn || (Gn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.75 6.875H15"
  })), Un || (Un = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M18.75 6.875H15"
  })), Nn || (Nn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.125 1.875v2.5"
  })), Xn || (Xn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M13.125 1.875v2.5"
  })), In || (In = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.375 3.125h-2.5"
  })), Qn || (Qn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M14.375 3.125h-2.5"
  })), Kn || (Kn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.927 11.926a7.19 7.19 0 0 1-8.853-8.853h0a7.189 7.189 0 1 0 8.853 8.853z"
  })), Jn || (Jn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.927 11.926a7.19 7.19 0 0 1-8.853-8.853h0a7.189 7.189 0 1 0 8.853 8.853z"
  })));
}, Yn, ta, ea;
function k0() {
  return k0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k0.apply(this, arguments);
}
var $4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", k0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Yn || (Yn = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
  })), ta || (ta = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M16.25 16a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
  })), ea || (ea = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10 17.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M22 17.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })));
}, ra, na;
function S0() {
  return S0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, S0.apply(this, arguments);
}
var L4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", S0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), ra || (ra = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m5.87 5.296.002.001L7.468 8H4.22l1.596-2.703.001-.001a.031.031 0 0 1 .054 0Zm6.546 2.125 3.175 5.36h-4.149l-1.125-1.909 2.045-3.45a.03.03 0 0 1 .011-.012l-.247-.434.247.434a.03.03 0 0 1 .043.011Zm-1.065-3.28.278.416-.278-.415a.828.828 0 1 1-.92-1.378.828.828 0 0 1 .92 1.378Z",
    opacity: 0.2
  })), na || (na = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10.89 5.313a1.859 1.859 0 1 0 0-3.719 1.859 1.859 0 0 0 0 3.718m0-2.657a.797.797 0 1 1 0 1.594.797.797 0 0 1 0-1.594m6.035 10.354-3.623-6.114a1.05 1.05 0 0 0-.914-.521 1.05 1.05 0 0 0-.914.52L9.737 9.829 6.759 4.775a1.063 1.063 0 0 0-1.831 0L.073 13.012a.531.531 0 0 0 .458.8h15.938a.53.53 0 0 0 .456-.802M5.844 5.313l1.565 2.656h-3.13zM1.46 12.75l2.191-3.719h4.383l1.244 2.112.947 1.607zm9.999 0-1.107-1.878 2.035-3.434 3.15 5.312z"
  })));
}, aa;
function y0() {
  return y0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y0.apply(this, arguments);
}
var k4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", y0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 11"
  }, t), aa || (aa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M5.055 7.073a.2.2 0 0 1-.032-.214c.426-.937-.036-1.462.01-3.58.002-.1.08-.196.206-.193a.197.197 0 0 1 .19.202q-.003.14-.003.283c0 .11.09.2.2.198.323-.004.95-.11 1.193-.84l.12-.362A1.236 1.236 0 0 0 6.096.984L4.859.644a1.24 1.24 0 0 0-1.326.462 15.7 15.7 0 0 0-2.81 6.648c-.113.66.201 1.327.78 1.659 3.254 1.861 7.111 2.041 10.606.413a.85.85 0 0 0 .491-.771V5.511a.85.85 0 0 0-.373-.704c-1.253-.85-2.85-.748-3.92.38-.095.1-.059.266.07.32.482.201.94.495 1.32.841a.198.198 0 0 1-.266.295c-.999-.902-2.35-1.313-3.693-.883a.2.2 0 0 0-.136.19c.005.36-.055.709-.219 1.074a.198.198 0 0 1-.328.05"
  })));
}, oa, la;
function H0() {
  return H0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H0.apply(this, arguments);
}
var S4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", H0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), oa || (oa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.313 11.422a1.36 1.36 0 1 1-2.719 0 1.36 1.36 0 0 1 2.719 0ZM2.492 14.508l-.35.35.35-.35a1.36 1.36 0 1 1 1.922-1.922 1.36 1.36 0 0 1-1.922 1.922Z",
    opacity: 0.2
  })), la || (la = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M14.14 1.706a.53.53 0 0 0-.456-.096l-8.5 2.125a.53.53 0 0 0-.403.515v7.31a2.39 2.39 0 1 0 1.063 1.987V7.853l7.437-1.86v3.442a2.39 2.39 0 1 0 1.063 1.987V2.125a.53.53 0 0 0-.205-.42M3.452 14.875a1.328 1.328 0 1 1 0-2.655 1.328 1.328 0 0 1 0 2.655m2.39-8.118V4.665l7.438-1.86v2.092zm6.11 5.993a1.327 1.327 0 1 1 0-2.655 1.327 1.327 0 0 1 0 2.655"
  })));
}, sa, ia;
function P0() {
  return P0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P0.apply(this, arguments);
}
var y4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", P0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), sa || (sa = /* @__PURE__ */ a.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#NonCalculator_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fillRule: "evenodd",
    d: "M4.375 1.875h11.25a1.25 1.25 0 0 1 1.25 1.25v6.533A6 6 0 0 0 15.5 9.5a5.99 5.99 0 0 0-4.563 2.104v-.041a.937.937 0 1 0-.597.873q-.377.631-.591 1.348a.936.936 0 0 0-.249 1.697v.019c0 .941.217 1.832.603 2.625H4.375a1.25 1.25 0 0 1-1.25-1.25V3.125a1.25 1.25 0 0 1 1.25-1.25m1.98 13.592a.938.938 0 1 0 1.04-1.56.938.938 0 0 0-1.04 1.56m0-3.125a.938.938 0 1 0 1.04-1.56.938.938 0 0 0-1.04 1.56m7.837-3.775a.63.63 0 0 0 .183-.442V5a.625.625 0 0 0-.625-.625h-7.5A.625.625 0 0 0 5.625 5v3.125a.625.625 0 0 0 .625.625h7.5a.63.63 0 0 0 .442-.183",
    clipRule: "evenodd"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M15.5 11a4.5 4.5 0 1 0 4.5 4.5 4.51 4.51 0 0 0-4.5-4.5m1.631 5.638a.35.35 0 0 1 0 .493.354.354 0 0 1-.493 0L15.5 15.99l-1.138 1.142a.355.355 0 0 1-.493 0 .35.35 0 0 1 0-.493L15.01 15.5l-1.142-1.138a.35.35 0 0 1 .493-.493L15.5 15.01l1.138-1.142a.35.35 0 0 1 .493.493L15.99 15.5z"
  }))), ia || (ia = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "NonCalculator_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, ca, va;
function z0() {
  return z0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z0.apply(this, arguments);
}
var H4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", z0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), ca || (ca = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#NotePencil_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M10 12.5H7.5V10L15 2.5 17.5 5zM13.125 4.375l2.5 2.5"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M16.875 9.375v6.875a.624.624 0 0 1-.625.625H3.75a.625.625 0 0 1-.625-.625V3.75a.625.625 0 0 1 .625-.625h6.875"
  }))), va || (va = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "NotePencil_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, ha, pa;
function V0() {
  return V0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V0.apply(this, arguments);
}
var P4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", V0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), ha || (ha = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.162 10.656a1.09 1.09 0 0 0 1.067-.85q.151-.67.146-1.357c-.027-3.23-2.703-5.856-5.936-5.824zm0 0h-3.068A2.094 2.094 0 0 0 8 12.75a1.093 1.093 0 0 1-1.458 1.03m6.62-3.124-6.62 3.124m0 0c-2.306-.815-3.917-2.746-3.917-5.28m3.917 5.28L2.625 8.5m0 0c0-1.548.61-3.033 1.699-4.133M2.625 8.5l1.699-4.133m0 0A5.88 5.88 0 0 1 8.44 2.625z",
    opacity: 0.2
  })), pa || (pa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.332 3.579A6.86 6.86 0 0 0 8.5 1.594h-.071A6.906 6.906 0 0 0 1.594 8.5c0 2.855 1.765 5.25 4.606 6.254A2.127 2.127 0 0 0 9.03 12.75a1.063 1.063 0 0 1 1.063-1.062h3.068a2.11 2.11 0 0 0 2.072-1.653 7 7 0 0 0 .172-1.593 6.86 6.86 0 0 0-2.074-4.863m.864 6.223a1.056 1.056 0 0 1-1.034.823h-3.068a2.125 2.125 0 0 0-2.125 2.125 1.063 1.063 0 0 1-1.415 1c-2.404-.847-3.898-2.86-3.898-5.25A5.844 5.844 0 0 1 8.44 2.656h.06a5.867 5.867 0 0 1 5.843 5.794 6 6 0 0 1-.145 1.352zm-4.9-4.755a.797.797 0 1 1-1.593 0 .797.797 0 0 1 1.594 0M6.376 6.64a.797.797 0 1 1-1.594 0 .797.797 0 0 1 1.594 0m0 3.718a.797.797 0 1 1-1.593 0 .797.797 0 0 1 1.593 0m5.844-3.718a.797.797 0 1 1-1.595 0 .797.797 0 0 1 1.595 0"
  })));
}, ua, ga;
function B0() {
  return B0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B0.apply(this, arguments);
}
var z4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", B0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), ua || (ua = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#Pause_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M15.625 3.125H12.5a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h3.125c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625M7.5 3.125H4.375a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625H7.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625"
  }))), ga || (ga = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Pause_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, ma, fa;
function W0() {
  return W0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W0.apply(this, arguments);
}
var V4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", W0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, t), ma || (ma = /* @__PURE__ */ a.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#PeoplePair_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M20.831 27.139a10.312 10.312 0 1 0-11.412 0 16.4 16.4 0 0 0-7.786 5.998 1.34 1.34 0 0 0-.103 1.427 1.39 1.39 0 0 0 1.22.739H27.5a1.39 1.39 0 0 0 1.22-.739 1.34 1.34 0 0 0-.103-1.427 16.4 16.4 0 0 0-7.786-5.998"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M42.642 33.138a16.55 16.55 0 0 0-7.803-5.999A10.295 10.295 0 0 0 29.133 8.25a11 11 0 0 0-2.802.378 1.41 1.41 0 0 0-.928.894 1.38 1.38 0 0 0 .207 1.255 13.03 13.03 0 0 1 .653 14.592 1.39 1.39 0 0 0 .36 1.822q.774.6 1.496 1.237l.086.086a19.4 19.4 0 0 1 4.383 5.999 1.36 1.36 0 0 0 1.237.79h7.683a1.39 1.39 0 0 0 1.22-.739 1.37 1.37 0 0 0-.086-1.426"
  }))), fa || (fa = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "PeoplePair_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h44v44H0z"
  })))));
}, da, wa, _a, ba, Oa, ja;
function A0() {
  return A0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A0.apply(this, arguments);
}
var B4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", A0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, t), da || (da = /* @__PURE__ */ a.createElement("mask", {
    id: "Person_svg__a",
    width: 15,
    height: 8,
    x: -0.238,
    y: 7.734,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M-.238 7.734h15v8h-15z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M13.853 12.895v1.435a.55.55 0 0 1-.463.556 47.3 47.3 0 0 1-12.166 0 .55.55 0 0 1-.462-.556v-1.435c0-2.207 1.505-3.856 3.491-4.155a.48.48 0 0 1 .338.072c.85.53 1.712.806 2.716.806s1.866-.276 2.716-.806a.48.48 0 0 1 .338-.071c1.986.298 3.492 1.947 3.492 4.154m-3.49-3.27a5.8 5.8 0 0 1-3.056.877 5.8 5.8 0 0 1-3.055-.878c-1.519.228-2.663 1.631-2.663 3.27v1.156c1.895.241 3.81.346 5.718.346 1.91 0 3.822-.106 5.718-.347v-1.154c0-1.639-1.143-3.043-2.662-3.27"
  }))), wa || (wa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.853 12.895v1.435a.55.55 0 0 1-.463.556 47.3 47.3 0 0 1-12.166 0 .55.55 0 0 1-.462-.556v-1.435c0-2.207 1.505-3.856 3.491-4.155a.48.48 0 0 1 .338.072c.85.53 1.712.806 2.716.806s1.866-.276 2.716-.806a.48.48 0 0 1 .338-.071c1.986.298 3.492 1.947 3.492 4.154m-3.49-3.27a5.8 5.8 0 0 1-3.056.877 5.8 5.8 0 0 1-3.055-.878c-1.519.228-2.663 1.631-2.663 3.27v1.156c1.895.241 3.81.346 5.718.346 1.91 0 3.822-.106 5.718-.347v-1.154c0-1.639-1.143-3.043-2.662-3.27"
  })), _a || (_a = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.6,
    d: "M13.853 12.895v1.435a.55.55 0 0 1-.463.556 47.3 47.3 0 0 1-12.166 0 .55.55 0 0 1-.462-.556v-1.435c0-2.207 1.505-3.856 3.491-4.155a.48.48 0 0 1 .338.072c.85.53 1.712.806 2.716.806s1.866-.276 2.716-.806a.48.48 0 0 1 .338-.071c1.986.298 3.492 1.947 3.492 4.154Zm-3.49-3.27a5.8 5.8 0 0 1-3.056.877 5.8 5.8 0 0 1-3.055-.878c-1.519.228-2.663 1.631-2.663 3.27v1.156c1.895.241 3.81.346 5.718.346 1.91 0 3.822-.106 5.718-.347v-1.154c0-1.639-1.143-3.043-2.662-3.27Z",
    mask: "url(#Person_svg__a)"
  })), ba || (ba = /* @__PURE__ */ a.createElement("mask", {
    id: "Person_svg__b",
    width: 9,
    height: 9,
    x: 2.672,
    y: -0.266,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M2.672-.266h9v9h-9z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M7.308.734a3.64 3.64 0 0 1 3.637 3.637 3.638 3.638 0 0 1-7.273 0A3.64 3.64 0 0 1 7.308.734m0 .826a2.81 2.81 0 0 0-2.81 2.81 2.81 2.81 0 1 0 2.81-2.81"
  }))), Oa || (Oa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M7.308.734a3.64 3.64 0 0 1 3.637 3.637 3.638 3.638 0 0 1-7.273 0A3.64 3.64 0 0 1 7.308.734m0 .826a2.81 2.81 0 0 0-2.81 2.81 2.81 2.81 0 1 0 2.81-2.81"
  })), ja || (ja = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.6,
    d: "M7.308.734a3.64 3.64 0 0 1 3.637 3.637 3.638 3.638 0 0 1-7.273 0A3.64 3.64 0 0 1 7.308.734Zm0 .826a2.81 2.81 0 0 0-2.81 2.81 2.81 2.81 0 1 0 2.81-2.81Z",
    mask: "url(#Person_svg__b)"
  })));
}, Ea, Ma;
function R0() {
  return R0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R0.apply(this, arguments);
}
var W4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", R0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Ea || (Ea = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m6.858 8.627.109-.413-.39-.172-3.781-1.664c-.289-.137-.19-.566.126-.566h11.156c.313 0 .414.43.125.566l-3.78 1.664-.39.172.108.413L11.66 14.4l.01.04.017.037a.297.297 0 0 1-.37.402l-.168.47.168-.47a.3.3 0 0 1-.168-.15l-.008-.018-.01-.016-2.199-3.79-.432-.745-.433.745-2.2 3.79-.009.016-.008.017a.3.3 0 0 1-.167.15l.167.472-.167-.471a.297.297 0 0 1-.37-.402l.016-.037.01-.04zm.548-5.97a1.094 1.094 0 1 1 2.187 0 1.094 1.094 0 0 1-2.187 0Z",
    opacity: 0.2
  })), Ma || (Ma = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10.625 2.656a2.125 2.125 0 1 0-4.25 0 2.125 2.125 0 0 0 4.25 0M8.5 3.72a1.062 1.062 0 1 1 0-2.125 1.062 1.062 0 0 1 0 2.125m6.873 2.105a1.3 1.3 0 0 0-1.295-1.043H2.922a1.328 1.328 0 0 0-.557 2.534l.01.004 3.37 1.484-1.395 5.294a1.33 1.33 0 0 0 2.423 1.098l1.727-2.98 1.727 2.98a1.328 1.328 0 0 0 2.417-1.098l-1.395-5.294 3.37-1.484.009-.004a1.304 1.304 0 0 0 .745-1.49m-1.182.525-3.78 1.665a.53.53 0 0 0-.3.621l1.519 5.775q.01.047.032.09a.266.266 0 1 1-.481.224l-.023-.042-2.198-3.791a.532.532 0 0 0-.92 0L5.845 14.68l-.023.042a.266.266 0 1 1-.481-.225.5.5 0 0 0 .032-.09L6.89 8.634a.53.53 0 0 0-.3-.622L2.81 6.35a.266.266 0 0 1 .113-.505h11.156a.266.266 0 0 1 .115.505z"
  })));
}, xa, Ca;
function F0() {
  return F0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F0.apply(this, arguments);
}
var A4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", F0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, t), xa || (xa = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#Pin_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M20 19.25a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M20 19.25a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M20 36.75v-17.5"
  }))), Ca || (Ca = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Pin_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 .5h40v40H0z"
  })))));
}, $a, La;
function q0() {
  return q0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, q0.apply(this, arguments);
}
var R4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", q0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), $a || ($a = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.844 8.5a5.344 5.344 0 1 1-10.688 0 5.344 5.344 0 0 1 10.688 0Z",
    opacity: 0.2
  })), La || (La = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.277 4.03c-.508-.876-1.849-1.074-3.885-.576A6.37 6.37 0 0 0 2.177 9.317C.338 11.223.365 12.351.724 12.97c.338.587 1.045.842 1.975.842a8.2 8.2 0 0 0 1.912-.265 6.37 6.37 0 0 0 10.213-5.86c.83-.864 1.382-1.684 1.57-2.386.13-.486.09-.914-.117-1.272M8.5 3.186a5.32 5.32 0 0 1 5.18 4.13c-1.133 1.067-2.666 2.161-4.122 2.998-1.83 1.05-3.417 1.704-4.682 2.063A5.308 5.308 0 0 1 8.5 3.188m-6.857 9.25c-.097-.167-.043-.48.147-.863.189-.358.418-.694.684-1a6.4 6.4 0 0 0 1.195 2.08c-1.146.193-1.86.07-2.026-.217M8.5 13.812a5.3 5.3 0 0 1-2.56-.66 24.6 24.6 0 0 0 4.145-1.916c1.433-.823 2.701-1.715 3.723-2.595A5.317 5.317 0 0 1 8.5 13.812m6.868-8.786c-.113.42-.411.899-.839 1.403a6.4 6.4 0 0 0-1.195-2.081c.943-.157 1.817-.145 2.025.215q.09.157.009.463"
  })));
}, ka, Sa;
function Z0() {
  return Z0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z0.apply(this, arguments);
}
var F4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Z0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), ka || (ka = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M13.675 8.719c-1.075 1-2.55 1.196-4.11.31-.886-1.56-.69-3.034.31-4.109 1-1.073 2.882-1.83 5.559-1.76.07 2.677-.685 4.559-1.76 5.559Zm-8.166 1.04c-1.051.583-2.023.439-2.732-.221S1.542 7.625 1.563 5.813c1.813-.021 3.065.505 3.725 1.214s.805 1.68.221 2.732Z",
    opacity: 0.2
  })), Sa || (Sa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.444 2.649a.53.53 0 0 0-.5-.5c-3.436-.199-6.196.847-7.382 2.804-.784 1.294-.783 2.866-.01 4.366a4.7 4.7 0 0 0-.942 1.79l-1.08-1.082c.519-1.084.5-2.215-.067-3.153-.879-1.447-2.902-2.226-5.414-2.075a.53.53 0 0 0-.5.5c-.148 2.512.628 4.535 2.075 5.412a3.04 3.04 0 0 0 1.589.445 3.6 3.6 0 0 0 1.564-.376l1.66 1.66v1.904a.531.531 0 1 0 1.063 0v-1.959a3.7 3.7 0 0 1 .815-2.324 4.9 4.9 0 0 0 2.212.558 4.05 4.05 0 0 0 2.114-.588c1.957-1.185 3.005-3.945 2.803-7.382M5.714 9.213l-1.62-1.62a.531.531 0 0 0-.751.751l1.62 1.62c-.637.212-1.256.16-1.788-.162-1.019-.617-1.595-2.078-1.581-3.958 1.88-.017 3.34.562 3.958 1.58.322.533.374 1.152.163 1.79m7.376-.09c-.89.538-1.936.58-2.998.133l3.565-3.566a.531.531 0 0 0-.751-.752L9.34 8.5c-.449-1.062-.408-2.109.133-2.998.925-1.528 3.12-2.378 5.932-2.313.064 2.81-.786 5.008-2.315 5.934"
  })));
}, ya;
function D0() {
  return D0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D0.apply(this, arguments);
}
var q4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", D0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 18"
  }, t), ya || (ya = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.824 8.467 2.576 1.593a.625.625 0 0 0-.951.533v13.748a.625.625 0 0 0 .95.533l11.25-6.874a.626.626 0 0 0 0-1.066"
  })));
}, Ha, Pa;
function T0() {
  return T0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T0.apply(this, arguments);
}
var Z4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", T0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, t), Ha || (Ha = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#PlayCircleFilled_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M20 5a15 15 0 1 0 0 30 15 15 0 0 0 0-30m-2.5 20V15l7.5 5z",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15Z"
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m25 20-7.5-5v10z"
  }))), Pa || (Pa = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "PlayCircleFilled_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h40v40H0z"
  })))));
}, za, Va;
function G0() {
  return G0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G0.apply(this, arguments);
}
var D4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", G0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, t), za || (za = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.3 14V0h1.4v14z",
    clipRule: "evenodd"
  })), Va || (Va = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 7.7H0V6.3h14z",
    clipRule: "evenodd"
  })));
}, Ba, Wa;
function U0() {
  return U0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U0.apply(this, arguments);
}
var T4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", U0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Ba || (Ba = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
  })), Wa || (Wa = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.875 10h6.25M10 6.875v6.25"
  })));
}, Aa;
function N0() {
  return N0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N0.apply(this, arguments);
}
var G4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", N0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Aa || (Aa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M29.762 12.46c-.53-.555-1.079-1.126-1.286-1.628-.191-.46-.202-1.222-.213-1.96-.022-1.373-.044-2.928-1.126-4.01-1.08-1.08-2.636-1.103-4.009-1.125-.738-.01-1.5-.022-1.96-.213-.5-.207-1.073-.755-1.627-1.286C18.57 1.306 17.468.25 16 .25s-2.57 1.056-3.54 1.988c-.555.53-1.126 1.079-1.628 1.286-.457.191-1.222.202-1.96.213-1.373.022-2.928.044-4.01 1.125-1.08 1.082-1.096 2.637-1.125 4.01-.01.738-.022 1.5-.213 1.96-.207.5-.755 1.073-1.286 1.627C1.306 13.43.25 14.532.25 16s1.056 2.57 1.988 3.54c.53.555 1.079 1.126 1.286 1.628.191.46.202 1.222.213 1.96.022 1.373.044 2.928 1.125 4.01 1.082 1.08 2.637 1.103 4.01 1.124.738.012 1.5.023 1.96.214.5.207 1.073.755 1.627 1.286.97.932 2.073 1.988 3.541 1.988s2.57-1.056 3.54-1.988c.555-.53 1.126-1.079 1.628-1.286.46-.191 1.222-.202 1.96-.213 1.373-.022 2.928-.044 4.01-1.126 1.08-1.08 1.103-2.636 1.124-4.009.012-.738.023-1.5.214-1.96.207-.5.755-1.073 1.286-1.627.932-.97 1.988-2.073 1.988-3.541s-1.056-2.57-1.988-3.54M16 25a1.687 1.687 0 1 1 0-3.375A1.687 1.687 0 0 1 16 25m1.125-6.851v.101a1.125 1.125 0 1 1-2.25 0v-1.125A1.125 1.125 0 0 1 16 16c1.86 0 3.375-1.266 3.375-2.812 0-1.547-1.515-2.813-3.375-2.813s-3.375 1.266-3.375 2.813v.562a1.125 1.125 0 1 1-2.25 0v-.562c0-2.792 2.523-5.063 5.625-5.063s5.625 2.271 5.625 5.063c0 2.444-1.935 4.49-4.5 4.96"
  })));
}, Ra;
function X0() {
  return X0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X0.apply(this, arguments);
}
var U4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", X0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, t), Ra || (Ra = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10.587 4.82c-.176-.185-.36-.375-.428-.543-.064-.153-.068-.407-.072-.653-.006-.458-.014-.976-.374-1.336-.361-.361-.88-.368-1.337-.375-.246-.004-.5-.008-.653-.072-.167-.069-.358-.251-.543-.428C6.857 1.102 6.49.75 6 .75s-.856.352-1.18.663c-.185.177-.375.36-.543.428-.152.064-.407.068-.653.072-.458.007-.976.014-1.336.375-.361.36-.366.878-.375 1.336-.004.246-.008.5-.072.653-.069.167-.251.358-.428.543C1.102 5.143.75 5.51.75 6s.352.856.663 1.18c.177.185.36.375.428.543.064.153.068.407.072.653.007.458.014.976.375 1.337.36.36.878.368 1.336.375.246.003.5.007.653.07.167.07.358.253.543.43.323.31.69.662 1.18.662s.856-.352 1.18-.663c.185-.176.375-.36.543-.428.153-.064.407-.068.653-.072.458-.006.976-.014 1.337-.374.36-.361.368-.88.375-1.337.003-.246.007-.5.07-.653.07-.167.253-.358.43-.543.31-.323.662-.69.662-1.18s-.352-.856-.663-1.18m-.541 1.841c-.225.235-.457.477-.58.775-.119.286-.124.612-.128.929-.005.328-.01.672-.156.817s-.487.15-.817.155c-.317.005-.643.01-.93.128-.297.124-.54.356-.774.58-.234.225-.473.455-.661.455-.187 0-.429-.23-.661-.454s-.477-.457-.775-.58c-.286-.119-.612-.124-.929-.128-.328-.005-.672-.01-.817-.156s-.15-.487-.155-.817c-.005-.317-.01-.643-.128-.93-.124-.297-.356-.54-.58-.774C1.73 6.427 1.5 6.188 1.5 6c0-.187.23-.429.454-.661s.457-.477.58-.775c.119-.286.124-.612.129-.929.004-.328.01-.672.155-.817.146-.145.487-.15.817-.155.317-.005.643-.01.93-.128.297-.124.54-.356.774-.58.234-.225.473-.455.661-.455s.429.23.661.454.477.457.775.58c.286.119.612.124.929.129.328.004.672.01.817.155.145.146.15.487.155.817.005.317.01.643.128.93.124.297.356.54.58.774.225.234.455.473.455.661s-.23.429-.454.661M6.563 8.438a.562.562 0 1 1-1.125 0 .562.562 0 0 1 1.125 0m1.312-3.376c0 .815-.645 1.497-1.5 1.654v.034a.375.375 0 0 1-.75 0v-.375A.375.375 0 0 1 6 6c.62 0 1.125-.422 1.125-.937S6.62 4.125 6 4.125s-1.125.422-1.125.938v.187a.375.375 0 1 1-.75 0v-.187c0-.931.84-1.688 1.875-1.688 1.034 0 1.875.757 1.875 1.688"
  })));
}, Fa;
function I0() {
  return I0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, I0.apply(this, arguments);
}
var N4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", I0({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23"
  }, t), Fa || (Fa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.108 4.556v17.018s-3.742-3.92-8.02-3.564c-2.583.178-2.583-.089-2.583-3.564V1.17C3.683-.345 5.465.01 6.535.1c1.158.09 5.078.713 7.573 4.456M1.812 3.04v10.87c0 4.01.178 5.792 4.9 5.614 5.792-.267 7.04 3.386 7.04 3.475 0 0-3.565-1.871-7.93-1.871-1.426.089-4.1 1.07-4.99.178-1.07-.98-.802-3.653-.802-5.703V5.001c0-.98.445-2.317 1.782-1.96m26.285 0v10.87c0 4.01-.178 5.792-4.9 5.614-5.792-.267-7.04 3.386-7.04 3.475 0 0 3.565-1.871 7.93-1.871 1.426.089 4.1 1.07 4.99.178.98-.98.802-3.653.802-5.703V5.001c0-.98-.445-2.317-1.782-1.96M15.801 4.556v17.018s3.742-3.92 8.02-3.564c2.583.178 2.583-.089 2.583-3.564V1.17C26.226-.345 24.444.01 23.374.1c-1.158.09-5.078.713-7.573 4.456"
  })));
}, qa, Za;
function Q0() {
  return Q0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Q0.apply(this, arguments);
}
var X4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Q0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), qa || (qa = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M5.846 2.528C2.989 4.02 1.25 6.941 1.25 10.172a8.55 8.55 0 0 0 8.57 8.577c4.72 0 8.572-3.853 8.572-8.577 0-3.107-1.677-5.966-4.348-7.52"
  })), Za || (Za = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m13.448 1.994-.062-.697-.697.062.062.697zm1.194 5.496-.496-5.558-1.395.124.497 5.56zm-1.131-4.799 5.555-.497L18.941.8l-5.555.497z"
  })));
}, Da, Ta;
function K0() {
  return K0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K0.apply(this, arguments);
}
var I4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", K0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Da || (Da = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25 28H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12l7 7v16a1 1 0 0 1-1 1"
  })), Ta || (Ta = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 4v7h7M12 17h8M12 21h8"
  })));
}, Ga;
function J0() {
  return J0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J0.apply(this, arguments);
}
var Q4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", J0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Ga || (Ga = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.625 3.75h-5v-2.5a.625.625 0 1 0-1.25 0v2.5h-5a2.51 2.51 0 0 0-2.5 2.5V15a2.51 2.51 0 0 0 2.5 2.5h11.25a2.51 2.51 0 0 0 2.5-2.5V6.25a2.51 2.51 0 0 0-2.5-2.5m-10 4.688a.937.937 0 1 1 1.875 0 .937.937 0 0 1-1.875 0m2.188 5.937h-.625a1.25 1.25 0 0 1 0-2.5h.625zm3.125 0H9.062v-2.5h1.876zm1.874 0h-.624v-2.5h.624a1.25 1.25 0 0 1 0 2.5m.626-5a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874"
  })));
}, Ua, Na;
function Y0() {
  return Y0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Y0.apply(this, arguments);
}
var K4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Y0({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, t), Ua || (Ua = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M31.65 8.75H9.15A3.75 3.75 0 0 0 5.4 12.5V30a3.75 3.75 0 0 0 3.75 3.75h22.5A3.75 3.75 0 0 0 35.4 30V12.5a3.75 3.75 0 0 0-3.75-3.75m-5.625 20h-11.25a3.125 3.125 0 1 1 0-6.25h11.25a3.125 3.125 0 1 1 0 6.25",
    opacity: 0.2
  })), Na || (Na = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M31.65 7.5h-10v-5a1.25 1.25 0 0 0-2.5 0v5h-10a5 5 0 0 0-5 5V30a5 5 0 0 0 5 5h22.5a5 5 0 0 0 5-5V12.5a5 5 0 0 0-5-5m2.5 22.5a2.5 2.5 0 0 1-2.5 2.5H9.15a2.5 2.5 0 0 1-2.5-2.5V12.5a2.5 2.5 0 0 1 2.5-2.5h22.5a2.5 2.5 0 0 1 2.5 2.5zm-8.125-8.75h-11.25a4.375 4.375 0 1 0 0 8.75h11.25a4.375 4.375 0 1 0 0-8.75m-4.375 2.5v3.75h-2.5v-3.75zm-8.75 1.875a1.875 1.875 0 0 1 1.875-1.875h1.875v3.75h-1.875a1.875 1.875 0 0 1-1.875-1.875M26.025 27.5H24.15v-3.75h1.875a1.875 1.875 0 1 1 0 3.75M11.65 16.875a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0m13.75 0a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0"
  })));
}, Xa, Ia, Qa, Ka;
function t5() {
  return t5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t5.apply(this, arguments);
}
var J4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", t5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 19"
  }, t), Xa || (Xa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M9.25 16.875h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25"
  })), Ia || (Ia = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.12,
    d: "M9.25 16.875h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25"
  })), Qa || (Qa = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m15.156 11.242-2.36-2.836a9.8 9.8 0 0 0-.624-2.726c-.906-2.36-2.508-3.907-3.39-4.618a1.24 1.24 0 0 0-1.563-.007c-.89.71-2.516 2.257-3.43 4.617a9.5 9.5 0 0 0-.633 2.789L.844 11.242a1.26 1.26 0 0 0-.266 1.07l.969 4.344a1.24 1.24 0 0 0 1.226.977 1.25 1.25 0 0 0 .774-.274l2.172-1.734h4.562l2.172 1.734a1.25 1.25 0 0 0 2-.703l.969-4.343a1.26 1.26 0 0 0-.266-1.07m-12.39 5.14-.961-4.343 1.398-1.68q.274 2.196 1.492 4.485zM8 8.438a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m5.234 7.946-1.937-1.547c.812-1.54 1.297-3.047 1.469-4.516l1.43 1.719z"
  })), Ka || (Ka = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.12,
    d: "m15.156 11.242-2.36-2.836a9.8 9.8 0 0 0-.624-2.726c-.906-2.36-2.508-3.907-3.39-4.618a1.24 1.24 0 0 0-1.563-.007c-.89.71-2.516 2.257-3.43 4.617a9.5 9.5 0 0 0-.633 2.789L.844 11.242a1.26 1.26 0 0 0-.266 1.07l.969 4.344a1.24 1.24 0 0 0 1.226.977 1.25 1.25 0 0 0 .774-.274l2.172-1.734h4.562l2.172 1.734a1.25 1.25 0 0 0 2-.703l.969-4.343a1.26 1.26 0 0 0-.266-1.07m-12.39 5.14-.961-4.343 1.398-1.68q.274 2.196 1.492 4.485zM8 8.438a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m5.234 7.946-1.937-1.547c.812-1.54 1.297-3.047 1.469-4.516l1.43 1.719z"
  })));
}, Ja;
function e5() {
  return e5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, e5.apply(this, arguments);
}
var Y4 = function(t) {
  return /* @__PURE__ */ a.createElement("svg", e5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Ja || (Ja = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M12.971 23.242C12.922 23.436 11.704 28 5 28a1 1 0 0 1-1-1c0-6.704 4.564-7.923 4.757-7.971a1 1 0 0 1 .485 1.94c-.112.032-2.802.818-3.195 4.983 4.166-.392 4.953-3.077 4.986-3.202a1 1 0 1 1 1.938.5zm11.625-8.425-.596.597v7.29a2 2 0 0 1-.585 1.42l-4.29 4.288a1.99 1.99 0 0 1-2.05.484 1.99 1.99 0 0 1-1.348-1.615l-.67-4.811-5.527-5.526-4.809-.672a2 2 0 0 1-1.134-3.397l4.288-4.29A2 2 0 0 1 9.295 8h7.291l.597-.596c3.334-3.334 7.353-3.478 8.926-3.384a2 2 0 0 1 1.875 1.875c.091 1.569-.053 5.587-3.387 8.922M5 14.292l4.644.648L14.586 10H9.295zM11.415 16 16 20.585l7.181-7.181a9.56 9.56 0 0 0 2.803-7.395 9.58 9.58 0 0 0-7.389 2.808zM22 17.414l-4.941 4.94.65 4.646L22 22.705z"
  })));
}, Ya;
function r5() {
  return r5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r5.apply(this, arguments);
}
var tl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", r5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, t), Ya || (Ya = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M12.188 7.969H2.813a.937.937 0 0 0-.938.937v2.344a.937.937 0 0 0 .938.938h9.375a.94.94 0 0 0 .937-.938V8.906a.94.94 0 0 0-.937-.937m0 3.281H2.813V8.906h9.375zm0-8.437H2.813a.937.937 0 0 0-.938.937v2.344a.937.937 0 0 0 .938.937h9.375a.937.937 0 0 0 .937-.937V3.75a.94.94 0 0 0-.937-.937m0 3.28H2.813V3.75h9.375z"
  })));
}, t3, e3;
function n5() {
  return n5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, n5.apply(this, arguments);
}
var el = function(t) {
  return /* @__PURE__ */ a.createElement("svg", n5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), t3 || (t3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m14.897 5.646.001-.001a.03.03 0 0 0 .01-.022.03.03 0 0 0-.01-.022V5.6l-3.5-3.497a.031.031 0 0 0-.044 0l-9.251 9.253zm0 0-9.251 9.251m9.251-9.251-9.251 9.251m0 0a.03.03 0 0 1-.044 0m.044 0h-.044m0 0-3.5-3.496a.03.03 0 0 1 0-.044z",
    opacity: 0.2
  })), e3 || (e3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m15.626 4.872-3.499-3.498a1.063 1.063 0 0 0-1.503 0l-9.251 9.251a1.06 1.06 0 0 0 0 1.503l3.499 3.498a1.06 1.06 0 0 0 1.503 0l9.251-9.25a1.06 1.06 0 0 0 0-1.504M5.623 14.875l-3.498-3.499L4.25 9.251l1.749 1.75a.53.53 0 1 0 .751-.752L5 8.5l1.375-1.374 1.749 1.75a.532.532 0 1 0 .751-.752l-1.75-1.749L8.5 5.001l1.749 1.75A.53.53 0 1 0 11 5.999L9.25 4.25l2.126-2.125 3.499 3.499z"
  })));
}, r3, n3;
function a5() {
  return a5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a5.apply(this, arguments);
}
var rl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", a5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), r3 || (r3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m2.098 11.243 1.62-4.053 1.622 4.053c-.028.314-.212.543-.512.718a2.35 2.35 0 0 1-1.11.289c-.327 0-.768-.09-1.109-.289-.3-.175-.483-.404-.511-.718Zm10.074-1.407c-.3-.174-.484-.404-.512-.718l1.621-4.053 1.621 4.053c-.028.314-.212.544-.511.718a2.35 2.35 0 0 1-1.11.289c-.327 0-.768-.09-1.11-.289Z",
    opacity: 0.2
  })), n3 || (n3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.9 8.832 13.775 3.52a.53.53 0 0 0-.609-.322l-4.135.92V2.655a.531.531 0 1 0-1.062 0v1.699l-4.366.97a.53.53 0 0 0-.378.32v.004L1.1 10.957a.5.5 0 0 0-.037.2c0 1.547 1.63 2.124 2.656 2.124s2.656-.577 2.656-2.125a.5.5 0 0 0-.038-.199l-1.893-4.73 3.525-.782v8.368H6.906a.531.531 0 0 0 0 1.062h3.188a.531.531 0 0 0 0-1.062H9.03V5.208l3.387-.752-1.755 4.376a.5.5 0 0 0-.038.2c0 1.547 1.63 2.124 2.656 2.124s2.656-.577 2.656-2.125a.5.5 0 0 0-.037-.199M3.719 12.219c-.5 0-1.512-.24-1.59-.972l1.59-3.973 1.589 3.973c-.078.732-1.09.972-1.59.972m9.562-2.125c-.5 0-1.511-.24-1.589-.972l1.59-3.973 1.588 3.973c-.077.732-1.089.972-1.589.972"
  })));
}, a3, o3;
function o5() {
  return o5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o5.apply(this, arguments);
}
var nl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", o5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 17"
  }, t), a3 || (a3 = /* @__PURE__ */ a.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#School_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "m12.901.288-.433.76c-.064.112-.047.215.017.327.142.249.27.504.419.786-.097.01-.163.02-.229.02h-2.109c-.198 0-.213.015-.213.217v1.606c0 .228.02.245.246.245h3.115c.168 0 .194.024.194.192v1.567c0 .246.025.273.27.273h5.03c.367 0 .367 0 .367.372v8.21c0 .253.008.263.257.26.12 0 .17.042.168.163a20 20 0 0 0 0 .656c.002.116-.05.155-.161.155q-3.442-.005-6.886-.005h-.182c-.175-.006-.19-.022-.19-.195v-2.182q.003-.226-.026-.448a2.64 2.64 0 0 0-1.623-2.014 2.48 2.48 0 0 0-1.614-.076c-.467.13-.887.388-1.214.746a2.7 2.7 0 0 0-.557.926c-.112.292-.127.589-.128.891-.003.698 0 1.399 0 2.095 0 .253-.005.257-.255.257H.18c-.121 0-.183-.035-.179-.167q.008-.323 0-.643c0-.12.05-.165.168-.163.392.009.362.038.362-.357V6.619c0-.344 0-.344.348-.344H5.67c.52 0 .415-.045.418-.416.005-.47 0-.94 0-1.41 0-.182.023-.205.198-.205H9.43c.184 0 .21-.022.21-.208V.18c0-.172.008-.184.178-.184a4 4 0 0 1 .406.006c.047.005.125.065.127.103.007.136.085.144.188.143h2.11q.128.011.253.039m-1.306 6.609c.013-.952-.761-1.604-1.6-1.601-.861 0-1.6.681-1.6 1.635 0 .892.788 1.635 1.664 1.599.784-.032 1.577-.696 1.537-1.633m4.227 6.645v-.895c0-.117-.043-.182-.172-.182h-1.773c-.148 0-.206.06-.207.205v1.76c0 .135.064.19.198.19h1.76c.167 0 .192-.03.194-.2.003-.292 0-.585 0-.878m0-3.38v-.85c0-.182-.037-.221-.224-.224-.27-.004-.54 0-.809 0h-.907c-.162 0-.216.056-.217.205v1.73c0 .168.032.197.198.198q.879.005 1.758 0c.168 0 .194-.027.196-.195.008-.287.006-.575.006-.862zM5.318 14.622h.865c.168 0 .202-.025.203-.19q.004-.887 0-1.772c0-.161-.044-.194-.203-.194-.573 0-1.144.005-1.716 0-.14 0-.197.049-.197.184v1.813c0 .116.046.168.168.164.294-.01.587-.005.88-.005m12.534 0h.85c.188 0 .218-.027.219-.218v-1.731c0-.107-.022-.208-.168-.207-.591 0-1.182.003-1.773 0-.127 0-.179.062-.179.177v1.814c0 .124.06.168.184.168.288-.008.577-.004.865-.004zm-15.45 0c.293 0 .586-.004.88 0 .111 0 .161-.043.16-.155v-1.812c0-.103-.011-.194-.156-.192q-.885.006-1.772 0c-.127 0-.18.064-.18.178v1.8c0 .127.055.182.187.18q.44-.003.88.001zM16.8 10.15v.88c0 .172.021.19.197.19h1.716c.183 0 .207-.021.207-.21V9.307c0-.18-.045-.224-.224-.224h-1.688c-.177 0-.208.032-.209.214v.854zm-12.53.005v.866c0 .186.017.2.2.2h1.69c.208 0 .228-.016.228-.22v-1.69c0-.185-.04-.224-.22-.224H4.477c-.171 0-.206.033-.207.203q-.001.433 0 .865m-.828.014v-.895c0-.121-.038-.192-.177-.192-.581.004-1.163 0-1.745 0-.128 0-.188.056-.188.185 0 .591.004 1.182 0 1.773 0 .133.056.181.184.18q.88-.004 1.759 0c.12 0 .168-.041.168-.162-.005-.293-.002-.59-.002-.889z"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M9.81 6.391v-.473a.5.5 0 0 1 .01-.125c.026-.08.038-.182.165-.168.118.014.136.1.136.193v.752c0 .25.008.254.26.257q.174-.007.346.019a.18.18 0 0 1 .112.125.17.17 0 0 1-.095.134q-.24.034-.482.037c-.42.013-.472-.013-.455-.447.006-.099.002-.201.002-.304"
  }))), o3 || (o3 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "School_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v16.097H0z"
  })))));
}, l3;
function l5() {
  return l5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, l5.apply(this, arguments);
}
var al = function(t) {
  return /* @__PURE__ */ a.createElement("svg", l5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 15"
  }, t), l3 || (l3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M6.5 6.094c0-.125.053-.244.146-.332A.52.52 0 0 1 7 5.625h4c.133 0 .26.05.354.137a.46.46 0 0 1 .146.332.46.46 0 0 1-.146.331.52.52 0 0 1-.354.138H7a.52.52 0 0 1-.354-.138.45.45 0 0 1-.146-.331M7 8.437h4c.133 0 .26-.049.354-.137a.46.46 0 0 0 .146-.331.46.46 0 0 0-.146-.332A.52.52 0 0 0 11 7.5H7c-.133 0-.26.05-.354.137a.45.45 0 0 0-.146.332c0 .124.053.243.146.331.094.088.221.137.354.137m8 2.813c0 .497-.21.974-.586 1.326a2.07 2.07 0 0 1-1.414.549H6a2.07 2.07 0 0 1-1.414-.55A1.82 1.82 0 0 1 4 11.25v-7.5a.9.9 0 0 0-.293-.663A1.03 1.03 0 0 0 3 2.812c-.265 0-.52.1-.707.275A.9.9 0 0 0 2 3.75c0 .336.302.564.305.566a.47.47 0 0 1 .174.236.44.44 0 0 1-.006.287.47.47 0 0 1-.182.23.52.52 0 0 1-.59-.007C1.628 5.012 1 4.547 1 3.75c0-.497.21-.974.586-1.326A2.07 2.07 0 0 1 3 1.875h8.5c.53 0 1.04.198 1.414.55.375.35.586.828.586 1.325v6.094h.5c.108 0 .213.033.3.094.075.05.7.515.7 1.312m-8.484-1.085a.48.48 0 0 1 .187-.234A.53.53 0 0 1 7 9.844h5.5V3.75a.9.9 0 0 0-.293-.663 1.03 1.03 0 0 0-.707-.275H4.73c.177.285.27.609.27.938v7.5c0 .249.105.487.293.663.187.176.442.274.707.274s.52-.098.707-.274A.9.9 0 0 0 7 11.25c0-.336-.302-.564-.305-.566a.46.46 0 0 1-.18-.232.43.43 0 0 1 .001-.287M14 11.25a.7.7 0 0 0-.202-.469H7.923q.075.23.076.469c0 .33-.092.653-.268.938H13c.265 0 .52-.1.707-.275A.9.9 0 0 0 14 11.25"
  })));
}, s3;
function s5() {
  return s5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s5.apply(this, arguments);
}
var ol = function(t) {
  return /* @__PURE__ */ a.createElement("svg", s5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, t), s3 || (s3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.111 15.223A7.111 7.111 0 1 0 8.111 1a7.111 7.111 0 0 0 0 14.223M17 17l-3.867-3.867"
  })));
}, i3;
function i5() {
  return i5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i5.apply(this, arguments);
}
var ll = function(t) {
  return /* @__PURE__ */ a.createElement("svg", i5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), i3 || (i3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.426 2.803 1.869 6.909a.625.625 0 0 0-.098 1.166l6.688 3.168c.13.062.236.167.298.298l3.168 6.688a.626.626 0 0 0 1.166-.098l4.106-14.557a.626.626 0 0 0-.771-.771M8.661 11.339l3.536-3.536"
  })));
}, c3;
function c5() {
  return c5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c5.apply(this, arguments);
}
var sl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", c5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 416 400"
  }, t), c3 || (c3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M207.897 161.735c-2.122 0-4.243-2.041-4.774-4.592l-9.015-109.694C191.456 18.878 197.29 0 207.897 0c11.137 0 16.44 18.878 13.789 47.449l-9.016 109.694c-.531 3.061-2.652 4.592-4.773 4.592M252.443 146.429c-1.591-1.531-2.121-4.082-1.061-5.613l51.974-62.755c13.259-16.326 27.578-22.449 35.003-14.796 7.955 7.653 1.591 20.919-15.38 33.674l-65.232 50c-1.061 1.53-3.713 1.02-5.304-.51M247.142 200c0-2.041 2.121-4.082 4.773-4.592l114.024-8.673c29.699-2.551 49.322 3.061 49.322 13.265 0 10.714-19.623 15.816-49.322 13.265l-114.024-8.673c-2.652-.51-4.773-2.551-4.773-4.592M252.443 240.816c1.591-1.53 4.242-2.041 5.833-1.02l65.233 50c16.971 12.755 23.335 26.531 15.38 33.673-7.955 7.653-21.744 1.531-35.003-14.796l-51.974-62.755c-1.591-1.02-1.06-3.571.531-5.102M207.895 238.265c2.122 0 4.243 2.041 4.773 4.592l9.016 109.694c2.652 28.571-3.182 47.449-13.789 47.449-11.137 0-16.44-18.878-13.789-47.449l9.016-109.694c0-3.061 2.122-4.592 4.773-4.592M154.331 240.816c1.591 1.531 2.121 4.082 1.061 5.613l-51.974 62.755C90.159 325.51 75.84 331.633 68.415 323.98c-7.955-7.653-1.59-20.919 15.38-33.674l65.233-50c1.06-1.53 3.712-1.02 5.303.51M168.119 200c0 2.041-2.121 4.082-4.773 4.592l-114.024 8.673C19.622 215.816 0 210.204 0 200c0-10.714 19.623-15.816 49.322-13.265l114.024 8.673c2.652.51 4.773 2.551 4.773 4.592M154.332 146.429c-1.591 1.53-4.243 2.04-5.834 1.02l-65.232-50c-16.971-12.755-23.336-26.53-15.38-33.673 7.955-7.654 21.744-1.531 35.002 14.795l51.974 62.756c1.591 1.02 1.061 3.571-.53 5.102",
    clipRule: "evenodd"
  })));
}, v3, h3, p3, u3, g3, m3, f3, d3, w3;
function v5() {
  return v5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v5.apply(this, arguments);
}
var il = function(t) {
  return /* @__PURE__ */ a.createElement("svg", v5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "SenecaLoader_svg__senecaLoader",
    viewBox: "0 0 416 400"
  }, t), v3 || (v3 = /* @__PURE__ */ a.createElement("style", null, "@keyframes loading{0%{opacity:1}to{opacity:0}}.SenecaLoader_svg__SenecaLoader__spoke{animation:loading .8s linear infinite}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(1){animation-delay:-.7s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(2){animation-delay:-.6s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(3){animation-delay:-.5s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(4){animation-delay:-.4s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(5){animation-delay:-.3s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(6){animation-delay:-.2s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(7){animation-delay:-.1s}.SenecaLoader_svg__SenecaLoader__spoke:nth-child(8){animation-delay:0s}")), h3 || (h3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__1",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M207.897 161.735c-2.122 0-4.243-2.041-4.774-4.592l-9.015-109.694C191.456 18.878 197.29 0 207.897 0c11.137 0 16.44 18.878 13.789 47.449l-9.016 109.694c-.531 3.061-2.652 4.592-4.773 4.592",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), p3 || (p3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__2",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M252.443 146.429c-1.591-1.531-2.121-4.082-1.061-5.613l51.974-62.755c13.259-16.326 27.578-22.449 35.003-14.796 7.955 7.653 1.591 20.919-15.38 33.674l-65.232 50c-1.061 1.53-3.713 1.02-5.304-.51",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), u3 || (u3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__3",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M247.142 200c0-2.041 2.121-4.082 4.773-4.592l114.024-8.673c29.699-2.551 49.322 3.061 49.322 13.265 0 10.714-19.623 15.816-49.322 13.265l-114.024-8.673c-2.652-.51-4.773-2.551-4.773-4.592",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), g3 || (g3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__4",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M252.443 240.816c1.591-1.53 4.242-2.041 5.833-1.02l65.233 50c16.971 12.755 23.335 26.531 15.38 33.673-7.955 7.653-21.744 1.531-35.003-14.796l-51.974-62.755c-1.591-1.02-1.06-3.571.531-5.102",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), m3 || (m3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__5",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M207.895 238.265c2.122 0 4.243 2.041 4.773 4.592l9.016 109.694c2.652 28.571-3.182 47.449-13.789 47.449-11.137 0-16.44-18.878-13.789-47.449l9.016-109.694c0-3.061 2.122-4.592 4.773-4.592",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), f3 || (f3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__6",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M154.331 240.816c1.591 1.531 2.121 4.082 1.061 5.613l-51.974 62.755C90.159 325.51 75.84 331.633 68.415 323.98c-7.955-7.653-1.59-20.919 15.38-33.674l65.233-50c1.06-1.53 3.712-1.02 5.303.51",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), d3 || (d3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__7",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M168.119 200c0 2.041-2.121 4.082-4.773 4.592l-114.024 8.673C19.622 215.816 0 210.204 0 200c0-10.714 19.623-15.816 49.322-13.265l114.024 8.673c2.652.51 4.773 2.551 4.773 4.592",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })), w3 || (w3 = /* @__PURE__ */ a.createElement("path", {
    id: "SenecaLoader_svg__8",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M154.332 146.429c-1.591 1.53-4.243 2.04-5.834 1.02l-65.232-50c-16.971-12.755-23.336-26.53-15.38-33.673 7.955-7.654 21.744-1.531 35.002 14.795l51.974 62.756c1.591 1.02 1.061 3.571-.53 5.102",
    className: "SenecaLoader_svg__SenecaLoader__spoke",
    clipRule: "evenodd"
  })));
}, _3;
function h5() {
  return h5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h5.apply(this, arguments);
}
var cl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", h5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20"
  }, t), _3 || (_3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M13.75 0c-1.786 0-3.25 1.501-3.25 3.333 0 .355.055.704.156 1.026L5.29 7.419a3.18 3.18 0 0 0-2.039-.752C1.464 6.667 0 8.168 0 10s1.464 3.333 3.25 3.333c.771 0 1.48-.28 2.04-.745l5.374 3.061a3.4 3.4 0 0 0-.164 1.018c0 1.832 1.464 3.333 3.25 3.333S17 18.499 17 16.667s-1.464-3.334-3.25-3.334a3.2 3.2 0 0 0-2.305.994l-5.226-2.98c.178-.413.281-.87.281-1.347 0-.48-.1-.933-.281-1.346l5.219-2.98c.59.613 1.411.993 2.312.993 1.786 0 3.25-1.502 3.25-3.334S15.536 0 13.75 0m0 1.538c.975 0 1.75.795 1.75 1.795s-.775 1.795-1.75 1.795S12 4.334 12 3.333s.775-1.795 1.75-1.795M3.25 8.205C4.225 8.205 5 9 5 10s-.775 1.795-1.75 1.795S1.5 11 1.5 10s.775-1.795 1.75-1.795m10.5 6.667c.975 0 1.75.794 1.75 1.795s-.775 1.795-1.75 1.795S12 17.667 12 16.667s.775-1.795 1.75-1.795"
  })));
}, b3;
function p5() {
  return p5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, p5.apply(this, arguments);
}
var vl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", p5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 21"
  }, t), b3 || (b3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m24.994 9.132-8.75-8.75A.875.875 0 0 0 14.75 1v4.413c-2.837.243-5.97 1.632-8.549 3.819-3.104 2.633-5.036 6.027-5.442 9.556a1.312 1.312 0 0 0 2.262 1.047c1.203-1.28 5.484-5.33 11.729-5.687V18.5a.875.875 0 0 0 1.494.618l8.75-8.75a.875.875 0 0 0 0-1.236M16.5 16.388V13.25a.875.875 0 0 0-.875-.875c-3.071 0-6.063.802-8.891 2.384a21.5 21.5 0 0 0-4 2.901c.634-2.607 2.234-5.087 4.6-7.094 2.539-2.154 5.639-3.441 8.291-3.441a.875.875 0 0 0 .875-.875V3.113l6.638 6.637z"
  })));
}, O3, j3;
function u5() {
  return u5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u5.apply(this, arguments);
}
var hl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", u5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), O3 || (O3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m11.607 5.393-1.348 7.891v.002a.032.032 0 0 1-.038.025.03.03 0 0 1-.015-.008L3.699 6.795a.031.031 0 0 1 .017-.052h.001z",
    opacity: 0.2
  })), j3 || (j3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M4.25 15.672a.797.797 0 1 1-1.593 0 .797.797 0 0 1 1.593 0m1.328-2.922a.797.797 0 1 0 0 1.593.797.797 0 0 0 0-1.593m-4.25 0a.797.797 0 1 0 0 1.593.797.797 0 0 0 0-1.593m2.125-2.125a.797.797 0 1 0 0 1.593.797.797 0 0 0 0-1.593M17 2.656a.53.53 0 0 1-.531.532h-1.905l-1.85 1.85-1.438 8.42a1.063 1.063 0 0 1-1.8.574L2.97 7.525a1.063 1.063 0 0 1 .577-1.8l8.416-1.44 1.85-1.849a1.05 1.05 0 0 1 .752-.311h1.905a.53.53 0 0 1 .531.531m-5.431 2.775-7.85 1.342 6.508 6.508z"
  })));
}, E3, M3;
function g5() {
  return g5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, g5.apply(this, arguments);
}
var pl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", g5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, t), E3 || (E3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 4.5h1.442a4 4 0 0 1 3.254 1.675l2.608 3.65a4 4 0 0 0 3.255 1.675H14.5M13 3l1.5 1.5L13 6"
  })), M3 || (M3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13 10 1.5 1.5L13 13M9.229 6.28l.075-.105A4 4 0 0 1 12.558 4.5H14.5M2 11.5h1.442a4 4 0 0 0 3.254-1.675l.075-.104"
  })));
}, x3;
function m5() {
  return m5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m5.apply(this, arguments);
}
var ul = function(t) {
  return /* @__PURE__ */ a.createElement("svg", m5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 11"
  }, t), x3 || (x3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M20.114.886v6a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.53-1.28l2.445-2.446A8.25 8.25 0 0 0 1.75 10.25a.75.75 0 1 1-1.5 0 9.75 9.75 0 0 1 16.094-7.405l2.49-2.49a.75.75 0 0 1 1.28.53"
  })));
}, C3, $3, L3, k3, S3, y3, H3, P3, z3, V3, B3, W3;
function f5() {
  return f5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, f5.apply(this, arguments);
}
var gl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", f5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), C3 || (C3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
  })), $3 || ($3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
  })), L3 || (L3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.375 7.5-2.5 2.5"
  })), k3 || (k3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m14.375 7.5-2.5 2.5"
  })), S3 || (S3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.375 10-2.5-2.5"
  })), y3 || (y3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m14.375 10-2.5-2.5"
  })), H3 || (H3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.125 7.5-2.5 2.5"
  })), P3 || (P3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m8.125 7.5-2.5 2.5"
  })), z3 || (z3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.125 10-2.5-2.5"
  })), V3 || (V3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m8.125 10-2.5-2.5"
  })), B3 || (B3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10 15a.937.937 0 1 0 0-1.875A.937.937 0 0 0 10 15"
  })), W3 || (W3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.12,
    d: "M10 15a.937.937 0 1 0 0-1.875A.937.937 0 0 0 10 15"
  })));
}, A3, R3;
function d5() {
  return d5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d5.apply(this, arguments);
}
var ml = function(t) {
  return /* @__PURE__ */ a.createElement("svg", d5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, t), A3 || (A3 = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#SmileyXEyesFilled_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15",
    opacity: 0.2
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15Z"
  }), /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m28.75 15-5 5M28.75 20l-5-5M16.25 15l-5 5M16.25 20l-5-5"
  }), /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M20 30a1.875 1.875 0 1 0 0-3.75A1.875 1.875 0 0 0 20 30"
  }))), R3 || (R3 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "SmileyXEyesFilled_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h40v40H0z"
  })))));
}, F3;
function w5() {
  return w5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w5.apply(this, arguments);
}
var fl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", w5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, t), F3 || (F3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5 8v6M8 6v10M11 7v8M14 5v12M17 9v4"
  })));
}, q3;
function _5() {
  return _5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _5.apply(this, arguments);
}
var dl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", _5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), q3 || (q3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.317 11.25a1.24 1.24 0 0 1-.818 1.173l-4.075 1.501L9.924 18a1.25 1.25 0 0 1-2.347 0l-1.501-4.075L2 12.423a1.25 1.25 0 0 1 0-2.346l4.075-1.501L7.577 4.5a1.25 1.25 0 0 1 2.346 0l1.501 4.075 4.075 1.501a1.24 1.24 0 0 1 .818 1.173m-4.442-7.5h1.25V5a.625.625 0 1 0 1.25 0V3.75h1.25a.625.625 0 0 0 0-1.25h-1.25V1.25a.625.625 0 0 0-1.25 0V2.5h-1.25a.625.625 0 1 0 0 1.25m6.875 2.5h-.625v-.625a.625.625 0 0 0-1.25 0v.625h-.625a.625.625 0 1 0 0 1.25h.625v.625a.625.625 0 1 0 1.25 0V7.5h.625a.625.625 0 0 0 0-1.25"
  })));
}, Z3;
function b5() {
  return b5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b5.apply(this, arguments);
}
var wl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", b5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Z3 || (Z3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.1 6.022a5.624 5.624 0 0 1 0 7.955M6.25 13.125H2.5a.625.625 0 0 1-.625-.625v-5a.625.625 0 0 1 .625-.625h3.75L11.875 2.5v15zM6.25 6.875v6.25M14.89 8.232a2.5 2.5 0 0 1 0 3.536"
  })));
}, D3;
function O5() {
  return O5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O5.apply(this, arguments);
}
var _l = function(t) {
  return /* @__PURE__ */ a.createElement("svg", O5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), D3 || (D3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.1 6.023a5.625 5.625 0 0 1 0 7.955M6.25 6.876v6.25M14.891 8.233a2.5 2.5 0 0 1 0 3.536M3.75 3.125l12.5 13.75M11.875 12.063V17.5L6.25 13.126H2.5a.625.625 0 0 1-.625-.625v-5a.625.625 0 0 1 .625-.625h3.75l.533-.415M8.762 4.922l3.113-2.421v5.845"
  })));
}, T3;
function j5() {
  return j5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, j5.apply(this, arguments);
}
var bl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", j5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), T3 || (T3 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m11.527 5.517 1.503-1.502zm0 0a.03.03 0 0 1-.022.01v.5-.5a.03.03 0 0 1-.029-.02.03.03 0 0 1 .007-.034m.044.044-.044-.044m0 0 1.502-1.503a.032.032 0 0 1 .045.045zM3.97 12.985a.032.032 0 0 0 .045.045zm0 0 1.496-1.494a.03.03 0 0 1 .041.002.03.03 0 0 1 .002.041L4.015 13.03zm.045-9.015a.03.03 0 0 0-.045 0l-.326-.326.326.326a.03.03 0 0 0 0 .045l1.496 1.494a.03.03 0 0 0 .041-.002zm0 0 1.494 1.496a.03.03 0 0 1-.002.041zM8.53 2.125V4.25a.031.031 0 1 1-.062 0V2.125a.031.031 0 1 1 .062 0Zm4.219 6.344h2.125a.031.031 0 0 1 0 .062H12.75a.031.031 0 0 1 0-.062Zm-1.236 3.015q.012 0 .02.007l1.496 1.494a.031.031 0 0 1-.045.045l-1.494-1.495a.032.032 0 0 1 .002-.042.03.03 0 0 1 .021-.01Zm-3.036 1.244a.03.03 0 0 1 .022-.01.03.03 0 0 1 .031.032v2.125a.031.031 0 0 1-.062 0V12.75q0-.013.009-.022Zm-4.206-4.25a.031.031 0 0 1-.022.053H2.125a.031.031 0 1 1 0-.062H4.25q.013 0 .022.009Z"
  })));
}, G3, U3, N3, X3, I3, Q3, K3, J3;
function E5() {
  return E5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, E5.apply(this, arguments);
}
var Ol = function(t) {
  return /* @__PURE__ */ a.createElement("svg", E5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), G3 || (G3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 3.75h-5v5h5z"
  })), U3 || (U3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M8.75 3.75h-5v5h5z"
  })), N3 || (N3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 3.75h-5v5h5z"
  })), X3 || (X3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.25 3.75h-5v5h5z"
  })), I3 || (I3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 11.25h-5v5h5z"
  })), Q3 || (Q3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M8.75 11.25h-5v5h5z"
  })), K3 || (K3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 11.25h-5v5h5z"
  })), J3 || (J3 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.25 11.25h-5v5h5z"
  })));
}, Y3, t6;
function M5() {
  return M5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, M5.apply(this, arguments);
}
var jl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", M5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), Y3 || (Y3 = /* @__PURE__ */ a.createElement("g", {
    clipPath: "url(#Star_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "m10 2.625 2.248 4.712.164.343.377.05 5.176.682-3.787 3.595-.275.261.069.374.95 5.133-4.588-2.49-.334-.181-.334.18-4.588 2.491.95-5.133.07-.374-.276-.261-3.787-3.595 5.176-.682.377-.05.164-.343z"
  }))), t6 || (t6 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Star_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}, e6;
function x5() {
  return x5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, x5.apply(this, arguments);
}
var El = function(t) {
  return /* @__PURE__ */ a.createElement("svg", x5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), e6 || (e6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m18.32 8.936-3.523 3.075 1.055 4.578a1.25 1.25 0 0 1-1.862 1.355l-3.993-2.422-3.984 2.422a1.249 1.249 0 0 1-1.863-1.355l1.054-4.573-3.524-3.08a1.25 1.25 0 0 1 .711-2.192l4.646-.403L8.85 2.016a1.246 1.246 0 0 1 2.3 0l1.819 4.325 4.644.403a1.25 1.25 0 0 1 .711 2.192z"
  })));
}, r6;
function C5() {
  return C5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C5.apply(this, arguments);
}
var Ml = function(t) {
  return /* @__PURE__ */ a.createElement("svg", C5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, t), r6 || (r6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M9 .875A8.125 8.125 0 1 0 17.125 9 8.133 8.133 0 0 0 9 .875m0 15A6.875 6.875 0 1 1 15.875 9 6.883 6.883 0 0 1 9 15.875M10.875 6.5h-3.75a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 .625.625h3.75a.624.624 0 0 0 .625-.625v-3.75a.625.625 0 0 0-.625-.625m-.625 3.75h-2.5v-2.5h2.5z"
  })));
}, n6, a6;
function $5() {
  return $5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $5.apply(this, arguments);
}
var xl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", $5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19"
  }, t), n6 || (n6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9 15.688A6.187 6.187 0 1 0 9 3.313a6.187 6.187 0 0 0 0 12.375Z"
  })), a6 || (a6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9 9.5 2.784-2.784M7.313 1.063h3.375"
  })));
}, o6, l6;
function L5() {
  return L5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, L5.apply(this, arguments);
}
var Cl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", L5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), o6 || (o6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M5.875 12.484a1.36 1.36 0 1 1-2.719 0 1.36 1.36 0 0 1 2.719 0Z",
    opacity: 0.2
  })), l6 || (l6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M4.516 10.094a2.391 2.391 0 1 0 0 4.782 2.391 2.391 0 0 0 0-4.782m0 3.719a1.328 1.328 0 1 1 0-2.657 1.328 1.328 0 0 1 0 2.656M2.28 7.062l.953-.953-.953-.952a.532.532 0 1 1 .751-.752l.953.953.952-.953a.532.532 0 1 1 .752.752l-.953.952.953.953a.532.532 0 1 1-.752.751l-.952-.953-.953.953a.532.532 0 1 1-.751-.751m12.439 6.375a.531.531 0 0 1-.752.751l-.952-.953-.952.953a.532.532 0 0 1-.752-.751l.953-.953-.953-.952a.532.532 0 0 1 .752-.752l.952.953.952-.953a.532.532 0 1 1 .752.752l-.953.952zm-3.001-5.944c-.41 1.482-1.681 2.764-3.09 3.116a.54.54 0 0 1-.484-.118.532.532 0 0 1 .223-.913c1.038-.26 2.016-1.255 2.324-2.369.212-.764.214-1.926-.976-3.114l-.153-.156v1.374a.531.531 0 0 1-1.063 0V2.656a.53.53 0 0 1 .532-.531h2.656a.531.531 0 1 1 0 1.063h-1.374l.156.155c1.211 1.212 1.655 2.685 1.249 4.15"
  })));
}, s6, i6;
function k5() {
  return k5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k5.apply(this, arguments);
}
var $l = function(t) {
  return /* @__PURE__ */ a.createElement("svg", k5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), s6 || (s6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.5 5v6.25M4.237 16.875a6.877 6.877 0 0 1 11.526 0M17.5 5 10 7.5 2.5 5 10 2.5z"
  })), i6 || (i6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.23 6.423a4.375 4.375 0 1 1-6.46 0"
  })));
}, c6, v6;
function S5() {
  return S5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, S5.apply(this, arguments);
}
var Ll = function(t) {
  return /* @__PURE__ */ a.createElement("svg", S5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, t), c6 || (c6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m35.6 10-15 5-15-5 15-5z",
    opacity: 0.2
  })), v6 || (v6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m35.995 8.814-15-5a1.25 1.25 0 0 0-.79 0l-15 5A1.25 1.25 0 0 0 4.36 9.87a1 1 0 0 0-.01.131v12.5a1.25 1.25 0 1 0 2.5 0V11.735l5.248 1.748a10 10 0 0 0 3.226 13.758c-2.812 1.103-5.244 3.098-7.022 5.826a1.25 1.25 0 1 0 2.094 1.366C12.752 30.82 16.47 28.75 20.6 28.75s7.848 2.07 10.203 5.683a1.25 1.25 0 0 0 2.094-1.366c-1.778-2.728-4.219-4.723-7.022-5.826a10 10 0 0 0 3.227-13.75l6.893-2.297a1.25 1.25 0 0 0 0-2.372zM28.1 18.75a7.5 7.5 0 1 1-13.539-4.445l5.644 1.875c.256.085.534.085.79 0l5.644-1.875A7.5 7.5 0 0 1 28.1 18.75m-7.5-5.067L9.553 10 20.6 6.317 31.647 10z"
  })));
}, h6, p6;
function y5() {
  return y5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y5.apply(this, arguments);
}
var kl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", y5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), h6 || (h6 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#Sun_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M10 14.688a4.688 4.688 0 1 0 0-9.376 4.688 4.688 0 0 0 0 9.375"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M10 14.688a4.688 4.688 0 1 0 0-9.376 4.688 4.688 0 0 0 0 9.375"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M10 2.813V1.25"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M10 2.813V1.25"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M4.914 4.914 3.813 3.813"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M4.914 4.914 3.813 3.813"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M2.813 10H1.25"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M2.813 10H1.25"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m4.914 15.086-1.101 1.101"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "m4.914 15.086-1.101 1.101"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M10 17.188v1.562"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M10 17.188v1.562"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m15.086 15.086 1.101 1.101"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "m15.086 15.086 1.101 1.101"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M17.188 10h1.562"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "M17.188 10h1.562"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "m15.086 4.914 1.101-1.101"
  }), /* @__PURE__ */ a.createElement("path", {
    strokeOpacity: 0.12,
    d: "m15.086 4.914 1.101-1.101"
  }))), p6 || (p6 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "Sun_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
}, u6, g6, m6, f6, d6, w6, _6, b6, O6, j6, E6, M6, x6, C6;
function H5() {
  return H5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, H5.apply(this, arguments);
}
var Sl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", H5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), u6 || (u6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.25 4.61-.598-1.444"
  })), g6 || (g6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m7.25 4.61-.598-1.444"
  })), m6 || (m6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.36 8.5 1.916 7.9"
  })), f6 || (f6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M3.36 8.5 1.916 7.9"
  })), d6 || (d6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.64 8.5 1.444-.599"
  })), w6 || (w6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m16.64 8.5 1.444-.599"
  })), _6 || (_6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12.75 4.61.598-1.444"
  })), b6 || (b6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "m12.75 4.61.598-1.444"
  })), O6 || (O6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.75 12.5H1.25"
  })), j6 || (j6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M18.75 12.5H1.25"
  })), E6 || (E6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 15.625H3.75"
  })), M6 || (M6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M16.25 15.625H3.75"
  })), x6 || (x6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.481 12.5a4.688 4.688 0 1 1 9.038 0"
  })), C6 || (C6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.12,
    strokeWidth: 1.5,
    d: "M5.481 12.5a4.688 4.688 0 1 1 9.038 0"
  })));
}, $6;
function P5() {
  return P5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, P5.apply(this, arguments);
}
var yl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", P5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, t), $6 || ($6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M11.31 12.448h-1.278l1.07 1.07a.828.828 0 0 1-1.17 1.17l-2.483-2.482a.827.827 0 0 1 0-1.17l2.483-2.483a.828.828 0 0 1 1.17 1.17l-1.07 1.07h1.278a3.035 3.035 0 0 0 0-6.069.828.828 0 1 1 0-1.655A4.695 4.695 0 0 1 16 7.759a4.695 4.695 0 0 1-4.69 4.69M6.102 6.964a.828.828 0 0 1-1.17-1.17l1.07-1.07H4.69a3.034 3.034 0 0 0 0 6.07.828.828 0 0 1 0 1.654A4.695 4.695 0 0 1 0 7.758a4.695 4.695 0 0 1 4.69-4.69h1.312L4.932 2a.828.828 0 0 1 1.17-1.17L8.585 3.31a.83.83 0 0 1 0 1.17z"
  })));
}, L6, k6;
function z5() {
  return z5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z5.apply(this, arguments);
}
var Hl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", z5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), L6 || (L6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10 10 7.5-7.5M15.303 4.697a7.493 7.493 0 1 0 1.466 2.07"
  })), k6 || (k6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.652 7.348a3.75 3.75 0 1 0 1.092 2.438"
  })));
}, S6, y6;
function V5() {
  return V5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V5.apply(this, arguments);
}
var Pl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", V5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), S6 || (S6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M9.594 5.281v8.032H2.656a.03.03 0 0 1-.022-.01l-.351.352.351-.352a.03.03 0 0 1-.009-.022V5.312a.03.03 0 0 1 .031-.03z",
    opacity: 0.2
  })), y6 || (y6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M14.344 4.25H9.782l2.281-2.28a.532.532 0 0 0-.751-.752L8.5 4.03 5.688 1.218a.532.532 0 0 0-.751.752l2.28 2.28h-4.56a1.06 1.06 0 0 0-1.063 1.063v7.968a1.063 1.063 0 0 0 1.062 1.063h11.688a1.063 1.063 0 0 0 1.062-1.063V5.313a1.063 1.063 0 0 0-1.062-1.063M2.656 5.313h6.906v7.968H2.657zm11.688 7.968h-3.719V5.313h3.719zM13.28 7.703a.797.797 0 1 1-1.594 0 .797.797 0 0 1 1.594 0m0 3.188a.797.797 0 1 1-1.594 0 .797.797 0 0 1 1.594 0"
  })));
}, H6;
function B5() {
  return B5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, B5.apply(this, arguments);
}
var zl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", B5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, t), H6 || (H6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M16.453 5.633a1.69 1.69 0 0 0-1.265-.57H11.25V3.938a2.81 2.81 0 0 0-2.812-2.813.56.56 0 0 0-.504.31L5.278 6.75H2.25a1.125 1.125 0 0 0-1.125 1.125v6.188a1.125 1.125 0 0 0 1.125 1.124h12.094a1.69 1.69 0 0 0 1.675-1.476l.843-6.75a1.69 1.69 0 0 0-.409-1.328M2.25 7.875h2.813v6.188H2.25zM15.746 6.82l-.844 6.75a.56.56 0 0 1-.558.492H6.188V7.446l2.58-5.163a1.69 1.69 0 0 1 1.357 1.656v1.687a.563.563 0 0 0 .563.563h4.5a.563.563 0 0 1 .558.632"
  })));
}, P6;
function W5() {
  return W5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, W5.apply(this, arguments);
}
var Vl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", W5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, t), P6 || (P6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M15.453 4.633a1.69 1.69 0 0 0-1.265-.57H10.25V2.938A2.813 2.813 0 0 0 7.438.124a.56.56 0 0 0-.504.31L4.278 5.75H1.25A1.125 1.125 0 0 0 .125 6.875v6.188a1.125 1.125 0 0 0 1.125 1.124h12.094a1.69 1.69 0 0 0 1.675-1.476l.843-6.75a1.69 1.69 0 0 0-.409-1.328M1.25 6.875h2.813v6.188H1.25z"
  })));
}, z6;
function A5() {
  return A5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A5.apply(this, arguments);
}
var Bl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", A5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, t), z6 || (z6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.506 1.483 6.624 15.016.492 8.574l1.014-.966 5.118 5.377L18.492.518z",
    clipRule: "evenodd"
  })));
}, V6, B6;
function R5() {
  return R5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R5.apply(this, arguments);
}
var Wl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", R5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), V6 || (V6 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#TickCircle_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M13.438 8.125 8.852 12.5l-2.29-2.187"
  }), /* @__PURE__ */ a.createElement("path", {
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  }))), B6 || (B6 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "TickCircle_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
}, W6;
function F5() {
  return F5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, F5.apply(this, arguments);
}
var Al = function(t) {
  return /* @__PURE__ */ a.createElement("svg", F5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, t), W6 || (W6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m4.28 8.03-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06"
  })));
}, A6;
function q5() {
  return q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, q5.apply(this, arguments);
}
var Rl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", q5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), A6 || (A6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M2.07 13.282a8.53 8.53 0 0 1 0-6.568A8.5 8.5 0 0 1 5.734 2.55v3.54h1.416V.709h-5.38v1.415h2.065C.39 4.822-.994 9.588.76 13.824a10 10 0 0 0 3.126 4.089 10.06 10.06 0 0 0 4.586 1.967l.217-1.4a8.53 8.53 0 0 1-6.62-5.198M19.234 13.825a9.93 9.93 0 0 0 0-7.652 10 10 0 0 0-3.126-4.089A10.06 10.06 0 0 0 11.522.117l-.217 1.4a8.53 8.53 0 0 1 6.62 5.198 8.53 8.53 0 0 1 0 6.568 8.5 8.5 0 0 1-3.665 4.165v-3.54h-1.416v5.38h5.38v-1.416h-2.059a9.94 9.94 0 0 0 3.069-4.047"
  })));
}, R6, F6;
function Z5() {
  return Z5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z5.apply(this, arguments);
}
var Fl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Z5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), R6 || (R6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "m11.688 8.024 1.847 3.695H9.84zm-4.73-1.906a5.9 5.9 0 0 1-1.114 1.658A5.86 5.86 0 0 1 4.24 4.22h3.208a5.9 5.9 0 0 1-.49 1.899Z",
    opacity: 0.2
  })), F6 || (F6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "m15.881 14.106-3.719-7.437a.53.53 0 0 0-.95 0L9.77 9.553a5.84 5.84 0 0 1-3.13-1.124A6.88 6.88 0 0 0 8.48 4.25h1.614a.531.531 0 0 0 0-1.062H6.375V2.125a.531.531 0 1 0-1.062 0v1.063h-3.72a.531.531 0 1 0 0 1.062h5.82a5.82 5.82 0 0 1-1.57 3.476 5.8 5.8 0 0 1-1.261-2.058.531.531 0 1 0-1.001.354 6.9 6.9 0 0 0 1.466 2.412 5.8 5.8 0 0 1-3.453 1.129.531.531 0 1 0 0 1.062 6.87 6.87 0 0 0 4.25-1.466 6.9 6.9 0 0 0 3.416 1.415l-1.767 3.532a.531.531 0 0 0 .95.476l.916-1.832h4.656l.916 1.832a.53.53 0 1 0 .95-.476m-5.99-2.418 1.797-3.594 1.796 3.594z"
  })));
}, q6;
function D5() {
  return D5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D5.apply(this, arguments);
}
var ql = function(t) {
  return /* @__PURE__ */ a.createElement("svg", D5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 22"
  }, t), q6 || (q6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.75 5.625V21H2.253h12.498zm-11.25 0v14.127zm9.803-.044v13.972H3.701V5.58zm-12.502 0h1.252V21.2h12.898V5.58h1.25V3.933h-4.376V.801H5.176v3.132H.801zm10.824-1.449V1.001zM1.001 5.38H16V4.133v1.248zM11.205 8.3H9.553v9.153h1.651zm-3.75 0H5.802v9.153h1.651zm-.631-4.367V2.448h3.354v1.485zm-.2.2V2.247h3.753-3.753zm4.38 4.368v8.751h-1.25 1.25zm-3.75 8.752V8.5v8.751h-1.25z",
    clipRule: "evenodd"
  })));
}, Z6, D6;
function T5() {
  return T5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, T5.apply(this, arguments);
}
var Zl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", T5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, t), Z6 || (Z6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M4.275 5.094a3.75 3.75 0 0 0 .683 7.058l-.116.487.116-.487a3.75 3.75 0 0 0 2.962-.532 1.03 1.03 0 0 1 1.156 0 3.751 3.751 0 0 0 5.83-3.13zm0 0 .004-.002m-.004.002.004-.002m0 0c.232-.108.416-.3.515-.536a4.016 4.016 0 0 1 7.408 0c.099.236.282.428.515.536m-8.438 0h8.438m0 0 .003.002m-.003-.002.003.002m0 0a3.75 3.75 0 0 1 1.59 1.378m-1.59-1.378 1.59 1.378m0 0a3.75 3.75 0 0 1 .596 2.017z",
    opacity: 0.2
  })), D6 || (D6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M13.155 4.157a5.047 5.047 0 0 0-9.31 0 4.8 4.8 0 0 0-2.782 4.33c-.008 2.578 2.082 4.728 4.657 4.794a4.76 4.76 0 0 0 2.249-.498v2.623a.531.531 0 1 0 1.062 0v-2.623c.66.329 1.388.5 2.125.498h.124c2.575-.066 4.665-2.215 4.658-4.793a4.8 4.8 0 0 0-2.783-4.331m-1.902 8.062a3.7 3.7 0 0 1-2.16-.624l-.062-.038V8.828l2.894-1.446a.531.531 0 0 0-.475-.951L9.03 7.64V5.844a.531.531 0 0 0-1.062 0v3.39L5.55 8.024a.532.532 0 0 0-.475.951l2.894 1.447v1.133l-.061.037a3.718 3.718 0 1 1-3.621-6.47c.24-.11.432-.308.534-.553a3.984 3.984 0 0 1 7.351 0c.103.245.293.443.535.554a3.718 3.718 0 0 1-1.461 7.096z"
  })));
}, T6, G6;
function G5() {
  return G5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G5.apply(this, arguments);
}
var Dl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", G5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, t), T6 || (T6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m36.25 9.25-15 15L15 18 3.75 29.25"
  })), G6 || (G6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36.25 19.25v-10h-10"
  })));
}, U6;
function U5() {
  return U5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, U5.apply(this, arguments);
}
var Tl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", U5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 19"
  }, t), U6 || (U6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M21.75 2.8H19.5v-.75A1.5 1.5 0 0 0 18 .55H6a1.5 1.5 0 0 0-1.5 1.5v.75H2.25a1.5 1.5 0 0 0-1.5 1.5v1.5A3.75 3.75 0 0 0 4.5 9.55h.342a7.51 7.51 0 0 0 6.408 5.214v2.287H9a.75.75 0 1 0 0 1.5h6a.75.75 0 1 0 0-1.5h-2.25v-2.29c2.994-.302 5.479-2.403 6.383-5.21h.367a3.75 3.75 0 0 0 3.75-3.75V4.3a1.5 1.5 0 0 0-1.5-1.5M4.5 8.05A2.25 2.25 0 0 1 2.25 5.8V4.3H4.5v3q0 .375.037.75zM18 7.217c0 3.33-2.67 6.06-5.954 6.085H12a6 6 0 0 1-6-6V2.05h12zm3.75-1.415a2.25 2.25 0 0 1-2.25 2.25h-.047q.046-.416.047-.835V4.301h2.25z"
  })));
}, N6, X6;
function N5() {
  return N5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, N5.apply(this, arguments);
}
var Gl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", N5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), N6 || (N6 = /* @__PURE__ */ a.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 8.125v3.125M8.918 3.124 2.045 14.998a1.25 1.25 0 0 0 1.082 1.876h13.746a1.25 1.25 0 0 0 1.082-1.876L11.082 3.124a1.25 1.25 0 0 0-2.164 0"
  })), X6 || (X6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M10 15a.937.937 0 1 0 0-1.875A.937.937 0 0 0 10 15"
  })));
}, I6, Q6, K6, J6;
function X5() {
  return X5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X5.apply(this, arguments);
}
var Ul = function(t) {
  return /* @__PURE__ */ a.createElement("svg", X5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), I6 || (I6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.6 10a8.6 8.6 0 0 1-13.42 7.123l-1.692.466A9.96 9.96 0 0 0 10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10a9.96 9.96 0 0 0 2.347 6.437l.403-1.81A8.6 8.6 0 1 1 18.6 10",
    clipRule: "evenodd"
  })), Q6 || (Q6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.32 14.83 1.36.34-.711 2.84 2.847-.776.368 1.35L.031 19.99z",
    clipRule: "evenodd"
  })), K6 || (K6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M6.914 4.857h-.486c-.143 0-1.143.714-1.286 2.429S7 11 7.571 11.57s3 2.858 5 2.572c1.528-.219 2.136-1.063 2.27-1.511a.4.4 0 0 0 .016-.123v-.432a.57.57 0 0 0-.328-.517l-1.714-.807a.57.57 0 0 0-.67.138l-.656.737a.49.49 0 0 1-.502.158c-.433-.132-1.133-.449-1.845-1.072A7 7 0 0 1 7.711 8.99a.51.51 0 0 1 .032-.533l.51-.767a.57.57 0 0 0 .047-.549l-.864-1.945a.57.57 0 0 0-.522-.339"
  })), J6 || (J6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.9 5.513c-.27.372-.546.954-.615 1.785-.067.803.37 1.696.92 2.477.546.775 1.181 1.41 1.467 1.695.283.283 1.025.99 1.941 1.589.924.604 1.992 1.078 2.938.942 1.479-.21 2.036-1.02 2.153-1.41a.3.3 0 0 0 .01-.082v-.432a.43.43 0 0 0-.246-.388l-1.714-.806a.43.43 0 0 0-.503.103l-.655.737a.63.63 0 0 1-.65.2c-.451-.138-1.17-.464-1.898-1.101A7 7 0 0 1 7.586 9.06a.65.65 0 0 1 .038-.683l.51-.766a.43.43 0 0 0 .036-.412l-.865-1.944A.43.43 0 0 0 6.914 5H6.44l-.033.016a1 1 0 0 0-.13.09 2.2 2.2 0 0 0-.376.407m.442-.781a.3.3 0 0 1 .086-.018h.486c.282 0 .538.167.653.424l.864 1.945c.1.224.077.483-.059.686l-.51.767a.37.37 0 0 0-.027.384c.23.407.693 1.067 1.401 1.687.696.608 1.378.916 1.793 1.043.12.036.256-.008.353-.117l.655-.737a.714.714 0 0 1 .838-.172l1.714.807c.25.117.41.37.41.646v.432a.6.6 0 0 1-.021.164c-.152.507-.809 1.386-2.387 1.611-1.055.151-2.2-.375-3.134-.986a13 13 0 0 1-1.987-1.626h-.001c-.287-.287-.936-.937-1.497-1.733C5.415 9.15 4.924 8.184 5 7.274c.074-.884.369-1.516.67-1.93.15-.206.3-.358.427-.46q.095-.075.171-.118a1 1 0 0 1 .074-.034",
    clipRule: "evenodd"
  })));
}, Y6, t7;
function I5() {
  return I5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, I5.apply(this, arguments);
}
var Nl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", I5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t), Y6 || (Y6 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M30 10v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1",
    opacity: 0.2
  })), t7 || (t7 = /* @__PURE__ */ a.createElement("path", {
    fill: "currentColor",
    d: "M14 5a1 1 0 0 0-1 1v2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1M3 22V10h10v12zm28-12v12a2 2 0 0 1-2 2H18a1 1 0 0 1 0-2h11V10H18a1 1 0 1 1 0-2h11a2 2 0 0 1 2 2m-20 4a1 1 0 0 1-1 1H9v3a1 1 0 1 1-2 0v-3H6a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1"
  })));
}, e7, r7;
function Q5() {
  return Q5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Q5.apply(this, arguments);
}
var Xl = function(t) {
  return /* @__PURE__ */ a.createElement("svg", Q5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, t), e7 || (e7 = /* @__PURE__ */ a.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#XCircle_svg__a)"
  }, /* @__PURE__ */ a.createElement("path", {
    d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M12.5 7.5l-5 5M12.5 12.5l-5-5"
  }))), r7 || (r7 = /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", {
    id: "XCircle_svg__a"
  }, /* @__PURE__ */ a.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
const a8 = {
  alarm: o(n7),
  archive: o(a7),
  arrowDown: o(o7),
  arrowElbowDownLeft: o(l7),
  arrowFatRight: o(s7),
  arrowFatUp: o(i7),
  arrowLeft: o(c7),
  arrowRight: o(v7),
  arrowsSplit: o(h7),
  atom: o(p7),
  baby: o(u7),
  barbell: o(g7),
  bed: o(m7),
  bell: o(f7),
  bird: o(d7),
  bone: o(w7),
  book: o(_7),
  bookDuo: o(b7),
  bookOpenText: o(O7),
  bookOpenTextDuo: o(j7),
  bookmarksSimple: o(E7),
  books: o(M7),
  booksFilled: o(x7),
  brain: o(C7),
  briefCase: o($7),
  buildings: o(L7),
  calculator: o(k7),
  calendarBlank: o(S7),
  calendarChecked: o(y7),
  caretDoubleDown: o(H7),
  caretDoubleUp: o(P7),
  caretRight: o(z7),
  chalkStick: o(V7),
  chalkStickDocument: o(B7),
  chalkboardTeacher: o(W7),
  chart: o(A7),
  chartLineUp: o(R7),
  chat: o(F7),
  chatCircleText: o(q7),
  chatsCircle: o(Z7),
  checkSquare: o(D7),
  chevronDown: o(T7),
  chevronLeft: o(G7),
  chevronRight: o(U7),
  chevronUp: o(N7),
  church: o(X7),
  circleDashed: o(I7),
  circleWavyCheck: o(Q7),
  circlesThree: o(K7),
  circuitry: o(J7),
  classes: o(Y7),
  clock: o(to),
  coding: o(eo),
  cog: o(ro),
  copy: o(no),
  cpu: o(ao),
  cross: o(oo),
  desktop: o(lo),
  dna: o(so),
  dotsHorizontal: o(io),
  dotsVertical: o(co),
  downloadFile: o(vo),
  edit: o(ho),
  envelope: o(po),
  examQuestion: o(uo),
  exclamationCircle: o(go),
  export: o(mo),
  eye: o(fo),
  eyeSlashed: o(wo),
  fileAudio: o(_o),
  fileAudioPause: o(bo),
  fileAudioPlay: o(Oo),
  filePdf: o(jo),
  fileX: o(Eo),
  files: o(Mo),
  filmReel: o(xo),
  filters: o(Co),
  flag: o($o),
  flask: o(Lo),
  forkKnife: o(ko),
  gauge: o(So),
  gavel: o(yo),
  gearFine: o(Ho),
  globe: o(Po),
  globeHemisphereWest: o(zo),
  goStudentLoader: o(Vo),
  google: o(Bo),
  googleMulticolor: o(Wo),
  graduationCap: o(Ao),
  grains: o(Ro),
  group: o(Fo),
  hamburgerMenu: o(qo),
  hammer: o(Zo),
  handHeart: o(Do),
  heart: o(To),
  help: o(Go),
  house: o(Uo),
  identificationCard: o(No),
  image: o(Xo),
  imageMulti: o(Io),
  infinity: o(Qo),
  infinityFilled: o(Ko),
  info: o(Jo),
  keyReturn: o(Yo),
  laurelStar: o(t4),
  leave: o(e4),
  lifebuoy: o(r4),
  lightBulb: o(n4),
  lightBulbBigFilled: o(a4),
  lightning: o(o4),
  lightningOutline: o(l4),
  link: o(s4),
  listMagnifyingGlass: o(i4),
  lock: o(c4),
  lockOpen: o(v4),
  magicWand: o(h4),
  magnet: o(p4),
  mapPin: o(u4),
  maskHappy: o(g4),
  mathOperations: o(m4),
  medal: o(f4),
  megaphone: o(d4),
  microphone: o(w4),
  microphoneOutlined: o(_4),
  microphoneSlash: o(b4),
  microsoft: o(O4),
  microsoftMulticolor: o(j4),
  minus: o(E4),
  money: o(M4),
  moon: o(x4),
  moonStars: o(C4),
  more: o($4),
  mountains: o(L4),
  muscle: o(k4),
  musicNotes: o(S4),
  nonCalculator: o(y4),
  notePencil: o(H4),
  palette: o(P4),
  pause: o(z4),
  peoplePair: o(V4),
  person: o(B4),
  personsArmsSpread: o(W4),
  pin: o(A4),
  planet: o(R4),
  plant: o(F4),
  play: o(q4),
  playCircleFilled: o(Z4),
  plus: o(D4),
  plusCircle: o(T4),
  questionBadge: o(G4),
  questionBadgeOutlined: o(U4),
  readMore: o(N4),
  reassign: o(X4),
  report: o(I4),
  robot: o(Q4),
  robotDuo: o(K4),
  rocket: o(J4),
  rocketLaunch: o(Y4),
  rows: o(tl),
  ruler: o(el),
  scales: o(rl),
  school: o(nl),
  scroll: o(al),
  search: o(ol),
  send: o(ll),
  seneca: o(sl),
  senecaLoader: o(il),
  share: o(cl),
  shareFat: o(vl),
  shower: o(hl),
  shuffle: o(pl),
  skip: o(ul),
  smileyXEyes: o(gl),
  smileyXEyesFilled: o(ml),
  soundWave: o(fl),
  sparkle: o(dl),
  speakerHigh: o(wl),
  speakerSlash: o(_l),
  spinner: o(bl),
  squares: o(Ol),
  star: o(jl),
  starFilled: o(El),
  stopCircle: o(Ml),
  stopwatch: o(xl),
  strategy: o(Cl),
  student: o($l),
  studentDuo: o(Ll),
  sun: o(kl),
  sunHorizon: o(Sl),
  synced: o(yl),
  target: o(Hl),
  television: o(Pl),
  thumbsUp: o(zl),
  thumbsUpFilled: o(Vl),
  tick: o(Bl),
  tickCircle: o(Wl),
  tickCircleFilled: o(Al),
  transfer: o(Rl),
  translate: o(Fl),
  trash: o(ql),
  tree: o(Zl),
  trend: o(Dl),
  trophy: o(Tl),
  warning: o(Gl),
  whatsApp: o(Ul),
  wordFill: o(Nl),
  xCircle: o(Xl)
};
export {
  a8 as iconNameMap
};
